// import React, { Component } from "react";
// import { withRouter } from "react-router-dom";
// import { Form } from "react-form";
// import { connect } from "react-redux";

// import Grid from "@material-ui/core/Grid";
// import Typography from "@material-ui/core/Typography";
// import Tooltip from "@material-ui/core/Tooltip";
// import Table from "@material-ui/core/Table";
// import TableBody from "@material-ui/core/TableBody";
// import TableRow from "@material-ui/core/TableRow";

// import IconButton from "@material-ui/core/IconButton";
// import Stepper from "@material-ui/core/Stepper";
// import Step from "@material-ui/core/Step";
// import StepButton from "@material-ui/core/StepLabel";
// import Dialog from "@material-ui/core/Dialog";
// import Divider from "@material-ui/core/Divider";
// import DialogContent from "@material-ui/core/DialogContent";
// import DialogContentText from "@material-ui/core/DialogContentText";
// import Accordion from "@material-ui/core/Accordion";
// import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
// import AccordionDetails from "@material-ui/core/AccordionDetails";
// import AccordionSummary from "@material-ui/core/AccordionSummary";
// import Toolbar from "@material-ui/core/Toolbar";
// import { withStyles } from "@material-ui/core";
// import AddIcon from "@material-ui/icons/Add";
// import EditIcon from "@material-ui/icons/Edit";
// import ViewIcon from "@material-ui/icons/Visibility";
// import Close from "@material-ui/icons/Close";
// import DeleteIcon from "@material-ui/icons/Delete"; 
// import MobileStepper from "@material-ui/core/MobileStepper";
// import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
// import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
// import useMediaQuery from "@material-ui/core/useMediaQuery";
// // import { InputLabel } from '@material-ui/core';

// import Button from "@material-ui/core/Button";
// import Paper from "@material-ui/core/Paper";
// import AppContainerApplication from "../../common/AppContainerApplication";
// import TextField from "../../common/TextField";
// import RadioGroup from "../../common/RadioGroup";
// import Select from "../../common/Select";
// import CheckboxGroup from "../../common/CheckboxGroup";
// import ReactSelect from "../../common/ReactSelect"; 
// import FileInput from "../../common/FileInput";
// import Checkbox from "../../common/Checkbox"; 
// import HelpLabel from "../../common/HelpLabel"; 
// import states from "../../common/states.json";
// import EnhancedTableHead from "../../common/EnhancedTableHead";
// import CustomTableCell from "../../common/TableCell";
// import { ApplicationRecord, ApplicationRecordStatus, BRRWDPermit, BRRWDCulvert, BRRWDAttachment } from "../../page/models";

// const styles = (theme) => ({
//     deleteWidth: {
//         minWidth: 34,
//         width: 34,
//         marginRight: 8,
//         marginTop: 2,
//         marginBottom: 2,
//     },
//     centerAlign: {
//         textAlign: "center",
//     },
//     centerAlign2: {
//         textAlign: "center",
//         display: "inline-block",
//         width: "100%",
//     },
//     nowrap: {
//         whiteSpace: "nowrap",
//     },
//     rightAlign: {
//         textAlign: "right",
//         marginRight: 15,
//     },
//     flex: {
//         flex: 1,
//     },
//     printDivider: {
//         height: 8,
//         backgroundColor: "rgba(0, 0, 0, 0.42)",
//         marginTop: 16,
//         marginBottom: 8,
//     },
//     dialogMin: {
//         minWidth: 330,
//     },
//     minWidth: {
//         minWidth: 380,
//     },
//     root: {
//         flexBasis: "100%",
//         maxWidth: "100%",
//     },
//     heading2: {
//         fontSize: theme.typography.pxToRem(17),
//         fontWeight: theme.typography.fontWeightRegular,
//         display: "flex",
//     },
//     titlePanel: {
//         minHeight: "auto !important",
//     },
//     expandedMargin: {
//         marginTop: "12px",
//     },
//     disabledField: {
//         backgroundColor: '#f5f5f5',
//         color: 'rgba(0, 0, 0, 0.65)',
//         '& .MuiOutlinedInput-root.Mui-disabled': {
//             backgroundColor: '#f5f5f5',
//             color: 'rgba(0, 0, 0, 0.65)',
//         },
//         '& .MuiOutlinedInput-notchedOutline': {
//             borderColor: 'rgba(0, 0, 0, 0.23) !important',
//         },
//     },
// });

// function MAKE_OPTIONS(table) {
//     return table.map((row) => ({
//         label: row,
//         value: row,
//     }));
// }



// class BRRWD extends Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             activeStep: 0,
//             culvertDialogOpen: false,
//             culvertEditing: null,
//             formKey: null,
//             order: "desc",
//             orderBy: null,
//             temp_contacts: [],
//             attachmentDialogOpen: false,
//             attachmentEditing: null,
//             attachmentFormKey: null,
//             attachmentOrder: "desc",
//             attachmentOrderBy: null,
//             temp_attachments: [],
//             loading: false,
//             new_save: false,
//             new_save2: false,
//             mainFormKey: window.performance.now(),
//             entryError: false, 
//             projectType: [],
//             selectLegal: false,
//             tempCulverts: [],
//             culvertFormKey:null,
//             application:null

//         };
// }

//     componentDidMount() {
//         const { match, ormBRRWDPermitLoadDetailChild, ormBRRWDAttachmentLoadDetailChild, ormBRRWDCulvertLoadDetailChild } = this.props;
//         var component = this;


//         if (match.params && match.params.hash) {
//             ormBRRWDPermitLoadDetailChild(match.params.hash, function (wtf) {
//                 component.setState({ mainFormKey: window.performance.now(), projectType:wtf[0].project_types, application:wtf[0] });
//             });
//             ormBRRWDCulvertLoadDetailChild(match.params.hash, function (data) {
//                 component.setState({ tempCulverts: data });
//             });
//             ormBRRWDAttachmentLoadDetailChild(match.params.hash, function (data) {
//                 component.setState({ temp_attachments: data });
//             });
//         }
//         // if (match.params && match.params.print) {
//         //     component.setState({ activeStep: "PRINT" });
//         // }
//     }

//     errorValidator = (values) => {
//         const isRequired = (val) => {
//             return !val ? "Required" : null;
//         }; 

//         var valObj = {
//             appl_first_name: isRequired(values.appl_first_name),
//             appl_last_name: isRequired(values.appl_last_name),
//             appl_phone: isRequired(values.appl_phone),
//             project_types: isRequired(values.project_types),
//             county: isRequired(values.county),
//             project_description: isRequired(values.project_description),
//             project_township: isRequired(values.project_township),
//             section: isRequired(values.section),
//             understand1: isRequired(values.understand1), 
//         };

//         var alerts = "";
//         var ai = 6;
//         if (valObj["appl_first_name"] === "Required") {
//             alerts += "Applicant First Name (Step 2)\n";
//             ai = 1;
//         }
//         if (valObj["appl_last_name"] === "Required") {
//             alerts += "Applicant Last Name (Step 2)\n";
//             ai = 1;
//         }
//         if (valObj["appl_phone"] === "Required") {
//             alerts += "Applicant Phone  (Step 2)\n";
//             ai = 1;
//         }


//         if (valObj["project_types"] === "Required") {
//             alerts += "Project types (Step 3)\n";
//             ai = 2;
//         }
//         if (valObj["county"] === "Required") {
//             alerts += "County (Step 3)\n";
//             ai = 2;
//         }
//         if (valObj["project_township"] === "Required") {
//             alerts += "Township/City Name (Step 3)\n";
//             ai = 2;
//         }
//         if (valObj["section"] === "Required") {
//             alerts += "Section (Step 3)\n";
//             ai = 2;
//         }
//         if (valObj["project_description"] === "Required") {
//             alerts += "Project description (Step 3)\n";
//             ai = 2;
//         }

//         if (valObj["understand1"] === "Required") {
//             alerts += "Understand Agreement (Step 6)\n";
//             ai = 5;
//         }
//         if (alerts) {
//             alert("The following fields are missing or invalid:\n" + alerts);
//             this.setState({ activeStep: ai });
//         }

//         return valObj;
//     };

//     errorValidatorAttachment = (values) => {
//         const isRequired = (val) => {
//             return !val ? "Required" : null;
//         };
//         var valObj = {
//             file: isRequired(values.file),
//             name: isRequired(values.name),
//         };

//         return valObj;
//     };

//     submitApplication = (values) => {
//         const { 
//             ormApplicationRecordCreate,
//             ormApplicationRecordStatusCreate,
//             ormBRRWDPermitCreate,
//             ormBRRWDCulvertCreate,
//             ormBRRWDAttachmentCreate,
//             ormBRRWDPermitUpdatePublic 
//         } = this.props;
//         const { tempCulverts, temp_attachments, application } = this.state;

//         const _this = this;
//         this.setState({ loading: true });

//         // Editing
//         if (application) {

//         } else {
//             // New
//             let totalAttachments = tempCulverts.length + temp_attachments.length 
//             let hasntSaved = false
//             let created = 0
//             ormApplicationRecordCreate({
//                 application: 10,
//             }).then((ar) => {
//                 ormApplicationRecordStatusCreate({ //dummy status so backend can determine when to send email after attachments below
//                     applicationrecord: ar.id,
//                     status: "Initial", 
//                 });
//                 ormBRRWDPermitCreate({
//                     applicationrecord: ar.id,
//                     ...values,
//                 }).then((rpb) => {
//                     if (rpb && rpb.error) {
//                         this.setState({ entryError: true, loading: false });
//                         fetch("/error/post", {
//                             method: "POST",
//                             headers: {
//                                 "Content-Type": "application/json",
//                             },
//                             body: JSON.stringify({
//                                 error: JSON.stringify(values),
//                                 error_info: rpb.error.toString(),
//                             }),
//                         });
//                     } else { 

//                         tempCulverts.forEach(function (tc) { 
//                             ormBRRWDCulvertCreate({
//                                 brrwdpermit_id: rpb.id,
//                                 ...tc,
//                             }).then((_z) => { 
//                                 created++;
//                                 if(created === totalAttachments && !hasntSaved){ //so we want to save all the attachments first as we need to send them into the saved received email

//                                      ormApplicationRecordStatusCreate({
//                                         applicationrecord: ar.id,
//                                         status: "Received"
//                                     }).then(statusrecord => {
//                                         setTimeout(()=>{
//                                             ormBRRWDPermitUpdatePublic({
//                                             id: rpb.id,
//                                             ...values
//                                         })
//                                         },1500)
//                                         _this.setState({ loading: false, new_save: true });
//                                         hasntSaved = true
//                                     })
//                                 }
//                             });
//                         });
//                         temp_attachments.forEach(function (tc) { 
//                             ormBRRWDAttachmentCreate({
//                                 brrwdpermit_id: rpb.id,
//                                 ...tc,
//                             }).then((_z) => {
//                                 created++;
//                                 if(created === totalAttachments && !hasntSaved){ //so we want to save all the attachments first as we need to send them into the saved received email

//                                     ormApplicationRecordStatusCreate({
//                                        applicationrecord: ar.id,
//                                        status: "Received"
//                                    }).then(statusrecord => {
//                                         setTimeout(()=>{
//                                             ormBRRWDPermitUpdatePublic({
//                                             id: rpb.id,
//                                             ...values
//                                         })
//                                         },1500) 
//                                        _this.setState({ loading: false, new_save: true });
//                                        hasntSaved = true
//                                    })
//                                }

//                             });
//                         });
//                         if (totalAttachments === 0) {
//                             ormApplicationRecordStatusCreate({
//                                 applicationrecord: ar.id,
//                                 status: "Received"
//                             })
//                             setTimeout(()=>{//trigger for the email to be sent
//                                 ormBRRWDPermitUpdatePublic({
//                                 id: rpb.id
//                             })
//                             },1500) 
//                             // No attachments or culverts - its finished loading
//                             _this.setState({ loading: false, new_save: true });
//                         }
//                     }
//                 });
//             });
//         }
//     };
//     addCulvert = (values) => {
//         var { culvertEditing, tempCulverts } = this.state;

//         if (!culvertEditing) {
//             tempCulverts.push(values);
//             this.setState({ tempCulverts: tempCulverts });
//         } else {
//             var temp = tempCulverts.filter((tc) => tc !== culvertEditing);
//             temp.push(values);
//             this.setState({ tempCulverts: temp });
//         }

//         this.setState({ culvertDialogOpen: false });
//     };
//     errorValidatorCulvert = (values) => {
//         const isRequired = (val) => {
//             return !val ? "Required" : null;
//         };
//         var valObj = {
//             name: isRequired(values.name),
//         };

//         return valObj;
//     };
//     addAttachment = (values) => {
//         var { attachmentEditing, temp_attachments } = this.state;

//         if (!attachmentEditing) {
//             temp_attachments.push(values);
//             this.setState({ temp_attachments: temp_attachments });
//         } else {
//             var temp = temp_attachments.filter((tc) => tc !== attachmentEditing);
//             temp.push(values);
//             this.setState({ temp_attachments: temp });
//         }

//         this.setState({ attachmentDialogOpen: false });
//     };

//     handleRequestSort = (event, property) => {
//         const orderBy = property;
//         let order = "desc";

//         if (this.state.orderBy === property && this.state.order === "desc") {
//             order = "asc";
//         }

//         order === "desc"
//             ? this.state.temp_contacts.sort((a, b) => (b[orderBy].toUpperCase() < a[orderBy].toUpperCase() ? -1 : 1))
//             : this.state.temp_contacts.sort((a, b) => (a[orderBy].toUpperCase() < b[orderBy].toUpperCase() ? -1 : 1));

//         this.setState({ order, orderBy });
//     };

//     handleRequestSort2 = (event, property) => {
//         const orderBy = property;
//         let order = "desc";

//         if (this.state.orderBy === property && this.state.order === "desc") {
//             order = "asc";
//         }

//         order === "desc"
//             ? this.state.temp_attachments.sort((a, b) => (b[orderBy].toUpperCase() < a[orderBy].toUpperCase() ? -1 : 1))
//             : this.state.temp_attachments.sort((a, b) => (a[orderBy].toUpperCase() < b[orderBy].toUpperCase() ? -1 : 1));

//         this.setState({ order, orderBy });
//     };

//     handleNext = (index) => {
//         const { activeStep } = this.state;
//         if (index || index === 0) {
//             this.setState({ activeStep: index });
//         } else if (activeStep < 5) this.setState({ activeStep: activeStep + 1 });
//         else {
//             this.formApi.submitForm();
//         }
//     };




//     render() {
//         const { classes, mediaQuery } = this.props;
//         const {
//             activeStep,
//             attachmentDialogOpen,
//             attachmentEditing,
//             attachmentFormKey,
//             attachmentOrder,
//             attachmentOrderBy,
//             temp_attachments,
//             loading,
//             new_save,
//             mainFormKey,
//             new_save2,
//             entryError, 
//             order,
//             orderBy,
//             culvertDialogOpen,
//             culvertEditing,
//             formKey, 
//             projectType,
//             selectLegal,
//             tempCulverts,
//             application
//         } = this.state;

//         var is_read_only = false;
//         if (
//             application &&
//             application.applicationrecord &&
//             (application.applicationrecord.status !== ""
//         ))
//             is_read_only = true;

//         var columnDataAttachments = [
//             { id: "actions", numeric: false, label: "", allowSort: false, width: "20px" },
//             { id: "name", numeric: false, label: "Name", allowSort: true },
//             { id: "_type", numeric: false, label: "Type", allowSort: true },
//             { id: "notes", numeric: false, label: "Notes", allowSort: true },
//         ];

//         var culvertHeader = [
//             { id: "actions", numeric: false, label: "", allowSort: false, width: "20px" },
//             { id: "name", numeric: false, label: "Culvert Name or ID", allowSort: true },
//             { id: "e_size", numeric: false, label: "Existing culvert size", allowSort: true },
//             { id: "e_length", numeric: false, label: "Existing culvert length", allowSort: true },
//             { id: "e_elevation", numeric: false, label: "Existing culvert elevation", allowSort: true },
//             { id: "p_size", numeric: false, label: "Proposed culvert size", allowSort: true },
//             { id: "p_length", numeric: false, label: "Proposed culvert length", allowSort: true },
//             { id: "p_elevation", numeric: false, label: "Proposed culvert elevation", allowSort: true },
//             { id: "additional", numeric: false, label: "Additional information about culvert", allowSort: true },
//         ]

//         if (new_save) {
//             return (
//                 <AppContainerApplication city_id={window.location.origin.includes("ms4prod") ? "12" : "2"} page_loading={loading}>
//                     <Grid container spacing={1} style={{ padding: "0 12px" }}>
//                         <Grid item xs={12} xl={10}>
//                             <Typography>
//                                 This is a confirmation that the permit application has been submitted successfully. A copy of the permit application
//                                 has been emailed to the primary property owner's email address. Please check your spam and junk folders if you have
//                                 not received it or contact the district. The district will contact you as the application is being reviewed.
//                             </Typography>
//                         </Grid>
//                     </Grid>
//                 </AppContainerApplication>
//             );
//         }
//         if (entryError) {
//             return (
//                 <AppContainerApplication city_id={window.location.origin.includes("ms4prod") ? "12" : "2"} page_loading={loading}>
//                     <Grid container spacing={1} style={{ padding: "0 12px" }}>
//                         <Grid item xs={12} xl={10}>
//                             <Typography>
//                                 This permit application was 'not' successfully saved. Please contact the permit 'managing' staff to alert them of the
//                                 entry failure.
//                             </Typography>
//                         </Grid>
//                     </Grid>
//                 </AppContainerApplication>
//             );
//         }

//         if (new_save2) {
//             return (
//                 <AppContainerApplication city_id={window.location.origin.includes("ms4prod") ? "12" : "2"} page_loading={loading}>
//                     <Grid container spacing={1} style={{ padding: "0 12px" }}>
//                         <Grid item xs={12} xl={10}>
//                             <Typography>This is a confirmation that the permit application has been resubmitted successfully.</Typography>
//                         </Grid>
//                     </Grid>
//                 </AppContainerApplication>
//             );
//         }
//         if (activeStep === "PRINT")
//             return (
//                 <AppContainerApplication city_id={window.location.origin.includes("ms4prod") ? "12" : "2"} page_loading={loading}>
//                     <Grid container spacing={1} style={{ padding: "0 12px" }}>
//                         <Grid item xs={12} xl={10}>
//                             <Typography>Permit Printed.</Typography>
//                         </Grid>
//                     </Grid>
//                 </AppContainerApplication>
//             );

//         // based on project type will dictate the attachment types they have to choose from (well took away as customer didnt want detailed)
//         // but it still determines which help outputs are seen in the attachment step
//         var attachmentTypes = []
//         if (projectType.length > 0){    
//             let tiling = ['Tiling Site Map','Tiling Downstream Landowner Notification']
//             let surface = ['Surface Drainage Site Map','Surface Drainage Downstream Landowner Notification']
//             let culvert = ['Culvert Site Map']
//             let bridge = ['Bridge Site Map','Bridge Project Engineers Report','Bridge Detailed Project Construction Plans']
//             let wet = ['Wetland/Water Project Site Map','Wetland/Water Project Detailed Construction Plans']
//             let road = ['Road Grading detailed project construction plans','Road Grading site plan']
//             let dike = ['Dike site plan','Dike detailed construction plans']
//             let channel = ['Channel detailed design plans','Channel site map']
//             let land= ['Land Development project detailed construction plans','Land Development project site map']
//             let stormwater = ['Stormwater Report showing modeling results of pond design','Stormwater Pollution Prevention Plan (SWPPP)']
//             let utility = ['Utility project detailed project plans','Utility project site map']
//             let other = ['Legacy File','Other']
//             if(projectType.find(t=>t.includes("Tiling")) && !attachmentTypes.find(a=> a.includes("Tiling")))attachmentTypes = [...attachmentTypes, ...tiling] 
//             if(projectType.find(t=>t.includes("Surface")) && !attachmentTypes.find(a=> a.includes("Surface")))attachmentTypes = [...attachmentTypes, ...surface]
//             if(projectType.find(t=>t.includes("Culvert")) && !attachmentTypes.find(a=> a.includes("Culvert")))attachmentTypes = [...attachmentTypes, ...culvert] 
//             if(projectType.find(t=>t.includes("Bridge")) && !attachmentTypes.find(a=> a.includes("Bridge")))attachmentTypes = [...attachmentTypes, ...bridge] 
//             if(projectType.find(t=>t.includes("Wetland")) && !attachmentTypes.find(a=> a.includes("Wetland")))attachmentTypes = [...attachmentTypes, ...wet] 
//             if(projectType.find(t=>t.includes("Road")) && !attachmentTypes.find(a=> a.includes("Road")))attachmentTypes = [...attachmentTypes, ...road] 
//             if(projectType.find(t=>t.includes("Dike")) && !attachmentTypes.find(a=> a.includes("Dike")))attachmentTypes = [...attachmentTypes, ...dike] 
//             if(projectType.find(t=>t.includes("Channel")) && !attachmentTypes.find(a=> a.includes("Channel")))attachmentTypes = [...attachmentTypes, ...channel] 
//             if(projectType.find(t=>t.includes("Land")) && !attachmentTypes.find(a=> a.includes("Land")))attachmentTypes = [...attachmentTypes, ...land] 
//             if(projectType.find(t=>t.includes("Stormwater")) && !attachmentTypes.find(a=> a.includes("Stormwater")))attachmentTypes = [...attachmentTypes, ...stormwater]  
//             if(projectType.find(t=>t.includes("Utility")) && !attachmentTypes.find(a=> a.includes("Utility")))attachmentTypes = [...attachmentTypes, ...utility]  
//             if(!attachmentTypes.find(a=> a.includes("Legacy")))attachmentTypes = [...attachmentTypes, ...other]  

//         }
//         let steps = [
//             "Instructions",
//             "Applicant Information",
//             "Project Type and Location",
//             "Project Type Details",
//             "Document Upload",
//             "Landowner Acknowledgement and Submittal"
//         ]


//         return (
//             <AppContainerApplication
//                 city_id={"52"} //window.location.origin.includes("ms4prod") ? "45" : "2"}
//                 page_loading={loading}
//                 printing={activeStep === "PRINT"}>
//                 <Form
//                     getApi={(el) => (this.formApi = el)}
//                     defaultValues={application}
//                     key={mainFormKey}
//                     pure={false}
//                     dontValidateOnMount={true}
//                     validateOnSubmit={true}
//                     validateError={(values) => this.errorValidator(values)}
//                     onSubmit={(values) => this.submitApplication(values)}>
//                     {(formApi) => (
//                         <form onSubmit={formApi.submitForm}>
//                             <>
//                                 {application && application.applicationrecord && application.applicationrecord.status && (
//                                     <Grid container spacing={1} style={{ backgroundColor: "#a3a3a3", marginTop: -15 }}>
//                                         <Grid item xs={12} xl={10} classes={{ root: classes.root }}>
//                                             <Typography className={classes.centerAlign} variant="h6">
//                                                 Permit Status: {application && application.applicationrecord.status}
//                                             </Typography>
//                                         </Grid>
//                                     </Grid>
//                                 )}
//                                 <Grid container spacing={1} style={{ padding: "0 12px" }}>

//                                     <Grid item xs={12} xl={10} classes={{ root: classes.root }}>  
//                                         <Typography className={classes.centerAlign} variant="h6" >
//                                             Permit Application Form {application && application.permit_number && "#" + application.permit_number}
//                                         </Typography>{" "}     </Grid>
//                                         <Grid item xs={12} xl={10} className={classes.rightAlign} classes={{ root: classes.root }}> 
//                                         <Typography className={classes.centerAlign}>
//                                             <b>IMPORTANT:</b> The entire permit application must be filled out at one time and progress will not be
//                                             saved so please plan accordingly.
//                                         </Typography>
//                                         <Typography variant="caption" className={classes.centerAlign2}>
//                                             Required Fields are marked with an asterisk (*)
//                                         </Typography>
//                                     </Grid>

//                                     {activeStep !== "PRINT" && (
//                                         <Grid item xs={12} xl={10} classes={{ root: classes.root }}>
//                                             {!mediaQuery ? (
//                                                 <Typography variant="subtitle1" style={{fontWeight: "bold", textAlign:"center"}}>
//                                                     <MobileStepper
//                                                         variant="text"
//                                                         steps={steps.length + " - " + steps[activeStep]}
//                                                         position="static"
//                                                         activeStep={activeStep}
//                                                         style={{backgroundColor: "rgb(240, 240, 240)"}}
//                                                         nextButton={
//                                                             <Button
//                                                             size="small"
//                                                             onClick={() => this.handleNext()}
//                                                             disabled={is_read_only && activeStep === 5}
//                                                             >
//                                                             {activeStep === 5 ? "Submit" : "Next"} <KeyboardArrowRight />
//                                                             </Button>
//                                                         }
//                                                         backButton={
//                                                             <Button size="small" onClick={() => this.setState({ activeStep: activeStep - 1 })} disabled={activeStep === 0}>
//                                                                 <KeyboardArrowLeft /> Back
//                                                             </Button>
//                                                         }
//                                                     />
//                                                 </Typography>
//                                             ) : (
//                                             <Stepper style={{ padding: 8 }} alternativeLabel nonLinear activeStep={activeStep}>
//                                                 {steps.map((label, index) => {
//                                                     return (
//                                                         <Step key={label}>
//                                                             <StepButton style={{ cursor: "pointer" }} onClick={() => this.handleNext(index)}>
//                                                                 {label}
//                                                             </StepButton>
//                                                         </Step>
//                                                     );
//                                                 })}
//                                             </Stepper>
//                                             )}
//                                         </Grid>
//                                     )}
//                                     {activeStep === 0 && (
//                                         <Grid  item direction="row" justifyContent="center" alignItems="center" style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                             <Typography variant="subtitle1">
//                                                 <b>
//                                                     {"1. "}
//                                                     <u>Preparation</u>
//                                                 </b>
//                                             </Typography>
//                                             <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                 {`\u2022`} As you work through the online application you will not be able to save your progress for
//                                                 submittal at a later time.
//                                             </Typography>
//                                             <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                 {`\u2022`} Please have all the required information on hand to ensure you are able to submit a
//                                                 complete application.
//                                             </Typography>
//                                             <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                 {`\u2022`} For guidance about the required information, please see the{" "}
//                                                 <a
//                                                     target="_blank"
//                                                     rel="noopener noreferrer"
//                                                     href="https://www.brrwd.org/rules-and-regulations"
//                                                     >
//                                                     BRRWD Rules
//                                                 </a>{" "}
//                                             </Typography>
//                                             <br />
//                                             <Typography variant="subtitle1">
//                                                 <b>
//                                                     {"2. "}
//                                                     <u>Submit Application</u>
//                                                 </b>
//                                             </Typography>
//                                             <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                 {`\u2022`} Once you have compiled the required information, complete the permit application and
//                                                 submit. Again, your progress will not be saved for submittal at a later time.
//                                             </Typography>
//                                             <br />
//                                             <Typography variant="subtitle1">
//                                                 <b>
//                                                     {"3. "}
//                                                     <u>Application Review</u>
//                                                 </b>
//                                             </Typography>
//                                             <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                 {`\u2022`} Once your application has been submitted, BRRWD staff will notify you within 15 days if more information is required. 
//                                             </Typography>
//                                             <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                 {`\u2022`} Once all required information has been received, application will be brought to BRRWD Board for approval.
//                                             </Typography>
//                                         </Grid>
//                                     )}
//                                     {activeStep === 1 && (
//                                         <Grid  item direction="row" justifyContent="center" alignItems="center" classes={{ root: classes.root }}>
//                                             <Typography>Please add contacts associated with the application.</Typography>
//                                             <Accordion defaultExpanded>
//                                                 <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: "#ddd" }}>
//                                                     <Typography variant="subtitle1" gutterBottom>
//                                                         Primary Property Owner (required)
//                                                     </Typography>
//                                                 </AccordionSummary>
//                                                 <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
//                                                     <Grid container spacing={2}>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                         {/* <InputLabel htmlFor="appl_first_name">First Name *</InputLabel> */}
//                                                             <TextField
//                                                                 // id='appl_first_name'
//                                                                 disabled={is_read_only}
//                                                                 field="appl_first_name"
//                                                                 label="First Name *"
//                                                                 fullWidth
//                                                             />

//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             {/* <InputLabel htmlFor="appl_last_name">Last Name *</InputLabel> */}
//                                                             <TextField
//                                                                 // id='appl_last_name'
//                                                                 disabled={is_read_only}
//                                                                 field="appl_last_name"
//                                                                 label="Last Name *"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="appl_affiliation"
//                                                                 label={
//                                                                     <HelpLabel
//                                                                         inputLabel="Affiliation"
//                                                                         helpText="Please list government unit or private entity that 
//                                                                         is applying on behalf of the landowner, if applicable.
//                                                                         "
//                                                                     />
//                                                                 }
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>

//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField disabled={is_read_only} field="appl_email" label="Email" fullWidth />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField disabled={is_read_only} field="appl_phone" label="Phone *" fullWidth usePhoneNumberFormat />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField disabled={is_read_only} field="appl_mailing_address" label="Address" fullWidth />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField disabled={is_read_only} field="appl_mailing_address2" label="Address 2" fullWidth />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField disabled={is_read_only} field="appl_city" label="City" fullWidth />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <Select
//                                                                 disabled={is_read_only}
//                                                                 field="appl_state"
//                                                                 label="State"
//                                                                 options={states}
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField disabled={is_read_only} field="appl_zip" label="Zip" fullWidth />
//                                                         </Grid>

//                                                     </Grid>
//                                                 </AccordionDetails>
//                                             </Accordion>
//                                             <Accordion defaultExpanded>
//                                                 <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: "#ddd" }}>
//                                                     <Typography variant="subtitle1" gutterBottom>
//                                                         Landowner (if not same as Applicant)
//                                                     </Typography>
//                                                 </AccordionSummary>
//                                                 <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
//                                                     <Grid container spacing={2}>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="landowner_first_name"
//                                                                 label="First Name"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="landowner_last_name"
//                                                                 label="Last Name"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="landowner_email"
//                                                                 label="Email"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="landowner_phone"
//                                                                 label="Phone"
//                                                                 fullWidth
//                                                                 usePhoneNumberFormat
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField disabled={is_read_only} field="landowner_mailing_address" label="Address" fullWidth />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField disabled={is_read_only} field="landowner_mailing_address2" label="Address 2" fullWidth />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField disabled={is_read_only} field="landowner_city" label="City" fullWidth />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <Select
//                                                                 disabled={is_read_only}
//                                                                 field="landowner_state"
//                                                                 label="State"
//                                                                 options={states}
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField disabled={is_read_only} field="landowner_zip" label="Zip" fullWidth />
//                                                         </Grid>
//                                                     </Grid>
//                                                 </AccordionDetails>
//                                             </Accordion>{" "}
//                                         </Grid>
//                                     )}
//                                     {activeStep === "PRINT" && (
//                                         <>
//                                             <div style={{ height: 50 }}></div>
//                                             <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                                 <Divider className={classes.printDivider} />
//                                             </Grid>
//                                         </>
//                                     )}
//                                     {activeStep === 2 && (
//                                         <Grid item direction="row"  justifyContent="center" alignItems="center" classes={{ root: classes.root }}>
//                                                 <CheckboxGroup
//                                                     field="project_types"
//                                                     label="Select Project Types: (Check all that apply)"
//                                                     required
//                                                     row={true}
//                                                     disabled={is_read_only}
//                                                     eventHandle={(e) => { 
//                                                         this.setState({projectType:e})
//                                                     }}
//                                                     options={MAKE_OPTIONS([
//                                                         "Tiling","Surface Drainage (New Ditch or Improvement)","Culvert Installation / Removal / Modification","Bridge Installation / Removal / Modification",
//                                                         "Wetland Restoration / Water Retention Related Structures / Water and Sediment Control Basins","Dike / Levee",
//                                                         "Channel Stabilization / Restoration / Erosion Control / Shoreland Projects","Land Development","Utility Installations"
//                                                     ])}
//                                                 />
//                                             <Grid item xs={12}>
//                                                     <br />
//                                                     <hr />
//                                                     <br />
//                                             </Grid>
//                                             <Grid container spacing={2}>
//                                                 <Grid item xs={12}>
//                                                     <TextField
//                                                         field="project_description"
//                                                         label={
//                                                             <HelpLabel
//                                                                 inputLabel="Provide description of proposed project *:"
//                                                                 helpText="Applicant must provide a detailed project description. Application will be considered <u>incomplete</u> until adequate information is provided."
//                                                             />
//                                                         }
//                                                         multiline
//                                                         rows={8}
//                                                         disabled={is_read_only}
//                                                         fullWidth
//                                                     />
//                                                 </Grid>
//                                                 <Grid item xs={12}>
//                                                     <Typography variant="subtitle1" gutterBottom>
//                                                         <b>Project Location (County, Township and Section is required)</b>
//                                                     </Typography>
//                                                 </Grid>

//                                                 <Grid item xs={12} md={6} xl={4}> 
//                                                     <Select
//                                                         // id='county'
//                                                         disabled={is_read_only}
//                                                         field="county"
//                                                         label="County *"
//                                                         options={MAKE_OPTIONS(["Becker","Clay","Otter Tail","Wilkin"])}
//                                                         fullWidth 
//                                                     />
//                                                 </Grid>
//                                                 <Grid item xs={12} md={6} xl={4}>
//                                                     <Select
//                                                         disabled={is_read_only}
//                                                         field="project_township"
//                                                         label="Township/City Name *" 
//                                                         options={MAKE_OPTIONS(["Akron","Alliance","Andrea","Atherton","Atlanta","Audubon","Barnesville","Bradford","Breckenridge","Callaway","Carlisle",
//                                                             "City of Audubon","City of Barnesville","City of Breckenridge","City of Callaway","City of Comstock","City of Dilworth","City of Fergus Falls",
//                                                             "City of Foxhome","City of Georgetown","City of Glyndon","City of Hawley","City of Hitterdal","City of Kent","City of Lake Park","City of Moorhead",
//                                                             "City of Rothsay","City of Sabin","City of Wolverton","Connelly","Cormorant","Cromwell","Cuba","Deerhorn","Detroit","Eglon","Elizabeth","Elkton","Elmwood",
//                                                             "Erie","Fergus Falls","Flowing","Foxhome","Georgetown","Glyndon","Goose Prairie","Hamden","Hawley","Height of Land","Highland Grove","Holmesville","Holy Cross",
//                                                             "Humboldt","Keene","Kragnes","Kurtz","Lake Eunice","Lake Park","Lake View","Manston","Maple Grove","McCauleyville","Meadows","Mitchell","Moland","Moorhead","Morken","Nilsen",
//                                                             "Nordick","Norwegian Grove","Oakport","Orwell","Oscar","Parke","Pelican","Prairie View","Riceville","Richwood","Riverton","Roberts","Scambler","Skree","Spring Creek",
//                                                             "Spring Prairie","Sugar Bush","Sunnyside","Tanberg","Tansem","Trondhjem","Viding","Western","White Earth","Wolverton"])}
//                                                         fullWidth
//                                                     />
//                                                 </Grid>

//                                                 <Grid item xs={12} md={6} xl={4}>
//                                                     <Select
//                                                         disabled={is_read_only}
//                                                         field="section"
//                                                         label="Section *"
//                                                         options={MAKE_OPTIONS([
//                                                             "1",
//                                                             "2",
//                                                             "3",
//                                                             "4",
//                                                             "5",
//                                                             "6",
//                                                             "7",
//                                                             "8",
//                                                             "9",
//                                                             "10",
//                                                             "11",
//                                                             "12",
//                                                             "13",
//                                                             "14",
//                                                             "15",
//                                                             "16",
//                                                             "17",
//                                                             "18",
//                                                             "19",
//                                                             "20",
//                                                             "21",
//                                                             "22",
//                                                             "23",
//                                                             "24",
//                                                             "25",
//                                                             "26",
//                                                             "27",
//                                                             "28",
//                                                             "29",
//                                                             "30",
//                                                             "31",
//                                                             "32",
//                                                             "33",
//                                                             "34",
//                                                             "35",
//                                                             "36",
//                                                         ])}
//                                                         fullWidth
//                                                     />
//                                                 </Grid>
//                                                 <Grid item xs={12} md={6} xl={4}>
//                                                     <Select
//                                                         disabled={is_read_only}
//                                                         field="quarter_section"
//                                                         label="Primary Quarter Section"
//                                                         options={MAKE_OPTIONS(["NW", "NE", "SW", "SE"])}
//                                                         fullWidth
//                                                     />
//                                                 </Grid>
//                                             </Grid>
//                                         </Grid>
//                                     )}
//                                     {activeStep === "PRINT" && (
//                                         <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                             <Divider className={classes.printDivider} />
//                                         </Grid>
//                                     )}
//                                     {activeStep === 3 && projectType.length === 0 && (
//                                         <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                             <Typography variant="subtitle1" gutterBottom style={{textAlign: "center", textDecoration: "underline",fontWeight: "bold"}}>
//                                                 No Project Types have been selected. Refer to Step 3 and select a 'Project Type'
//                                             </Typography>
//                                         </Grid>
//                                     )}
//                                     {activeStep === 3 && projectType.length > 0 && projectType.find(t=>t==="Tiling") && (   
//                                         <Grid item direction="row"  justifyContent="center" alignItems="center" classes={{ root: classes.root }}>
//                                            <Accordion defaultExpanded>
//                                                 <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: "#ddd" }}>
//                                                     <Typography variant="subtitle1" gutterBottom>
//                                                         Tiling
//                                                     </Typography>
//                                                 </AccordionSummary>
//                                                 <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
//                                                     <Grid container spacing={2}>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="til_water_issu"
//                                                                 label="Describe water related issues that make this work necessary"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="til_rec_water"
//                                                                 label="Describe receiving waters"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <RadioGroup
//                                                                 field="til_land_ass"
//                                                                 disabled={is_read_only}
//                                                                 fullWidth
//                                                                 options={[
//                                                                     { label: "Yes", value: "Yes" },
//                                                                     { label: "No", value: "No" },
//                                                                 ]}
//                                                                 alignment={true}
//                                                                 label="Land is assessed to legal ditch system"
//                                                                 eventHandle={e=>{
//                                                                     this.setState({selectLegal:e === "Yes"? true : false})
//                                                                 }}
//                                                             />
//                                                         </Grid> 
//                                                         {selectLegal && (
//                                                             <Grid item xs={12} md={6} xl={4}>
//                                                                 <Select
//                                                                     // disabled={selectLegal }
//                                                                     field="til_legal_ditch"
//                                                                     label="Select legal ditch system"
//                                                                     options={MAKE_OPTIONS(["Becker County Ditch No. 10","Becker County Ditch No. 15","Becker County Ditch No. 19",
//                                                                         "Becker County Ditch No. 21","Becker County Ditch No. 5","Becker County Ditch No. 6","Becker County Ditch No. 7",
//                                                                         "Becker County Ditch No. 9","Clay County Ditch No. 10","Clay County Ditch No. 11","Clay County Ditch No. 12","Clay County Ditch No. 16",
//                                                                         "Clay County Ditch No. 17","Clay County Ditch No. 2","Clay County Ditch No. 20","Clay County Ditch No. 21","Clay County Ditch No. 22",
//                                                                         "Clay County Ditch No. 23","Clay County Ditch No. 28","Clay County Ditch No. 3","Clay County Ditch No. 30","Clay County Ditch No. 31",
//                                                                         "Clay County Ditch No. 32","Clay County Ditch No. 33","Clay County Ditch No. 34","Clay County Ditch No. 35","Clay County Ditch No. 36",
//                                                                         "Clay County Ditch No. 39","Clay County Ditch No. 40","Clay County Ditch No. 41","Clay County Ditch No. 41-Lateral No. 1",
//                                                                         "Clay County Ditch No. 41-Lateral No. 2","Clay County Ditch No. 47","Clay County Ditch No. 49","Clay County Ditch No. 5","Clay County Ditch No. 50",
//                                                                         "Clay County Ditch No. 51","Clay County Ditch No. 53","Clay County Ditch No. 54","Clay County Ditch No. 55","Clay County Ditch No. 57",
//                                                                         "Clay County Ditch No. 58","Clay County Ditch No. 59","Clay County Ditch No. 60","Clay County Ditch No. 63","Clay County Ditch No. 65",
//                                                                         "Clay County Ditch No. 67","Clay County Ditch No. 68","Clay County Ditch No. 69","Clay County Ditch No. 9","Clay-Wilkin Judicial Ditch No. 1",
//                                                                         "Wilkin County Ditch No. 12","Wilkin County Ditch No. 13","Wilkin County Ditch No. 13-Lateral No. 1","Wilkin County Ditch No. 15",
//                                                                         "Wilkin County Ditch No. 1A","Wilkin County Ditch No. 1B","Wilkin County Ditch No. 1C","Wilkin County Ditch No. 2/2A","Wilkin County Ditch No. 22",
//                                                                         "Wilkin County Ditch No. 23","Wilkin County Ditch No. 26","Wilkin County Ditch No. 27","Wilkin County Ditch No. 28","Wilkin County Ditch No. 29",
//                                                                         "Wilkin County Ditch No. 3","Wilkin County Ditch No. 31","Wilkin County Ditch No. 34","Wilkin County Ditch No. 37","Wilkin County Ditch No. 4/4A",
//                                                                         "Wilkin County Ditch No. 40","Wilkin County Ditch No. 41","Wilkin County Ditch No. 42","Wilkin County Ditch No. 43","Wilkin County Ditch No. 44",
//                                                                         "Wilkin County Ditch No. 5A","Wilkin County Ditch No. 6A","Wilkin County Ditch No. 7","Wilkin-Otter Tail Judicial Ditch No. 2"])}
//                                                                     fullWidth
//                                                                 />
//                                                             </Grid> 
//                                                         )}
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             {/* <InputLabel htmlFor="til_olet">Tile outlets across property not owned by landowner or applicant</InputLabel> */}
//                                                             <RadioGroup
//                                                                 // id='til_olet'
//                                                                 field="til_olet"
//                                                                 disabled={is_read_only}
//                                                                 fullWidth
//                                                                 options={[
//                                                                     { label: "Yes", value: "Yes" },
//                                                                     { label: "No", value: "No" },
//                                                                 ]}
//                                                                 alignment={true}
//                                                                 label="Tile outlets across property not owned by landowner or applicant"
//                                                             />
//                                                         </Grid> 
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField disabled={is_read_only} field="project_dname" label="Project Designer Name" fullWidth />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField disabled={is_read_only} field="project_dphone" label="Project Designer Phone" fullWidth usePhoneNumberFormat/>
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField disabled={is_read_only} field="project_demail" label="Project Designer Email" fullWidth />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField disabled={is_read_only} field="project_iname" label="Project Installer Name" fullWidth />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                         {/* <InputLabel htmlFor="project_iphone">Project Installer Phone</InputLabel> */}
//                                                             <TextField disabled={is_read_only} field="project_iphone" label="Project Installer Phone"   fullWidth usePhoneNumberFormat/>
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField disabled={is_read_only} field="project_iemail" label="Project Installer Email" fullWidth />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField disabled={is_read_only} field="addinfo" label="Additional Information about Tiling Project" fullWidth />
//                                                         </Grid>
//                                                     </Grid>
//                                                 </AccordionDetails>
//                                             </Accordion>
//                                         </Grid>
//                                     )}
//                                     {activeStep === 3 && projectType.length > 0 && projectType.find(t=>t==="Surface Drainage (New Ditch or Improvement)") && (   
//                                         <Grid item direction="row"  justifyContent="center" alignItems="center" classes={{ root: classes.root }}>
//                                            <Accordion defaultExpanded>
//                                                 <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: "#ddd" }}>
//                                                     <Typography variant="subtitle1" gutterBottom>
//                                                         Surface Drainage (New Ditch or Improvement)
//                                                     </Typography>
//                                                 </AccordionSummary>
//                                                 <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
//                                                     <Grid container spacing={2}>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <Select
//                                                                 disabled={is_read_only}
//                                                                 field="sur_drainage"
//                                                                 label="Surface Drainage Project involves:"
//                                                                 options={MAKE_OPTIONS(["Construction of new ditch","Improvement of existing ditch"])}
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="sur_depth"
//                                                                 label="Existing ditch depth (max 50)"
//                                                                 fullWidth
//                                                                 units="feet"
//                                                                 useNumberFormat3
//                                                                 maxValue={50}
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="sur_width"
//                                                                 label="Existing ditch width (max 1000)"
//                                                                 fullWidth
//                                                                 units="feet"
//                                                                 useNumberFormat3
//                                                                 maxValue={1000}
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <Select
//                                                                 disabled={is_read_only}
//                                                                 field="sur_slopes"
//                                                                 label="Existing ditch side slopes"
//                                                                 options={MAKE_OPTIONS(["3H:1V","4H:1V","5H:1V","6H:1V"])}
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="sur_pdepth"
//                                                                 label="Proposed ditch depth (max 50)"
//                                                                 fullWidth
//                                                                 units="feet"
//                                                                 useNumberFormat3
//                                                                 maxValue={50}
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="sur_pwidth"
//                                                                 label="Proposed ditch width (max 1000)"
//                                                                 fullWidth
//                                                                 units="feet"
//                                                                 useNumberFormat3
//                                                                 maxValue={1000}
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <Select
//                                                                 disabled={is_read_only}
//                                                                 field="sur_pslopes"
//                                                                 label="Proposed ditch side slopes"
//                                                                 options={MAKE_OPTIONS(["3H:1V","4H:1V","5H:1V","6H:1V"])}
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="sur_how_grade"
//                                                                 label="How will grade-line of ditch be established?"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="sur_spoil"
//                                                                 label="Where will spoil be placed?"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <Select
//                                                                 disabled={is_read_only}
//                                                                 field="sur_outlet"
//                                                                 label="Outlet is:"
//                                                                 options={MAKE_OPTIONS(["Natural Stream / River","Roadside Ditch","Legal Ditch","Applicants Field","Other"])}
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="sur_outlet_other"
//                                                                 label="If is Outlet Other, Explain"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <RadioGroup
//                                                                 field="sur_ditch_outlet"
//                                                                 disabled={is_read_only}
//                                                                 fullWidth
//                                                                 options={[
//                                                                     { label: "Yes", value: "Yes" },
//                                                                     { label: "No", value: "No" },
//                                                                 ]}
//                                                                 alignment={true}
//                                                                 label="Ditch outlets across property not owned by landowner or applicant"
//                                                             />
//                                                         </Grid> 
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <RadioGroup
//                                                                 field="sur_land_ass"
//                                                                 disabled={is_read_only}
//                                                                 fullWidth
//                                                                 options={[
//                                                                     { label: "Yes", value: "Yes" },
//                                                                     { label: "No", value: "No" },
//                                                                 ]}
//                                                                 alignment={true}
//                                                                 label="Land is assessed to legal ditch system"
//                                                             />
//                                                         </Grid> 
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <Select
//                                                                 disabled={is_read_only}
//                                                                 field="sur_legal_ditch"
//                                                                 label="Legal ditch system"
//                                                                 options={MAKE_OPTIONS(["Becker County Ditch No. 10","Becker County Ditch No. 15","Becker County Ditch No. 19",
//                                                                     "Becker County Ditch No. 21","Becker County Ditch No. 5","Becker County Ditch No. 6","Becker County Ditch No. 7",
//                                                                     "Becker County Ditch No. 9","Clay County Ditch No. 10","Clay County Ditch No. 11","Clay County Ditch No. 12","Clay County Ditch No. 16",
//                                                                     "Clay County Ditch No. 17","Clay County Ditch No. 2","Clay County Ditch No. 20","Clay County Ditch No. 21","Clay County Ditch No. 22",
//                                                                     "Clay County Ditch No. 23","Clay County Ditch No. 28","Clay County Ditch No. 3","Clay County Ditch No. 30","Clay County Ditch No. 31",
//                                                                     "Clay County Ditch No. 32","Clay County Ditch No. 33","Clay County Ditch No. 34","Clay County Ditch No. 35","Clay County Ditch No. 36",
//                                                                     "Clay County Ditch No. 39","Clay County Ditch No. 40","Clay County Ditch No. 41","Clay County Ditch No. 41-Lateral No. 1",
//                                                                     "Clay County Ditch No. 41-Lateral No. 2","Clay County Ditch No. 47","Clay County Ditch No. 49","Clay County Ditch No. 5","Clay County Ditch No. 50",
//                                                                     "Clay County Ditch No. 51","Clay County Ditch No. 53","Clay County Ditch No. 54","Clay County Ditch No. 55","Clay County Ditch No. 57",
//                                                                     "Clay County Ditch No. 58","Clay County Ditch No. 59","Clay County Ditch No. 60","Clay County Ditch No. 63","Clay County Ditch No. 65",
//                                                                     "Clay County Ditch No. 67","Clay County Ditch No. 68","Clay County Ditch No. 69","Clay County Ditch No. 9","Clay-Wilkin Judicial Ditch No. 1",
//                                                                     "Wilkin County Ditch No. 12","Wilkin County Ditch No. 13","Wilkin County Ditch No. 13-Lateral No. 1","Wilkin County Ditch No. 15",
//                                                                     "Wilkin County Ditch No. 1A","Wilkin County Ditch No. 1B","Wilkin County Ditch No. 1C","Wilkin County Ditch No. 2/2A","Wilkin County Ditch No. 22",
//                                                                     "Wilkin County Ditch No. 23","Wilkin County Ditch No. 26","Wilkin County Ditch No. 27","Wilkin County Ditch No. 28","Wilkin County Ditch No. 29",
//                                                                     "Wilkin County Ditch No. 3","Wilkin County Ditch No. 31","Wilkin County Ditch No. 34","Wilkin County Ditch No. 37","Wilkin County Ditch No. 4/4A",
//                                                                     "Wilkin County Ditch No. 40","Wilkin County Ditch No. 41","Wilkin County Ditch No. 42","Wilkin County Ditch No. 43","Wilkin County Ditch No. 44",
//                                                                     "Wilkin County Ditch No. 5A","Wilkin County Ditch No. 6A","Wilkin County Ditch No. 7","Wilkin-Otter Tail Judicial Ditch No. 2"])}
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField disabled={is_read_only} field="sur_addinfo" label="Additional Information about Surface Drainage Project" fullWidth />
//                                                         </Grid>
//                                                     </Grid>
//                                                 </AccordionDetails>
//                                             </Accordion>
//                                         </Grid>
//                                     )}

//                                     {activeStep === 3 && projectType.length > 0 && projectType.find(t=>t==="Culvert Installation / Removal / Modification") && (   
//                                         <Grid item direction="row"  justifyContent="center" alignItems="center" classes={{ root: classes.root }}>
//                                            <Accordion defaultExpanded>
//                                                 <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: "#ddd" }}>
//                                                     <Typography variant="subtitle1" gutterBottom>
//                                                         Culvert Installation
//                                                     </Typography>
//                                                 </AccordionSummary>
//                                                 <AccordionDetails style={{ paddingBottom: 27, backgroundColor: "f6f0f0" }}>
//                                                     <Grid container spacing={2}>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <Select
//                                                                 disabled={is_read_only}
//                                                                 field="cul_involves"
//                                                                 label="Culvert Project involves:"
//                                                                 options={MAKE_OPTIONS(["removal of existing culverts","installation of new culverts", "modification of existing culverts"])}
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="cul_num"
//                                                                 label="Number of culverts installed, removed or modified: (minimum 0, maximum 100)"
//                                                                 fullWidth
//                                                                 units="count"
//                                                                 useNumberFormat3
//                                                                 maxValue={100}
//                                                                 minValue={0}
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="cul_info"
//                                                                 label="Additional Information for Culvert Project"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}> 
//                                                             <RadioGroup
//                                                                 disabled={is_read_only}
//                                                                 field="culroad_involves"
//                                                                 label="Does Project Involve Road Grading that will modify elevations?"
//                                                                 fullWidth
//                                                                 options={[
//                                                                     { label: "Yes", value: "Yes" },
//                                                                     { label: "No", value: "No" },
//                                                                 ]}
//                                                                 alignment={true}
//                                                                 />
//                                                         </Grid> 
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="culroad_elev"
//                                                                 label="If Project modifies road elevations, please describe proposed elevations?"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                     </Grid>
//                                                 </AccordionDetails>
//                                                 <AccordionDetails style={{ paddingBottom: 27, backgroundColor: "f6f0f0" }}>
//                                                     <Grid container spacing={2}>
//                                                         <Paper className={classes.root}>
//                                                             <Button
//                                                                 fullWidth
//                                                                 disabled={is_read_only}
//                                                                 className={classes.gutterBottom}
//                                                                 gutterBottom={true}
//                                                                 variant="contained"
//                                                                 color="primary"
//                                                                 onClick={() => {
//                                                                         this.setState({
//                                                                             culvertDialogOpen: true,
//                                                                             culvertEditing: null,
//                                                                             culvertFormKey: window.performance.now(),
//                                                                         })
//                                                                 }}>
//                                                                 <AddIcon className={classes.iconAdd} />
//                                                                 &nbsp;&nbsp;&nbsp;Create New
//                                                             </Button>   
//                                                             <Paper style={{overflowX:"auto"}}>
//                                                             <Table className={classes.table}>
//                                                                 <EnhancedTableHead
//                                                                     order={order}
//                                                                     orderBy={orderBy}
//                                                                     onRequestSort={this.handleRequestSort}
//                                                                     columnData={culvertHeader}
//                                                                 />
//                                                                 <TableBody>
//                                                                     {(() => {
//                                                                         if (tempCulverts.length < 1) {
//                                                                             return (
//                                                                                 <TableRow>
//                                                                                     <CustomTableCell colSpan={culvertHeader.length} className={classes.centerAlign}>
//                                                                                         No Records Available
//                                                                                     </CustomTableCell>
//                                                                                 </TableRow>
//                                                                             );
//                                                                         }

//                                                                         return tempCulverts.map((n) => (
//                                                                             <TableRow hover key={ n.id }>
//                                                                                 <CustomTableCell className={ classes.nowrap }>
//                                                                                     <Tooltip title="Edit">
//                                                                                         {/* EDIT RECORD will trigger createRepeatableField class*/ }
//                                                                                         <Button
//                                                                                             onClick={ () => {
//                                                                                                 this.setState({
//                                                                                                     culvertEditing: n,
//                                                                                                     culvertDialogOpen:true,
//                                                                                                     culvertFormKey: window.performance.now()
//                                                                                                 });
//                                                                                             } }

//                                                                                             className={ classes.deleteWidth }>
//                                                                                             <EditIcon color="primary" />
//                                                                                         </Button>
//                                                                                     </Tooltip>

//                                                                                     <Tooltip title="Delete">
//                                                                                         <Button
//                                                                                             disabled={is_read_only}
//                                                                                             onClick={() =>
//                                                                                                 this.setState({ tempCulverts: tempCulverts.filter((tc) => tc !== n)})
//                                                                                             }
//                                                                                             className={ classes.deleteWidth }>
//                                                                                             <DeleteIcon color="inherit" />

//                                                                                         </Button>
//                                                                                     </Tooltip>
//                                                                                 </CustomTableCell>
//                                                                                 {/* PRINTING OF THE DATA IN THE TABLE */ }
//                                                                                 <CustomTableCell>{n.name}</CustomTableCell>
//                                                                                 <CustomTableCell>{n.e_size}</CustomTableCell>
//                                                                                 <CustomTableCell>{n.e_length}</CustomTableCell>
//                                                                                 <CustomTableCell>{n.e_elevation}</CustomTableCell>
//                                                                                 <CustomTableCell>{n.p_size}</CustomTableCell>
//                                                                                 <CustomTableCell>{n.p_length}</CustomTableCell>
//                                                                                 <CustomTableCell>{n.p_elevation}</CustomTableCell>
//                                                                                 <CustomTableCell>{n.additional}</CustomTableCell> 
//                                                                             </TableRow>
//                                                                         ));
//                                                                     })()}
//                                                                 </TableBody>
//                                                             </Table>
//                                                             </Paper>
//                                                         </Paper>
//                                                     </Grid> 
//                                                 </AccordionDetails>
//                                             </Accordion>
//                                         </Grid>
//                                     )}
//                                     {activeStep === 3 && projectType.length > 0 && projectType.find(t=>t==="Bridge Installation / Removal / Modification") && (   
//                                         <Grid item direction="row"  justifyContent="center" alignItems="center" classes={{ root: classes.root }}>
//                                            <Accordion defaultExpanded>
//                                                 <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: "#ddd" }}>
//                                                     <Typography variant="subtitle1" gutterBottom>
//                                                         Bridge Installation / Removal / Modification
//                                                     </Typography>
//                                                 </AccordionSummary>
//                                                 <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
//                                                     <Grid container spacing={2}>
//                                                         <Grid item xs={12} md={6} xl={4}> 
//                                                             <RadioGroup
//                                                                 disabled={is_read_only}
//                                                                 field="brroad_involves"
//                                                                 label="Does Project Involve Road Grading that will modify elevations?"
//                                                                 fullWidth
//                                                                 options={[
//                                                                     { label: "Yes", value: "Yes" },
//                                                                     { label: "No", value: "No" },
//                                                                 ]}
//                                                                 alignment={true}
//                                                                 />
//                                                         </Grid> 
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="brroad_elev"
//                                                                 label="If Project modifies road elevations, please describe proposed elevations?"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <Select
//                                                                 disabled={is_read_only}
//                                                                 field="br_involves"
//                                                                 label="Bridge Project involves:"
//                                                                 options={MAKE_OPTIONS(["removal of existing bridge","installation of new bridge", "modification of existing bridge"])}
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="br_ex1width"
//                                                                 label="Existing bridge 1 width (max 200)"
//                                                                 fullWidth
//                                                                 units="feet"
//                                                                 useNumberFormat3 
//                                                                 maxValue={200}
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="br_ex1len"
//                                                                 label="Existing bridge 1 length (max 5000)"
//                                                                 fullWidth
//                                                                 units="feet"
//                                                                 useNumberFormat3 
//                                                                 maxValue={5000}
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="br_ex1elev"
//                                                                 label="Existing bridge 1 elevation (max 1500)"
//                                                                 fullWidth
//                                                                 units="feet"
//                                                                 useNumberFormat3
//                                                                 maxValue={1500} 
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="br_p1width"
//                                                                 label="Proposed bridge 1 width (max 200)"
//                                                                 fullWidth
//                                                                 units="feet"
//                                                                 useNumberFormat3
//                                                                 maxValue={200} 
//                                                             />
//                                                         </Grid>

//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="br_p1len"
//                                                                 label="Proposed bridge 1 length (max 5000)"
//                                                                 fullWidth
//                                                                 units="feet"
//                                                                 useNumberFormat3
//                                                                 maxValue={5000} 
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="br_p1elev"
//                                                                 label="Proposed bridge 1 elevation (max 1500)"
//                                                                 fullWidth
//                                                                 units="feet"
//                                                                 useNumberFormat3 
//                                                                 maxValue={1500}
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="br_ex2width"
//                                                                 label="Existing bridge 2 width (max 200)"
//                                                                 fullWidth
//                                                                 units="feet"
//                                                                 useNumberFormat3 
//                                                                 maxValue={200}
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="br_ex2len"
//                                                                 label="Existing bridge 2 length (max 5000)"
//                                                                 fullWidth
//                                                                 units="feet"
//                                                                 useNumberFormat3 
//                                                                 maxValue={5000}
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="br_ex2elev"
//                                                                 label="Existing bridge 2 elevation (max 1500)"
//                                                                 fullWidth
//                                                                 units="feet"
//                                                                 useNumberFormat3 
//                                                                 maxValue={1500}
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="br_p2width"
//                                                                 label="Proposed bridge 2 width (max 200)"
//                                                                 fullWidth
//                                                                 units="feet"
//                                                                 useNumberFormat3 
//                                                                 maxValue={200}
//                                                             />
//                                                         </Grid>

//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="br_p2len"
//                                                                 label="Proposed bridge 2 length (max 5000)"
//                                                                 fullWidth
//                                                                 units="feet"
//                                                                 useNumberFormat3 
//                                                                 maxValue={5000}
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="br_p2elev"
//                                                                 label="Proposed bridge 2 elevation (max 1500)"
//                                                                 fullWidth
//                                                                 units="feet"
//                                                                 useNumberFormat3 
//                                                                 maxValue={1500}
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="br_info"
//                                                                 label="Additional Information for Bridge Proposed Project"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                     </Grid> 
//                                                 </AccordionDetails>
//                                             </Accordion>
//                                         </Grid>
//                                     )} 

//                                     {activeStep === 3 && projectType.length > 0 && projectType.find(t=>t==="Wetland Restoration / Water Retention Related Structures / Water and Sediment Control Basins") && (   
//                                         <Grid item direction="row"  justifyContent="center" alignItems="center" classes={{ root: classes.root }}>
//                                            <Accordion defaultExpanded>
//                                                 <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: "#ddd" }}>
//                                                     <Typography variant="subtitle1" gutterBottom>
//                                                         Wetland Restoration / Water Retention Related Structures / Water and Sediment Control Basins
//                                                     </Typography>
//                                                 </AccordionSummary>
//                                                 <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
//                                                     <Grid container spacing={2}>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <RadioGroup
//                                                                 field="wet_proj"
//                                                                 disabled={is_read_only}
//                                                                 fullWidth
//                                                                 options={[
//                                                                     { label: "Yes", value: "Yes" },
//                                                                     { label: "No", value: "No" },
//                                                                 ]}
//                                                                 alignment={true}
//                                                                 label="Project is mitigation for another project"
//                                                             />
//                                                         </Grid> 
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="wet_desc"
//                                                                 label="If yes, describe project"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <RadioGroup
//                                                                 disabled={is_read_only}
//                                                                 field="wroad_involves"
//                                                                 label="Does Project Involve Road Grading that will modify elevations?"
//                                                                 fullWidth
//                                                                 options={[
//                                                                     { label: "Yes", value: "Yes" },
//                                                                     { label: "No", value: "No" },
//                                                                 ]}
//                                                                 alignment={true}
//                                                             />
//                                                         </Grid> 
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="wroad_elev"
//                                                                 label="If Project modifies road elevations, please describe proposed elevations?"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <Select
//                                                                 disabled={is_read_only}
//                                                                 field="wet_dat"
//                                                                 label="Datum used for plan development"
//                                                                 options={MAKE_OPTIONS(["Local","NGVD29", "NAVD88"])}
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>

//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="wet_op_plan"
//                                                                 label="Describe operation plan"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid> 
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="wet_dname"
//                                                                 label="Project Designer Name"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="wet_dphone"
//                                                                 label="Project Designer Phone"
//                                                                 fullWidth
//                                                                 usePhoneNumberFormat
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="wet_demail"
//                                                                 label="Project Designer Email"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid> 
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="wet_info"
//                                                                 label="Additional Information for Wetland or Water Project"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                     </Grid>
//                                                 </AccordionDetails>
//                                             </Accordion>
//                                         </Grid>
//                                     )}
//                                     {activeStep === 3 && projectType.length > 0 && projectType.find(t=>t==="Road Grading") && (   
//                                         <Grid item direction="row"  justifyContent="center" alignItems="center" classes={{ root: classes.root }}>
//                                            <Accordion defaultExpanded>
//                                                 <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: "#ddd" }}>
//                                                     <Typography variant="subtitle1" gutterBottom>
//                                                         Road Grading
//                                                     </Typography>
//                                                 </AccordionSummary>
//                                                 <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
//                                                     <Grid container spacing={2}>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <ReactSelect
//                                                                 label="Road Grading project involves:"
//                                                                 field="road_involves"
//                                                                 options={MAKE_OPTIONS([
//                                                                     "Roadway elevations will be modified","Project involves removal / installation or modification of culverts",
//                                                                     "Project involves removal / installation or modification of bridge",
//                                                                     "Project involves wetland restoration / water retention structures or water and sediment control basins"
//                                                                 ])}
//                                                                 disabled={is_read_only}
//                                                                 isMulti={true}
//                                                                 height="auto"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>

//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="road_info"
//                                                                 label="Additional Information for Road Grading project"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid> 
//                                                     </Grid>
//                                                 </AccordionDetails>
//                                             </Accordion>
//                                         </Grid>
//                                     )}
//                                       {activeStep === 3 && projectType.length > 0 && projectType.find(t=>t==="Dike / Levee") && (   
//                                         <Grid item direction="row"  justifyContent="center" alignItems="center"classes={{ root: classes.root }}>
//                                            <Accordion defaultExpanded>
//                                                 <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: "#ddd" }}>
//                                                     <Typography variant="subtitle1" gutterBottom>
//                                                         Dike / Levee
//                                                     </Typography>
//                                                 </AccordionSummary>
//                                                 <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
//                                                     <Grid container spacing={2}>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <Select
//                                                                 disabled={is_read_only}
//                                                                 field="dike_involves"
//                                                                 label="Dike / Levee Project Involves:"
//                                                                 options={MAKE_OPTIONS(["New Dike","Modification of Existing Dike" ])}
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <RadioGroup
//                                                                 field="dike_includes"
//                                                                 disabled={is_read_only}
//                                                                 fullWidth
//                                                                 options={[
//                                                                     { label: "Yes", value: "Yes" },
//                                                                     { label: "No", value: "No" },
//                                                                 ]}
//                                                                 alignment={true}
//                                                                 label="Project includes construction of ring dike"
//                                                             />
//                                                         </Grid> 
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <Select
//                                                                 disabled={is_read_only}
//                                                                 field="dike_ring"
//                                                                 label="Ring dike will tie into:"
//                                                                 options={MAKE_OPTIONS(["Dike","Roadway", "High Ground", "Other"])}
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>

//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="dike_other"
//                                                                 label="If Other, please describe:"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid> 
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="dike_purpose"
//                                                                 label="Describe purpose of proposed dike/levee"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="dike_elevation"
//                                                                 label="Describe how elevation of dike was determined"
//                                                                 fullWidth 
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <Select
//                                                                 disabled={is_read_only}
//                                                                 field="dike_datum"
//                                                                 label="Datum used for plan development"
//                                                                 options={MAKE_OPTIONS(["Local","NGVD29", "NAVD88"])}
//                                                                 fullWidth
//                                                             />
//                                                         </Grid> 
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="dike_len"
//                                                                 label="Dike Length (max 20000)"
//                                                                 fullWidth
//                                                                 units="feet"
//                                                                 useNumberFormat3
//                                                                 maxValue={20000}
//                                                             />
//                                                         </Grid> 
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="dike_twidth"
//                                                                 label="Top Width (max 50)"
//                                                                 fullWidth
//                                                                 units="feet"
//                                                                 useNumberFormat3
//                                                                 maxValue={50}
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="dike_slopeint"
//                                                                 label="Side Slopes Interior"
//                                                                 fullWidth
//                                                                 units="H:1V"
//                                                             />
//                                                         </Grid> 
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="dike_slopeext"
//                                                                 label="Side Slopes Exterior"
//                                                                 fullWidth
//                                                                 units="H:1V"
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="dike_maxheight"
//                                                                 label="Maximum height"
//                                                                 fullWidth
//                                                                 units="feet tall"
//                                                                 useNumberFormat3      
//                                                             />
//                                                         </Grid> 
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="dike_maxelev"
//                                                                 label="Maximum Elevation"
//                                                                 fullWidth
//                                                                 units="feet msl"
//                                                                 useNumberFormat3 
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="dike_minheight"
//                                                                 label="Minimum height"
//                                                                 fullWidth
//                                                                 units="feet tall"
//                                                                 useNumberFormat3 
//                                                             />
//                                                         </Grid> 
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="dike_minelev"
//                                                                 label="Minimum elevation"
//                                                                 fullWidth
//                                                                 units="feet msl"
//                                                                 useNumberFormat3 
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <RadioGroup
//                                                                 field="dike_affect"
//                                                                 disabled={is_read_only}
//                                                                 fullWidth
//                                                                 options={[
//                                                                     { label: "Yes", value: "Yes" },
//                                                                     { label: "No", value: "No" },
//                                                                 ]}
//                                                                 alignment={true}
//                                                                 label="Dike will flood or adversely affect adjacent, upstream, or downstream landowners"
//                                                             />
//                                                         </Grid>

//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="dike_impact"
//                                                                 label="If yes, describe how impacts will be addressed"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid> 
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="dike_info"
//                                                                 label= "Additional Information for Dike / Levee project"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>
//                                                     </Grid>
//                                                 </AccordionDetails>
//                                             </Accordion>
//                                         </Grid>
//                                     )}       
//                                     {activeStep === 3 && projectType.length > 0 && projectType.find(t=>t==="Channel Stabilization / Restoration / Erosion Control / Shoreland Projects") && (   
//                                         <Grid item direction="row"  justifyContent="center" alignItems="center" classes={{ root: classes.root }}>
//                                            <Accordion defaultExpanded>
//                                                 <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: "#ddd" }}>
//                                                     <Typography variant="subtitle1" gutterBottom>
//                                                         Channel Stabilization / Restoration / Erosion Control / Shoreland Projects
//                                                     </Typography>
//                                                 </AccordionSummary>
//                                                 <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
//                                                     <Grid container spacing={2}>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <ReactSelect
//                                                                 label="Channel Stabilization / Restoration / Erosion Control / Shoreland Project Involves:"
//                                                                 field="ch_involves"
//                                                                 options={MAKE_OPTIONS([
//                                                                     "Project includes channel or streambank stabilization",
//                                                                     "Project includes river or stream restoration",
//                                                                     "Project lake shore stabilization"
//                                                                 ])}
//                                                                 disabled={is_read_only}
//                                                                 isMulti={true}
//                                                                 height="auto"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid>

//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="ch_info"
//                                                                 label="Additional Information for Channel Stabilization / Restoration / Erosion Control / Shoreland Project"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid> 
//                                                     </Grid>
//                                                 </AccordionDetails>
//                                             </Accordion>
//                                         </Grid>
//                                     )}

//                                     {activeStep === 3 && projectType.length > 0 && projectType.find(t=>t==="Land Development") && (   
//                                         <Grid item direction="row"  justifyContent="center" alignItems="center" classes={{ root: classes.root }}>
//                                            <Accordion defaultExpanded>
//                                                 <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: "#ddd" }}>
//                                                     <Typography variant="subtitle1" gutterBottom>
//                                                         Land Development
//                                                     </Typography>
//                                                 </AccordionSummary>
//                                                 <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
//                                                     <Grid container spacing={2}>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="l_prjacres"
//                                                                 label="Acres of project site:"
//                                                                 fullWidth
//                                                                 units="acres"
//                                                                 useNumberFormat3 
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="l_distacres"
//                                                                 label="Acres of land disturbance"
//                                                                 fullWidth
//                                                                 units="acres"
//                                                                 useNumberFormat3 
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <RadioGroup
//                                                                 field="l_stormsewer"
//                                                                 disabled={is_read_only}
//                                                                 fullWidth
//                                                                 options={[
//                                                                     { label: "Yes", value: "Yes" },
//                                                                     { label: "No", value: "No" },
//                                                                 ]}
//                                                                 alignment={true}
//                                                                 label="Project is a municipal storm sewer project"
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <RadioGroup
//                                                                 field="l_sansewer"
//                                                                 disabled={is_read_only}
//                                                                 fullWidth
//                                                                 options={[
//                                                                     { label: "Yes", value: "Yes" },
//                                                                     { label: "No", value: "No" },
//                                                                 ]}
//                                                                 alignment={true}
//                                                                 label="Project is a municipal sanitary sewer or lagoon project"
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <RadioGroup
//                                                                 field="l_runoff"
//                                                                 disabled={is_read_only}
//                                                                 fullWidth
//                                                                 options={[
//                                                                     { label: "Yes", value: "Yes" },
//                                                                     { label: "No", value: "No" },
//                                                                 ]}
//                                                                 alignment={true}
//                                                                 label="Project design incorporates stormwater ponding or other runoff reduction methods"
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="l_explain"
//                                                                 label="If not yes, explain why:"
//                                                                 fullWidth 
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="l_info"
//                                                                 label="Additional Information for Land Development Project"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid> 
//                                                     </Grid>
//                                                 </AccordionDetails>
//                                             </Accordion>
//                                         </Grid>
//                                     )}
//                                     {activeStep === 3 && projectType.length > 0 && projectType.find(t=>t==="Utility Installations") && (   
//                                         <Grid item direction="row"  justifyContent="center" alignItems="center" classes={{ root: classes.root }}>
//                                            <Accordion defaultExpanded>
//                                                 <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: "#ddd" }}>
//                                                     <Typography variant="subtitle1" gutterBottom>
//                                                         Utility Installation
//                                                     </Typography>
//                                                 </AccordionSummary>
//                                                 <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
//                                                     <Grid container spacing={2}>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <RadioGroup
//                                                                 field="u_buried"
//                                                                 disabled={is_read_only}
//                                                                 fullWidth
//                                                                 options={[
//                                                                     { label: "Yes", value: "Yes" },
//                                                                     { label: "No", value: "No" },
//                                                                 ]}
//                                                                 alignment={true}
//                                                                 label="Utility is buried"
//                                                             />
//                                                         </Grid>

//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="u_selected"
//                                                                 label="If yes, what is depth of cover over top of utility? (minimum depth is 48 inches below waterways and ditches)"
//                                                                 fullWidth
//                                                                 units="inches"
//                                                                 useNumberFormat3
//                                                             />
//                                                         </Grid>
//                                                         <Grid item xs={12} md={6} xl={4}>
//                                                             <TextField
//                                                                 disabled={is_read_only}
//                                                                 field="u_info"
//                                                                 label="Additional Information for Utility Installation Project"
//                                                                 fullWidth
//                                                             />
//                                                         </Grid> 
//                                                     </Grid>
//                                                 </AccordionDetails>
//                                             </Accordion>
//                                         </Grid>
//                                     )}

//                                     {activeStep === "PRINT" && (
//                                         <Grid item xs={12} xl={10} classes={{ root: classes.root }}>
//                                             <Divider className={classes.printDivider} />
//                                         </Grid>
//                                     )}
//                                     {activeStep === 4 && ( 
//                                         <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                             <Typography variant="subtitle1">Attachments</Typography>
//                                             <Typography gutterBottom>

//                                                 Please attached all electronic files associated with your applications. If document is not available for upload, 
//                                                 it shall be emailed to the BRRWD at <a
//                                                                 target="_blank"
//                                                                 rel="noopener noreferrer"
//                                                                 href='mailto:permits@brrwd.org'>
//                                                                 permits@brrwd.org
//                                                             </a>{" "}. Application will not be reviewed or considered complete until appropriate documents have been submitted. 
//                                                 Below is the list of expected documents and the information those documents should contain
//                                             </Typography>
//                                             <Button
//                                                 onClick={() =>
//                                                     this.setState({
//                                                         attachmentDialogOpen: true,
//                                                         attachmentEditing: null,
//                                                         attachmentFormKey: window.performance.now(),
//                                                     })
//                                                 }
//                                                 disabled={is_read_only}
//                                                 variant="contained"
//                                                 color="primary">
//                                                 Add Attachment
//                                             </Button>
//                                             <Table style={{ marginTop: 8 }}>
//                                                 <EnhancedTableHead
//                                                     columnData={columnDataAttachments}
//                                                     order={attachmentOrder}
//                                                     orderBy={attachmentOrderBy}
//                                                     onRequestSort={this.handleRequestSort2}
//                                                 />
//                                                 <TableBody>
//                                                     {temp_attachments.map((n,idx) => {
//                                                         return (
//                                                             <TableRow key={idx} hover>
//                                                                 <CustomTableCell className={classes.nowrap}>
//                                                                     {n.file.includes("https") && (
//                                                                         <Tooltip title="Open Link">
//                                                                             <Button
//                                                                                 color="primary"
//                                                                                 onClick={() => {
//                                                                                     window.open(n.file);
//                                                                                 }}
//                                                                                 className={classes.deleteWidth}>
//                                                                                 <ViewIcon color="primary" />
//                                                                             </Button>
//                                                                         </Tooltip>
//                                                                     )}
//                                                                     <Tooltip title="Delete">
//                                                                         <Button
//                                                                             color="primary"
//                                                                             onClick={() =>
//                                                                                 this.setState({
//                                                                                     temp_attachments: temp_attachments.filter((tc) => tc !== n),
//                                                                                 })
//                                                                             }
//                                                                             disabled={is_read_only}
//                                                                             className={classes.deleteWidth}>
//                                                                             <DeleteIcon color="primary" />
//                                                                         </Button>
//                                                                     </Tooltip>
//                                                                 </CustomTableCell>
//                                                                 <CustomTableCell>{n.name}</CustomTableCell>
//                                                                 <CustomTableCell>{n._type}</CustomTableCell>
//                                                                 <CustomTableCell>{n.notes}</CustomTableCell>
//                                                             </TableRow>
//                                                         );
//                                                     })}
//                                                     {temp_attachments.length < 1 && (
//                                                         <TableRow>
//                                                             <CustomTableCell colSpan={columnDataAttachments.length} className={classes.centerAlign}>
//                                                                 No Attachments Added
//                                                             </CustomTableCell>
//                                                         </TableRow>
//                                                     )}
//                                                 </TableBody>
//                                             </Table>
//                                         </Grid>

//                                     )}
//                                     {activeStep === 4 && attachmentTypes.length > 0 && attachmentTypes.find(a=>a.includes("Tiling")) && ( 
//                                          <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                             <Accordion expanded>
//                                                 <AccordionSummary style={{ backgroundColor: "#ddd" }}>
//                                                     <Typography variant="subtitle1" gutterBottom>
//                                                     <b>Tiling Documents to Upload:</b>
//                                                     </Typography>
//                                                 </AccordionSummary>
//                                                 <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
//                                                     <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                                         <Typography variant="subtitle1" gutterBottom>
//                                                             1.) Site Map must include: <br/> 
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             a.) Location of tile lines.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             b.) Size of tile.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             c.) Location of outlets(s).
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             d.) Location of lift station(s).
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             e.) Location of surface inlet(s).
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             f.) Location of other special features
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             g.) Receiving waters.
//                                                             <br/>
//                                                         </Typography>
//                                                         <Typography variant="subtitle1" gutterBottom>
//                                                             2.) Downstream Landowner Notification, if applicable. 
//                                                         </Typography>
//                                                     </Grid>
//                                                 </AccordionDetails>
//                                             </Accordion>
//                                         </Grid>
//                                     )}
//                                     {activeStep === 4 && attachmentTypes.length > 0 && attachmentTypes.find(a=>a.includes("Surface")) && ( 
//                                         <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                             <Accordion expanded>
//                                                 <AccordionSummary style={{ backgroundColor: "#ddd" }}>
//                                                     <Typography variant="subtitle1" gutterBottom>
//                                                         <b>Surface Drainage (New Ditch or Improvement) Documents to Upload:</b>
//                                                     </Typography>
//                                                 </AccordionSummary>
//                                                 <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
//                                                     <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                                         <Typography variant="subtitle1" gutterBottom>
//                                                             1.) Site Map must include:<br/> 
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             a.) Location of existing and proposed ditch.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             b.) Location of spoil pile.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             c.) Location of outlet.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             d.) Location of other special features.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             e.) Receiving waters.     <br/>
//                                                         </Typography>
//                                                         <Typography variant="subtitle1" gutterBottom>
//                                                              2.) Downstream Landowner Notification, if applicable. 
//                                                         </Typography>
//                                                     </Grid>
//                                                 </AccordionDetails>
//                                             </Accordion>
//                                         </Grid>
//                                     )}
//                                     {activeStep === 4 && attachmentTypes.length > 0 && attachmentTypes.find(a=>a.includes("Culvert")) && ( 
//                                         <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                             <Accordion expanded>
//                                                 <AccordionSummary style={{ backgroundColor: "#ddd" }}>
//                                                     <Typography variant="subtitle1" gutterBottom>
//                                                         <b>Culvert Installation Documents to Upload:</b>
//                                                     </Typography>
//                                                 </AccordionSummary>
//                                                 <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
//                                                     <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                                         <Typography variant="subtitle1" gutterBottom>
//                                                             1.) Site Map must include:<br/> 
//                                                         </Typography> 
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             a.) Location of existing and proposed culverts .
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             b.) Size of existing and proposed culverts.   <br/>
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             c.) Location of upstream and downstream culverts and bridges.   <br/>
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             d.) Size of upstream and downstream culverts and bridges.   <br/>
//                                                         </Typography>
//                                                         <Typography variant="subtitle1" gutterBottom>
//                                                              2.) Downstream Landowner Notification, if applicable. 
//                                                         </Typography>
//                                                     </Grid>
//                                                 </AccordionDetails>
//                                             </Accordion>
//                                         </Grid>
//                                     )}
//                                     {activeStep === 4 && attachmentTypes.length > 0 && attachmentTypes.find(a=>a.includes("Bridge")) && ( 
//                                         <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                             <Accordion expanded>
//                                                 <AccordionSummary style={{ backgroundColor: "#ddd" }}>
//                                                     <Typography variant="subtitle1" gutterBottom>
//                                                         <b>Bridge Installation Documents to Upload:</b>
//                                                     </Typography>
//                                                 </AccordionSummary>
//                                                 <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
//                                                     <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                                         <Typography variant="subtitle1" gutterBottom>
//                                                             1.) Site Map must include:<br/> 
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             a.) Location of existing and proposed culverts.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             b.) Size of existing and proposed culverts.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             c.) Location of upstream and downstream culverts and bridges.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             d.) Size of upstream and downstream culverts and bridges.
//                                                         </Typography>

//                                                         <Typography variant="subtitle1" gutterBottom>
//                                                             2.) Hydraulic analysis showing existing and proposed hydraulic conditions. 
//                                                         </Typography>
//                                                         <Typography variant="subtitle1" gutterBottom>
//                                                             3.) Size, type, location of adjacent upstream and downstream structures. 
//                                                         </Typography>
//                                                         <Typography variant="subtitle1" gutterBottom>
//                                                             4.) Maximum previously observed highwater elevation at site and time frame
//                                                         </Typography>
//                                                         <Typography variant="subtitle1" gutterBottom>
//                                                             5.) Detailed project construction plans with profile, cross sections, plan views, details. 
//                                                         </Typography>
//                                                     </Grid>
//                                                 </AccordionDetails>
//                                             </Accordion>
//                                         </Grid>
//                                     )}
//                                     {activeStep === 4 && attachmentTypes.length > 0 && attachmentTypes.find(a=>a.includes("Wetland")) && ( 
//                                         <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                             <Accordion expanded>
//                                                 <AccordionSummary style={{ backgroundColor: "#ddd" }}>
//                                                     <Typography variant="subtitle1" gutterBottom>
//                                                         <b>Wetland Restoration Documents to Upload:</b>
//                                                     </Typography>
//                                                 </AccordionSummary>
//                                                 <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
//                                                     <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                                         <Typography variant="subtitle1" gutterBottom>
//                                                             1.) Detailed project construction plans.<br/> 
//                                                         </Typography>
//                                                         <Typography variant="subtitle1" gutterBottom>
//                                                             2.) Site Map must include:<br/> 
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             a.) Location of proposed wetland basins, water retention areas.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             b.) Locations of ditch plugs, scrapes, embankments, other related features.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             c.) Property lines.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             d.) Maximum pool elevation boundaries.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             e.) Top of structure elevation.   <br/>
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             f.) Location of proposed tile lines.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             g.) Location of outlet structure(s).
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             h.) Location of other special features.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             i.) Receiving waters.   <br/>
//                                                         </Typography>

//                                                     </Grid>
//                                                 </AccordionDetails>
//                                             </Accordion>
//                                         </Grid>
//                                     )}
//                                     {activeStep === 4 && attachmentTypes.length > 0 && attachmentTypes.find(a=>a.includes("Road")) && ( 
//                                         <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                             <Accordion expanded>
//                                                 <AccordionSummary style={{ backgroundColor: "#ddd" }}>
//                                                     <Typography variant="subtitle1" gutterBottom>
//                                                         <b>Road Grading Documents to Upload:</b>
//                                                     </Typography>
//                                                 </AccordionSummary>
//                                                 <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
//                                                     <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                                         <Typography variant="subtitle1" gutterBottom>
//                                                             1.) Site Map must include:<br/> 
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             a.) Location of existing and proposed ditch.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             b.) Location of spoil pile.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             c.) Location of outlet(s).
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             d.) Location of existing and proposed culverts and bridges.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             e.) Size of existing and proposed culverts and brides.   <br/>
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             f.) Location of upstream and downstream culverts and bridges.   <br/>
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             g.) Size of upstream and downstream culverts and bridges.   <br/>
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             h.) Location of proposed wetland basins, water retention areas.   <br/>
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             i.) Locations of ditch plugs, scrapes, embankments, other related features.   <br/>
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             j.) Property lines.   <br/>
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             k.) Maximum pool elevation boundaries.   <br/>
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             l.) Location of proposed tile lines.   <br/>
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             m.) Location of other special features.   <br/>
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             n.) Receiving waters.  <br/>
//                                                         </Typography>
//                                                         <Typography variant="subtitle1" gutterBottom>
//                                                              2.) Downstream Landowner Notification, if applicable. 
//                                                         </Typography>
//                                                     </Grid>
//                                                 </AccordionDetails>
//                                             </Accordion>
//                                         </Grid>
//                                     )}
//                                     {activeStep === 4 && attachmentTypes.length > 0 && attachmentTypes.find(a=>a.includes("Dike")) && ( 
//                                         <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                             <Accordion expanded>
//                                                 <AccordionSummary style={{ backgroundColor: "#ddd" }}>
//                                                     <Typography variant="subtitle1" gutterBottom>
//                                                         <b>Dike Documents to Upload:</b>
//                                                     </Typography>
//                                                 </AccordionSummary>
//                                                 <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
//                                                     <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                                         <Typography variant="subtitle1" gutterBottom>
//                                                             1.) Detailed construction plans.<br/> 
//                                                         </Typography>
//                                                         <Typography variant="subtitle1" gutterBottom>
//                                                             2.) Site Map must include:<br/> 
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             a.) Location of proposed dike.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             b.) Elevation of proposed dike.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             c.) Location of other special features.
//                                                         </Typography>

//                                                     </Grid>
//                                                 </AccordionDetails>
//                                             </Accordion>
//                                         </Grid>
//                                     )}
//                                     {activeStep === 4 && attachmentTypes.length > 0 && attachmentTypes.find(a=>a.includes("Channel")) && ( 
//                                         <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                             <Accordion expanded>
//                                                 <AccordionSummary style={{ backgroundColor: "#ddd" }}>
//                                                     <Typography variant="subtitle1" gutterBottom>
//                                                         <b>Channel Stabilization Documents to Upload:</b>
//                                                     </Typography>
//                                                 </AccordionSummary>
//                                                 <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
//                                                     <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                                         <Typography variant="subtitle1" gutterBottom>
//                                                             1.) Detailed project plans.<br/> 
//                                                         </Typography>
//                                                         <Typography variant="subtitle1" gutterBottom>
//                                                             2.) Site Map, must include:<br/> 
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             a.) Location of proposed work.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             b.) Location of other special features.
//                                                         </Typography> 
//                                                     </Grid>
//                                                 </AccordionDetails>
//                                             </Accordion>
//                                         </Grid>
//                                     )}
//                                     {activeStep === 4 && attachmentTypes.length > 0 && attachmentTypes.find(a=>a.includes("Land Dev")) && ( 
//                                         <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                             <Accordion expanded>
//                                                 <AccordionSummary style={{ backgroundColor: "#ddd" }}>
//                                                     <Typography variant="subtitle1" gutterBottom>
//                                                         <b>Land Documents to Upload:</b>
//                                                     </Typography>
//                                                 </AccordionSummary>
//                                                 <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
//                                                     <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                                         <Typography variant="subtitle1" gutterBottom>
//                                                             1.) Detailed construction plans.<br/> 
//                                                         </Typography>
//                                                         <Typography variant="subtitle1" gutterBottom>
//                                                             2.) Site Map, must include:<br/> 
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             a.) Location of proposed work.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             b.) Location of other special features.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             c.) Receiving waters.
//                                                         </Typography>  
//                                                         <Typography variant="subtitle1" gutterBottom>
//                                                             3.) Stormwater Report showing modeling results of pond design.<br/> 
//                                                         </Typography>
//                                                         <Typography variant="subtitle1" gutterBottom>
//                                                             4.) Stormwater Pollution Prevention Plan (SWPPP).<br/> 
//                                                         </Typography> 
//                                                     </Grid>
//                                                 </AccordionDetails>
//                                             </Accordion>
//                                         </Grid>
//                                     )}
//                                     {activeStep === 4 && attachmentTypes.length > 0 && attachmentTypes.find(a=>a.includes("Stormwater")) && ( 
//                                         <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                             <Accordion expanded>
//                                                 <AccordionSummary style={{ backgroundColor: "#ddd" }}>
//                                                     <Typography variant="subtitle1" gutterBottom>
//                                                         <b>Stormwater Documents to Upload:</b>
//                                                     </Typography>
//                                                 </AccordionSummary>
//                                                 <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
//                                                     <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                                         <Typography variant="subtitle1" gutterBottom>
//                                                             1.) Site Map must include:<br/> 
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             a.) Location of existing and proposed ditch.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             b.) Location of spoil pile.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             c.) Location of outlet.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             d.) Location of other special features.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             e.) Receiving waters.     <br/>
//                                                         </Typography>
//                                                         <Typography variant="subtitle1" gutterBottom>
//                                                              2.) Downstream Landowner Notification, if applicable. 
//                                                         </Typography>
//                                                     </Grid>
//                                                 </AccordionDetails>
//                                             </Accordion>
//                                         </Grid>
//                                     )}
//                                     {activeStep === 4 && attachmentTypes.length > 0 && attachmentTypes.find(a=>a.includes("Utility")) && ( 
//                                         <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                             <Accordion expanded>
//                                                 <AccordionSummary style={{ backgroundColor: "#ddd" }}>
//                                                     <Typography variant="subtitle1" gutterBottom>
//                                                         <b>Utility Documents to Upload:</b>
//                                                     </Typography>
//                                                 </AccordionSummary>
//                                                 <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
//                                                     <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                                         <Typography variant="subtitle1" gutterBottom>
//                                                             1.) Detailed project plans.<br/> 
//                                                         </Typography>
//                                                         <Typography variant="subtitle1" gutterBottom>
//                                                             2.) Site Map, must include:<br/> 
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             a.) Location of proposed work.
//                                                         </Typography>
//                                                         <Typography gutterBottom style={{ marginLeft: 9 }}>
//                                                             b.) Location of other special features.
//                                                         </Typography> 
//                                                     </Grid>
//                                                 </AccordionDetails>
//                                             </Accordion>
//                                         </Grid>
//                                     )}

//                                     {activeStep === "PRINT" && (
//                                         <Grid item xs={12} xl={10} classes={{ root: classes.root }}>
//                                             <Divider className={classes.printDivider} />
//                                         </Grid>
//                                     )}
//                                     {activeStep === 5 && (
//                                         <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
//                                             <Typography variant="subtitle1" gutterBottom>
//                                                 <b>I understand:</b>
//                                             </Typography>
//                                             <table>
//                                                 {" "}
//                                                 <tr>
//                                                     <td>
//                                                         <Typography gutterBottom style={{marginBottom:3, marginLeft:3}}>
//                                                             1. Submitting this application in no way relieves the applicant or landowner from any 
//                                                             responsibility or liability resulting from the construction, operation, or failure of the project.
//                                                         </Typography> 
//                                                     </td>
//                                                 </tr>
//                                                 <tr>
//                                                     <td>
//                                                         <Typography gutterBottom style={{marginBottom:3, marginLeft:3}}>
//                                                             2. The project may be field reviewed prior to the Board Meeting. 
//                                                             The applicant grants permission to the BRRWD and their representatives to review the work area within the permit application.
//                                                         </Typography> 
//                                                     </td>
//                                                 </tr> 
//                                                 <tr>
//                                                     <td>
//                                                         <Typography gutterBottom style={{marginBottom:3, marginLeft:3}}>
//                                                             3. The application must be considered complete a minimum of 10 days prior to the Regular Board
//                                                             Meeting to be considered. BRRWD staff will contact you within 15 days if additional information is required.
//                                                         </Typography> 
//                                                     </td>
//                                                 </tr> 
//                                                 <tr>
//                                                     <td>
//                                                         <Typography gutterBottom style={{marginBottom:3, marginLeft:3}}>
//                                                             4. The requirements of the Permit Rules of the BRRWD. (A copy of the rules can be found at brrwd.org).
//                                                         </Typography> 
//                                                     </td>
//                                                 </tr> 
//                                                 <tr>
//                                                     <td>
//                                                         <Typography gutterBottom style={{marginBottom:3, marginLeft:3}}>
//                                                             5. This permit does not relieve the applicant of any requirements of other permits which may be necessary 
//                                                             from any other permitting agency.
//                                                         </Typography> 
//                                                     </td>
//                                                 </tr> 
//                                                 <tr>
//                                                     <td>
//                                                         <Typography gutterBottom style={{marginBottom:3, marginLeft:3}}>
//                                                             6. I acknowledge by submitting this permit application is equivalent to my manual/handwritten signature.
//                                                         </Typography> 
//                                                     </td>
//                                                 </tr>  
//                                             </table>
//                                             <table>
//                                                 <tr>
//                                                     <td style={{ whiteSpace: "nowrap", paddingRight: 16 }}>
//                                                         <Checkbox disabled={is_read_only} label="I AGREE *" field="understand1" />
//                                                     </td>
//                                                     <td>
//                                                         <Typography gutterBottom style={{marginBottom:0}}>
//                                                             In checking this box, I acknowledge the above statements.
//                                                         </Typography> 
//                                                     </td>
//                                                 </tr> 
//                                             </table>
//                                         </Grid>
//                                     )}
//                                     {activeStep !== "PRINT" && (
//                                         <Grid item xs={12} xl={10} className={classes.rightAlign} classes={{ root: classes.root }}>
//                                             <Button
//                                                 disabled={activeStep === 0}
//                                                 onClick={() => this.setState({ activeStep: activeStep - 1 })}
//                                                 className={classes.button}>
//                                                 Back
//                                             </Button>
//                                             <Button
//                                                 onClick={() => this.handleNext()}
//                                                 disabled={is_read_only && activeStep === 5}
//                                                 variant="contained"
//                                                 color="primary"
//                                                 style={{ marginLeft: 16 }}>
//                                                 {activeStep === 5 ? "Submit Permit Application" : "Next"}
//                                             </Button>
//                                             {/* <Button
//                                                 style={{ marginLeft: 16 }}
//                                                 onClick={() => {
//                                                     return (
//                                                         // this.setState({ activeStep: "PRINT" }),
//                                                         window.open("/reports/application/" + application.hash)
//                                                     );
//                                                 }}
//                                                 variant="contained"
//                                                 color="primary">
//                                                 Print
//                                             </Button> */}
//                                         </Grid>
//                                     )}
//                                 </Grid>
//                             </>
//                         </form>
//                     )}
//                 </Form>
//                 <Dialog open={attachmentDialogOpen} classes={{ paper: classes.minWidth, overflowX:"none" }}>
//                     <Toolbar>
//                         <Typography variant="h6" className={classes.flex}>
//                             Attachment
//                         </Typography>
//                         <IconButton aria-label="Close Dialog" onClick={() => this.setState({ attachmentDialogOpen: false })}>
//                             <Close />
//                         </IconButton>
//                     </Toolbar>
//                     <DialogContent className={classes.dialogMin}>
//                         <DialogContentText>
//                             <Form
//                                 dontValidateOnMount={true}
//                                 validateOnSubmit={true}
//                                 key={attachmentFormKey}
//                                 defaultValues={attachmentEditing}
//                                 validateError={this.errorValidatorAttachment}
//                                 onSubmit={(values) => this.addAttachment(values)}>
//                                 {(formApi) => (
//                                     <form onSubmit={formApi.submitForm}>
//                                         <Grid container spacing={2}>
//                                             <Grid item xs={12} md={6} xl={4}>
//                                                 <Typography gutterBottom>
//                                                     Only these file types can be directly uploaded as an attachment. All other file types should be
//                                                     put into a .zip file and then uploaded. Direct supported file types are: PDF (.pdf), Microsoft
//                                                     Word (.doc, .docx), Microsoft Excel (.xls, .xlsx), Images (.png, .jpg, .jpeg, .tiff, .bmp),
//                                                     Microsoft Powerpoint (.ppt, .pptx), Zip files (.zip).
//                                                 </Typography>
//                                                 <FileInput field="file" id="file_upl" fullWidth label="File *" />
//                                             </Grid>
//                                             <Grid item xs={12} md={6} xl={4}>
//                                                 <TextField field="name" label="Name *" fullWidth />
//                                             </Grid>
//                                             <Grid item xs={12} md={6} xl={4}>
//                                                 <Select
//                                                     field="_type"
//                                                     label="Type"
//                                                     options={MAKE_OPTIONS(["Site Map", "Downstream Landownder Notification", "Engineer's Report", "Detailed Construction Plans",
//                                                             "Stormwater Report Showing MOdeling Results of Pond Design", "Stormwater Pollution Prevention Plan (SWPPP)", "Detailed Project Plans",
//                                                             "Photo", "Other"])}
//                                                     fullWidth
//                                                 />
//                                             </Grid>
//                                             <Grid item xs={12} md={6} xl={4}>
//                                                 <TextField field="notes" label="Notes" fullWidth />
//                                             </Grid>
//                                             <Grid item xs={12} md={6} xl={4}>
//                                                 <Button fullWidth onClick={() => this.setState({ attachmentDialogOpen: false })}>
//                                                     Cancel
//                                                 </Button>
//                                             </Grid>
//                                             <Grid item xs={12} md={6} xl={4}>
//                                                 <Button fullWidth type="submit" variant="contained" color="primary">
//                                                     Save
//                                                 </Button>
//                                             </Grid>
//                                         </Grid>
//                                     </form>
//                                 )}
//                             </Form>
//                         </DialogContentText>
//                     </DialogContent>
//                 </Dialog>
//                 <Dialog open={culvertDialogOpen} classes={{ paper: classes.minWidth }}>
//                     <Toolbar>
//                         <Typography variant="h6" className={classes.flex}>
//                             Add Culvert
//                         </Typography>


//                         <IconButton aria-label="Close Dialog" onClick={() => this.setState({ culvertDialogOpen: false })}>
//                             <Close />
//                         </IconButton>
//                     </Toolbar>
//                     <Toolbar>
//                         <Typography variant="h7" className={classes.flex} style={{marginTop:-10}}>
//                             Note: If existing culvert is arch pipe or box culvert please include dimensions in Additional Information.
//                         </Typography>
//                     </Toolbar>
//                     <DialogContent className={classes.dialogMin}>
//                         <DialogContentText>
//                             <Form
//                                 dontValidateOnMount={true}
//                                 validateOnSubmit={true}
//                                 key={formKey}
//                                 defaultValues={culvertEditing}
//                                 validateError={this.errorValidatorCulvert}
//                                 onSubmit={(values) => this.addCulvert(values)}>
//                                 {(formApi) => (
//                                     <form onSubmit={formApi.submitForm}>
//                                         <Grid container spacing={2}>
//                                             <Grid item xs={12} md={6} xl={4}>
//                                                 <TextField disabled={is_read_only}  field="name" label="Culvert Name or ID" fullWidth />
//                                             </Grid>
//                                             <Grid item xs={12} md={6} xl={4}>
//                                                 <TextField  disabled={is_read_only} field="e_size" label="Existing culvert size" fullWidth units="inches" useNumberFormat3/>
//                                             </Grid>
//                                             <Grid item xs={12} md={6} xl={4}>
//                                                 <TextField  disabled={is_read_only} field="e_length" label="Existing culvert length" fullWidth units="feet" useNumberFormat3 />
//                                             </Grid>
//                                             <Grid item xs={12} md={6} xl={4}>
//                                                 <TextField  disabled={is_read_only} field="e_elevation" label="Existing culvert elevation" fullWidth units="feet" useNumberFormat3/>
//                                             </Grid>
//                                             <Grid item xs={12} md={6} xl={4}>
//                                                 <TextField  disabled={is_read_only} field="p_size" label="Proposed culvert size" fullWidth units="inches" useNumberFormat3/>
//                                             </Grid>
//                                             <Grid item xs={12} md={6} xl={4}>
//                                                 <TextField  disabled={is_read_only} field="p_length" label="Proposed culvert length" fullWidth units="feet" useNumberFormat3/>
//                                             </Grid>
//                                             <Grid item xs={12} md={6} xl={4}>
//                                                 <TextField  disabled={is_read_only} field="p_elevation" label="Proposed culvert elevation" fullWidth units="feet" useNumberFormat3/>
//                                             </Grid>
//                                             <Grid item xs={12} md={6} xl={4}>
//                                                 <TextField  disabled={is_read_only} field="additional" label="Additional information about culvert" fullWidth />
//                                             </Grid>
//                                             <Grid item xs={12} md={6} xl={4}>
//                                                 <RadioGroup
//                                                     disabled={is_read_only}
//                                                     field="cul_road_involves"
//                                                     label="Does Project Involve Road Grading that will modify elevations?"
//                                                     fullWidth
//                                                     options={[
//                                                         { label: "Yes", value: "Yes" },
//                                                         { label: "No", value: "No" },
//                                                     ]}
//                                                     alignment={true}
//                                                 />
//                                             </Grid> 
//                                             <Grid item xs={12} md={6} xl={4}>
//                                                 <TextField
//                                                     disabled={is_read_only}
//                                                     field="cul_road_elev"
//                                                     label="If Project modifies road elevations, please describe proposed elevations?"
//                                                     fullWidth
//                                                 />
//                                             </Grid>                                     
//                                             <Grid item xs={6}/>
//                                             <Grid item xs={6}/>
//                                             <Grid item xs={12} md={6} xl={4}>
//                                                 <Button  fullWidth onClick={() => this.setState({ culvertDialogOpen: false })}>
//                                                     Cancel
//                                                 </Button>
//                                             </Grid>
//                                             <Grid item xs={12} md={6} xl={4}>
//                                                 <Button  disabled={is_read_only} fullWidth type="submit" variant="contained" color="primary">
//                                                     Save
//                                                 </Button>
//                                             </Grid>
//                                         </Grid>
//                                     </form>
//                                 )}
//                             </Form>
//                         </DialogContentText>
//                     </DialogContent>
//                 </Dialog>
//             </AppContainerApplication>
//         );
//     }
// }

// BRRWD = connect(
//     (state, ownProps) => ({ 
//         authState: state.auth, // Admins will have an authstate
//     }),
//     {
//         ...ApplicationRecord.actions,
//         ...ApplicationRecordStatus.actions,
//         ...BRRWDPermit.actions,
//         ...BRRWDCulvert.actions,
//         ...BRRWDAttachment.actions
//     }
// )(BRRWD);

// const withMediaQuery = (...args) => Component => props => {
//     const mediaQuery = useMediaQuery(...args);
//     return <Component mediaQuery={mediaQuery} {...props} />;
// };

// export default withStyles(styles)(withMediaQuery('(min-width:960px)')(withRouter(BRRWD)));






import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Form } from "react-form";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import IconButton from "@material-ui/core/IconButton";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepButton from "@material-ui/core/StepButton";
import Dialog from "@material-ui/core/Dialog";
import Divider from "@material-ui/core/Divider";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import Accordion from "@material-ui/core/Accordion";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Toolbar from "@material-ui/core/Toolbar";
import { withStyles } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import EditIcon from "@material-ui/icons/Edit";
import ViewIcon from "@material-ui/icons/Visibility";
import Close from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";
import MobileStepper from "@material-ui/core/MobileStepper";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import useMediaQuery from "@material-ui/core/useMediaQuery";
// import { InputLabel } from '@material-ui/core';
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import AppContainerApplication from "../../common/AppContainerApplication";
import states from "../../common/states.json";
import CustomTableCell from "../../common/TableCell";
import { ApplicationRecord, ApplicationRecordStatus, BRRWDPermit, BRRWDCulvert, BRRWDAttachment } from "../../page/models";


// import HelpLabel from "../../common/HelpLabel";
import AccHelpLabel from "../../common/commonAccessability/accessabilityHelpLabel.js";
// import Checkbox from "../../common/Checkbox";
import AccCheckbox from "../../common/commonAccessability/accessabilityCheckbox.js";
// import EnhancedTableHead from "../../common/EnhancedTableHead";
import AccessabilityEnhancedTableHead from "../../common/commonAccessability/accessabilityEnhancedTableHead";
// import TextField from "../../common/TextField";
import AccTextField from "../../common/commonAccessability/accessabilityTextField.js";
// import Select from "../../common/Select";
import AccessabilitySelect from "../../common/commonAccessability/accessabilitySelect.js";
// import CheckboxGroup from "../../common/CheckboxGroup";
import AccFppCheckboxGroup from "../../common/commonAccessability/accessabilityCheckboxGroup.js";
// import RadioGroup from "../../common/RadioGroup";
import RadioGroup from "../../common/commonAccessability/accessabilityRadioGroup.js";
// import ReactSelect from "../../common/ReactSelect";
import AccReactSelect from "../../common/commonAccessability/accessabilityReactSelect.js";
import { im } from "mathjs/lib/entry/pureFunctionsAny.generated.js";

// import FileInput from "../../common/FileInput";  
import AccFileInput from "../../common/commonAccessability/accessabilityFileIndex.js";




const styles = (theme) => ({
    deleteWidth: {
        minWidth: 34,
        width: 34,
        marginRight: 8,
        marginTop: 2,
        marginBottom: 2,
    },
    centerAlign: {
        textAlign: "center",
    },
    centerAlign2: {
        textAlign: "center",
        display: "inline-block",
        width: "100%",
    },
    nowrap: {
        whiteSpace: "nowrap",
    },
    rightAlign: {
        textAlign: "right",
        marginRight: 15,
    },
    flex: {
        flex: 1,
    },
    printDivider: {
        height: 8,
        backgroundColor: "rgba(0, 0, 0, 0.42)",
        marginTop: 16,
        marginBottom: 8,
    },
    dialogMin: {
        minWidth: 330,
    },
    minWidth: {
        minWidth: 380,
    },
    root: {
        flexBasis: "100%",
        maxWidth: "100%",
    },
    heading2: {
        fontSize: theme.typography.pxToRem(17),
        fontWeight: theme.typography.fontWeightRegular,
        display: "flex",
    },
    titlePanel: {
        minHeight: "auto !important",
    },
    expandedMargin: {
        marginTop: "12px",
    },
    disabledField: {
        backgroundColor: '#f5f5f5',
        color: 'rgba(0, 0, 0, 0.65)',
        '& .MuiOutlinedInput-root.Mui-disabled': {
            backgroundColor: '#f5f5f5',
            color: 'rgba(0, 0, 0, 0.65)',
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(0, 0, 0, 0.23) !important',
        },
    },
    buttonClass: {
        color: "white",
        backgroundColor: "#2845D6",
    },

    modalStyle: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-around",
        padding: theme.spacing(2),
    },

    backbuttonClass: {
        color: "#2845D6",
        borderColor: "#2845D6"
    },
    stepperRoot: {
        "& .MuiStepIcon-root": {
            color: "#e0e0e0",
        },
        "& .MuiStepIcon-text": {
            fill: "#212121",
            fontWeight: 600,
        },
        "& .MuiStepIcon-root.MuiStepIcon-active": {
            color: "#2845D6",
        },
        "& .MuiStepIcon-root.MuiStepIcon-active .MuiStepIcon-text": {
            fill: "#ffffff",
        },
        "& .MuiStepIcon-root.MuiStepIcon-completed": {
            color: "#2845D6",
        },
        "& .MuiStepIcon-root.MuiStepIcon-completed .MuiStepIcon-text": {
            fill: "#ffffff",
        },
        "& .MuiStepLabel-label": {
            color: "#3d3d3d",
        },
        "& .MuiStepLabel-label.MuiStepLabel-active": {
            fontWeight: 600,
        },
        "& .MuiStepLabel-root.Mui-error .MuiStepLabel-label": {
            color: "#c62828",
            fontWeight: 600,
        },
    },
});

function MAKE_OPTIONS(table) {
    return table.map((row) => ({
        label: row,
        value: row,
    }));
}



class BRRWD extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeStep: 0,
            culvertDialogOpen: false,
            culvertEditing: null,
            formKey: null,
            order: "desc",
            orderBy: null,
            temp_contacts: [],
            attachmentDialogOpen: false,
            attachmentEditing: null,
            attachmentFormKey: null,
            attachmentOrder: "desc",
            attachmentOrderBy: null,
            temp_attachments: [],
            loading: false,
            new_save: false,
            new_save2: false,
            mainFormKey: window.performance.now(),
            entryError: false,
            projectType: [],
            selectLegal: false,
            tempCulverts: [],
            culvertFormKey: null,
            application: null

        };
    }

    componentDidMount() {
        const { match, ormBRRWDPermitLoadDetailChild, ormBRRWDAttachmentLoadDetailChild, ormBRRWDCulvertLoadDetailChild } = this.props;
        var component = this;


        if (match.params && match.params.hash) {
            ormBRRWDPermitLoadDetailChild(match.params.hash, function (wtf) {
                component.setState({ mainFormKey: window.performance.now(), projectType: wtf[0].project_types, application: wtf[0] });
            });
            ormBRRWDCulvertLoadDetailChild(match.params.hash, function (data) {
                component.setState({ tempCulverts: data });
            });
            ormBRRWDAttachmentLoadDetailChild(match.params.hash, function (data) {
                component.setState({ temp_attachments: data });
            });
        }
        // if (match.params && match.params.print) {
        //     component.setState({ activeStep: "PRINT" });
        // }
    }

    errorValidator = (values) => {
        const isRequired = (val) => {
            return !val ? "Required" : null;
        };

        var valObj = {
            appl_first_name: isRequired(values.appl_first_name),
            appl_last_name: isRequired(values.appl_last_name),
            appl_phone: isRequired(values.appl_phone),
            project_types: isRequired(values.project_types),
            county: isRequired(values.county),
            project_description: isRequired(values.project_description),
            project_township: isRequired(values.project_township),
            section: isRequired(values.section),
            understand1: isRequired(values.understand1),
        };

        var alerts = "";
        var ai = 6;
        if (valObj["appl_first_name"] === "Required") {
            alerts += "Applicant First Name (Step 2)\n";
            ai = 1;
        }
        if (valObj["appl_last_name"] === "Required") {
            alerts += "Applicant Last Name (Step 2)\n";
            ai = 1;
        }
        if (valObj["appl_phone"] === "Required") {
            alerts += "Applicant Phone  (Step 2)\n";
            ai = 1;
        }
        if (valObj["project_types"] === "Required") {
            alerts += "Project types (Step 3)\n";
            ai = 2;
        }
        if (valObj["county"] === "Required") {
            alerts += "County (Step 3)\n";
            ai = 2;
        }
        if (valObj["project_township"] === "Required") {
            alerts += "Township/City Name (Step 3)\n";
            ai = 2;
        }
        if (valObj["section"] === "Required") {
            alerts += "Section (Step 3)\n";
            ai = 2;
        }
        if (valObj["project_description"] === "Required") {
            alerts += "Project description (Step 3)\n";
            ai = 2;
        }
        if (valObj["understand1"] === "Required") {
            alerts += "Understand Agreement (Step 6)\n";
            ai = 5;
        }
        if (alerts) {
            alert("The following fields are missing or invalid:\n" + alerts);
            this.setState({ activeStep: ai });
        }

        return valObj;
    };

    errorValidatorAttachment = (values) => {
        const isRequired = (val) => {
            return !val ? "Required" : null;
        };
        var valObj = {
            file: isRequired(values.file),
            name: isRequired(values.name),
        };

        return valObj;
    };

    submitApplication = (values) => {
        const {
            ormApplicationRecordCreate,
            ormApplicationRecordStatusCreate,
            ormBRRWDPermitCreate,
            ormBRRWDCulvertCreate,
            ormBRRWDAttachmentCreate,
            ormBRRWDPermitUpdatePublic
        } = this.props;
        const { tempCulverts, temp_attachments, application } = this.state;

        const _this = this;
        this.setState({ loading: true });

        // Editing
        if (application) {

        } else {
            // New
            let totalAttachments = tempCulverts.length + temp_attachments.length
            let hasntSaved = false
            let created = 0
            ormApplicationRecordCreate({
                application: 10,
            }).then((ar) => {
                ormApplicationRecordStatusCreate({ //dummy status so backend can determine when to send email after attachments below
                    applicationrecord: ar.id,
                    status: "Initial",
                });
                ormBRRWDPermitCreate({
                    applicationrecord: ar.id,
                    ...values,
                }).then((rpb) => {
                    if (rpb && rpb.error) {
                        this.setState({ entryError: true, loading: false });
                        fetch("/error/post", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                                error: JSON.stringify(values),
                                error_info: rpb.error.toString(),
                            }),
                        });
                    } else {

                        tempCulverts.forEach(function (tc) {
                            ormBRRWDCulvertCreate({
                                brrwdpermit_id: rpb.id,
                                ...tc,
                            }).then((_z) => {
                                created++;
                                if (created === totalAttachments && !hasntSaved) { //so we want to save all the attachments first as we need to send them into the saved received email

                                    ormApplicationRecordStatusCreate({
                                        applicationrecord: ar.id,
                                        status: "Received"
                                    }).then(statusrecord => {
                                        setTimeout(() => {
                                            ormBRRWDPermitUpdatePublic({
                                                id: rpb.id,
                                                ...values
                                            })
                                        }, 1500)
                                        _this.setState({ loading: false, new_save: true });
                                        hasntSaved = true
                                    })
                                }
                            });
                        });
                        temp_attachments.forEach(function (tc) {
                            ormBRRWDAttachmentCreate({
                                brrwdpermit_id: rpb.id,
                                ...tc,
                            }).then((_z) => {
                                created++;
                                if (created === totalAttachments && !hasntSaved) { //so we want to save all the attachments first as we need to send them into the saved received email

                                    ormApplicationRecordStatusCreate({
                                        applicationrecord: ar.id,
                                        status: "Received"
                                    }).then(statusrecord => {
                                        setTimeout(() => {
                                            ormBRRWDPermitUpdatePublic({
                                                id: rpb.id,
                                                ...values
                                            })
                                        }, 1500)
                                        _this.setState({ loading: false, new_save: true });
                                        hasntSaved = true
                                    })
                                }

                            });
                        });
                        if (totalAttachments === 0) {
                            ormApplicationRecordStatusCreate({
                                applicationrecord: ar.id,
                                status: "Received"
                            })
                            setTimeout(() => {//trigger for the email to be sent
                                ormBRRWDPermitUpdatePublic({
                                    id: rpb.id
                                })
                            }, 1500)
                            // No attachments or culverts - its finished loading
                            _this.setState({ loading: false, new_save: true });
                        }
                    }
                });
            });
        }
    };
    addCulvert = (values) => {
        var { culvertEditing, tempCulverts } = this.state;

        if (!culvertEditing) {
            tempCulverts.push(values);
            this.setState({ tempCulverts: tempCulverts });
        } else {
            var temp = tempCulverts.filter((tc) => tc !== culvertEditing);
            temp.push(values);
            this.setState({ tempCulverts: temp });
        }

        this.setState({ culvertDialogOpen: false });
    };
    errorValidatorCulvert = (values) => {
        const isRequired = (val) => {
            return !val ? "Required" : null;
        };
        var valObj = {
            name: isRequired(values.name),
        };

        return valObj;
    };
    addAttachment = (values) => {
        var { attachmentEditing, temp_attachments } = this.state;

        if (!attachmentEditing) {
            temp_attachments.push(values);
            this.setState({ temp_attachments: temp_attachments });
        } else {
            var temp = temp_attachments.filter((tc) => tc !== attachmentEditing);
            temp.push(values);
            this.setState({ temp_attachments: temp });
        }

        this.setState({ attachmentDialogOpen: false });
    };

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = "desc";

        if (this.state.orderBy === property && this.state.order === "desc") {
            order = "asc";
        }

        order === "desc"
            ? this.state.temp_contacts.sort((a, b) => (b[orderBy].toUpperCase() < a[orderBy].toUpperCase() ? -1 : 1))
            : this.state.temp_contacts.sort((a, b) => (a[orderBy].toUpperCase() < b[orderBy].toUpperCase() ? -1 : 1));

        this.setState({ order, orderBy });
    };

    handleRequestSort2 = (event, property) => {
        const orderBy = property;
        let order = "desc";

        if (this.state.orderBy === property && this.state.order === "desc") {
            order = "asc";
        }

        order === "desc"
            ? this.state.temp_attachments.sort((a, b) => (b[orderBy].toUpperCase() < a[orderBy].toUpperCase() ? -1 : 1))
            : this.state.temp_attachments.sort((a, b) => (a[orderBy].toUpperCase() < b[orderBy].toUpperCase() ? -1 : 1));

        this.setState({ order, orderBy });
    };

    handleNext = (index) => {
        const { activeStep } = this.state;
        if (index || index === 0) {
            this.setState({ activeStep: index });
        } else if (activeStep < 5) this.setState({ activeStep: activeStep + 1 });
        else {
            this.formApi.submitForm();
        }
    };


    render() {
        const { classes, mediaQuery } = this.props;
        const {
            activeStep,
            attachmentDialogOpen,
            attachmentEditing,
            attachmentFormKey,
            attachmentOrder,
            attachmentOrderBy,
            temp_attachments,
            loading,
            new_save,
            mainFormKey,
            new_save2,
            entryError,
            order,
            orderBy,
            culvertDialogOpen,
            culvertEditing,
            formKey,
            projectType,
            selectLegal,
            tempCulverts,
            application
        } = this.state;

        var is_read_only = false;
        if (
            application &&
            application.applicationrecord &&
            (application.applicationrecord.status !== ""
            ))
            is_read_only = true;

        var columnDataAttachments = [
            { id: "actions", numeric: false, label: "", allowSort: false, width: "20px" },
            { id: "name", numeric: false, label: "Name", allowSort: true },
            { id: "_type", numeric: false, label: "Type", allowSort: true },
            { id: "notes", numeric: false, label: "Notes", allowSort: true },
        ];

        var culvertHeader = [
            { id: "actions", numeric: false, label: "", allowSort: false, width: "20px" },
            { id: "name", numeric: false, label: "Culvert Name or ID", allowSort: true },
            { id: "e_size", numeric: false, label: "Existing culvert size", allowSort: true },
            { id: "e_length", numeric: false, label: "Existing culvert length", allowSort: true },
            { id: "e_elevation", numeric: false, label: "Existing culvert elevation", allowSort: true },
            { id: "p_size", numeric: false, label: "Proposed culvert size", allowSort: true },
            { id: "p_length", numeric: false, label: "Proposed culvert length", allowSort: true },
            { id: "p_elevation", numeric: false, label: "Proposed culvert elevation", allowSort: true },
            { id: "additional", numeric: false, label: "Additional information about culvert", allowSort: true },
        ]

        if (new_save) {
            return (
                <AppContainerApplication city_id={window.location.origin.includes("ms4prod") ? "12" : "2"} page_loading={loading}>
                    <Grid container spacing={1} style={{ padding: "0 12px" }}>
                        <Grid item xs={12} xl={10}>
                            <Typography>
                                This is a confirmation that the permit application has been submitted successfully. A copy of the permit application
                                has been emailed to the primary property owner's email address. Please check your spam and junk folders if you have
                                not received it or contact the district. The district will contact you as the application is being reviewed.
                            </Typography>
                        </Grid>
                    </Grid>
                </AppContainerApplication>
            );
        }
        if (entryError) {
            return (
                <AppContainerApplication city_id={window.location.origin.includes("ms4prod") ? "12" : "2"} page_loading={loading}>
                    <Grid container spacing={1} style={{ padding: "0 12px" }}>
                        <Grid item xs={12} xl={10}>
                            <Typography>
                                This permit application was 'not' successfully saved. Please contact the permit 'managing' staff to alert them of the
                                entry failure.
                            </Typography>
                        </Grid>
                    </Grid>
                </AppContainerApplication>
            );
        }
        if (new_save2) {
            return (
                <AppContainerApplication city_id={window.location.origin.includes("ms4prod") ? "12" : "2"} page_loading={loading}>
                    <Grid container spacing={1} style={{ padding: "0 12px" }}>
                        <Grid item xs={12} xl={10}>
                            <Typography>This is a confirmation that the permit application has been resubmitted successfully.</Typography>
                        </Grid>
                    </Grid>
                </AppContainerApplication>
            );
        }
        if (activeStep === "PRINT")
            return (
                <AppContainerApplication city_id={window.location.origin.includes("ms4prod") ? "12" : "2"} page_loading={loading}>
                    <Grid container spacing={1} style={{ padding: "0 12px" }}>
                        <Grid item xs={12} xl={10}>
                            <Typography>Permit Printed.</Typography>
                        </Grid>
                    </Grid>
                </AppContainerApplication>
            );

        // based on project type will dictate the attachment types they have to choose from (well took away as customer didnt want detailed)
        // but it still determines which help outputs are seen in the attachment step
        var attachmentTypes = []
        if (projectType.length > 0) {
            let tiling = ['Tiling Site Map', 'Tiling Downstream Landowner Notification']
            let surface = ['Surface Drainage Site Map', 'Surface Drainage Downstream Landowner Notification']
            let culvert = ['Culvert Site Map']
            let bridge = ['Bridge Site Map', 'Bridge Project Engineers Report', 'Bridge Detailed Project Construction Plans']
            let wet = ['Wetland/Water Project Site Map', 'Wetland/Water Project Detailed Construction Plans']
            let road = ['Road Grading detailed project construction plans', 'Road Grading site plan']
            let dike = ['Dike site plan', 'Dike detailed construction plans']
            let channel = ['Channel detailed design plans', 'Channel site map']
            let land = ['Land Development project detailed construction plans', 'Land Development project site map']
            let stormwater = ['Stormwater Report showing modeling results of pond design', 'Stormwater Pollution Prevention Plan (SWPPP)']
            let utility = ['Utility project detailed project plans', 'Utility project site map']
            let other = ['Legacy File', 'Other']
            if (projectType.find(t => t.includes("Tiling")) && !attachmentTypes.find(a => a.includes("Tiling"))) attachmentTypes = [...attachmentTypes, ...tiling]
            if (projectType.find(t => t.includes("Surface")) && !attachmentTypes.find(a => a.includes("Surface"))) attachmentTypes = [...attachmentTypes, ...surface]
            if (projectType.find(t => t.includes("Culvert")) && !attachmentTypes.find(a => a.includes("Culvert"))) attachmentTypes = [...attachmentTypes, ...culvert]
            if (projectType.find(t => t.includes("Bridge")) && !attachmentTypes.find(a => a.includes("Bridge"))) attachmentTypes = [...attachmentTypes, ...bridge]
            if (projectType.find(t => t.includes("Wetland")) && !attachmentTypes.find(a => a.includes("Wetland"))) attachmentTypes = [...attachmentTypes, ...wet]
            if (projectType.find(t => t.includes("Road")) && !attachmentTypes.find(a => a.includes("Road"))) attachmentTypes = [...attachmentTypes, ...road]
            if (projectType.find(t => t.includes("Dike")) && !attachmentTypes.find(a => a.includes("Dike"))) attachmentTypes = [...attachmentTypes, ...dike]
            if (projectType.find(t => t.includes("Channel")) && !attachmentTypes.find(a => a.includes("Channel"))) attachmentTypes = [...attachmentTypes, ...channel]
            if (projectType.find(t => t.includes("Land")) && !attachmentTypes.find(a => a.includes("Land"))) attachmentTypes = [...attachmentTypes, ...land]
            if (projectType.find(t => t.includes("Stormwater")) && !attachmentTypes.find(a => a.includes("Stormwater"))) attachmentTypes = [...attachmentTypes, ...stormwater]
            if (projectType.find(t => t.includes("Utility")) && !attachmentTypes.find(a => a.includes("Utility"))) attachmentTypes = [...attachmentTypes, ...utility]
            if (!attachmentTypes.find(a => a.includes("Legacy"))) attachmentTypes = [...attachmentTypes, ...other]

        }
        let steps = [
            "Instructions",
            "Applicant Information",
            "Project Type and Location",
            "Project Type Details",
            "Document Upload",
            "Landowner Acknowledgement and Submittal"
        ]

        return (
            <AppContainerApplication
                city_id={"52"} //window.location.origin.includes("ms4prod") ? "45" : "2"}
                page_loading={loading}
                printing={activeStep === "PRINT"}
            >
                <main
                    id="main-content"
                    role="main"
                >
                    <Form
                        getApi={(el) => (this.formApi = el)}
                        defaultValues={application}
                        key={mainFormKey}
                        pure={false}
                        dontValidateOnMount={true}
                        validateOnSubmit={true}
                        validateError={(values) => this.errorValidator(values)}
                        onSubmit={(values) => this.submitApplication(values)}>
                        {(formApi) => (
                            <form onSubmit={formApi.submitForm}>
                                <>
                                    {application && application.applicationrecord && application.applicationrecord.status && (
                                        <Grid container spacing={1} style={{ backgroundColor: "#a3a3a3", marginTop: -15 }}>
                                            <Grid item xs={12} xl={10} classes={{ root: classes.root }}>
                                                <Typography className={classes.centerAlign} variant="h6">
                                                    Permit Status: {application && application.applicationrecord.status}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    )}
                                    <Grid container spacing={1} style={{ padding: "0 12px" }}>

                                        <Grid item xs={12} xl={10} classes={{ root: classes.root }}>
                                            <Typography
                                                className={classes.centerAlign}
                                                // variant="h6" 
                                                variant="h1"
                                                style={{
                                                    fontSize: 23,
                                                    fontWeight: 400,
                                                    lineHeight: 1.6,
                                                }}
                                            >
                                                Permit Application Form {application && application.permit_number && "#" + application.permit_number}
                                            </Typography>{" "}     </Grid>
                                        <Grid item xs={12} xl={10} className={classes.rightAlign} classes={{ root: classes.root }}>
                                            <Typography className={classes.centerAlign}>
                                                <b>IMPORTANT:</b> The entire permit application must be filled out at one time and progress will not be
                                                saved so please plan accordingly.
                                            </Typography>
                                            <Typography variant="caption" className={classes.centerAlign2}>
                                                Required Fields are marked with an asterisk (*)
                                            </Typography>
                                        </Grid>

                                        {activeStep !== "PRINT" && (
                                            <Grid item xs={12} xl={10} classes={{ root: classes.root }}>
                                                {!mediaQuery ? (
                                                    <Typography variant="subtitle1" style={{ fontWeight: "bold", textAlign: "center" }}>
                                                        <MobileStepper
                                                            variant="text"
                                                            steps={steps.length + " - " + steps[activeStep]}
                                                            position="static"
                                                            activeStep={activeStep}
                                                            style={{ backgroundColor: "rgb(240, 240, 240)" }}
                                                            nextButton={
                                                                <Button
                                                                    size="small"
                                                                    onClick={() => this.handleNext()}
                                                                    disabled={is_read_only && activeStep === 5}
                                                                >
                                                                    {activeStep === 5 ? "Submit" : "Next"} <KeyboardArrowRight />
                                                                </Button>
                                                            }
                                                            backButton={
                                                                <Button size="small" onClick={() => this.setState({ activeStep: activeStep - 1 })} disabled={activeStep === 0}>
                                                                    <KeyboardArrowLeft /> Back
                                                                </Button>
                                                            }
                                                        />
                                                    </Typography>
                                                ) : (
                                                    <nav
                                                        aria-label="Application steps"
                                                    >
                                                        <Stepper
                                                            style={{ padding: 8 }}
                                                            alternativeLabel
                                                            nonLinear
                                                            activeStep={activeStep}
                                                        >
                                                            {steps.map((label, index) => (
                                                                <Step key={label}>
                                                                    <StepButton
                                                                        onClick={() => this.handleNext(index)}
                                                                        className={classes.stepperRoot}
                                                                    >
                                                                        {label}
                                                                    </StepButton>
                                                                </Step>
                                                            ))}
                                                        </Stepper>
                                                    </nav>
                                                )}
                                            </Grid>
                                        )}
                                        {activeStep === 0 && (
                                            <Grid item direction="row" justifyContent="center" alignItems="center" style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                <Typography
                                                    // variant="subtitle1"
                                                    variant="h2"
                                                    style={{
                                                        // font-size: 1rem;
                                                        fontSize: 17,
                                                        // font-weight: 400;
                                                        fontWeight: 400,
                                                        // line-height: 1.75;
                                                        lineHeight: 1.75,
                                                    }}
                                                >
                                                    <b>
                                                        {"1. "}
                                                        {/* <u> */}
                                                        <i>
                                                            Preparation
                                                        </i>
                                                        {/* </u> */}
                                                    </b>
                                                </Typography>
                                                <Typography gutterBottom style={{ marginLeft: 9 }}>
                                                    {`\u2022`} As you work through the online application you will not be able to save your progress for
                                                    submittal at a later time.
                                                </Typography>
                                                <Typography gutterBottom style={{ marginLeft: 9 }}>
                                                    {`\u2022`} Please have all the required information on hand to ensure you are able to submit a
                                                    complete application.
                                                </Typography>
                                                <Typography gutterBottom style={{ marginLeft: 9 }}>
                                                    {`\u2022`} For guidance about the required information, please see the{" "}
                                                    <a
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        href="https://www.brrwd.org/rules-and-regulations"
                                                    >
                                                        BRRWD Rules
                                                    </a>{" "}
                                                </Typography>
                                                <br />
                                                <Typography
                                                    // variant="subtitle1"
                                                    variant="h2"
                                                    style={{
                                                        // font-size: 1rem;
                                                        fontSize: 17,
                                                        // font-weight: 400;
                                                        fontWeight: 400,
                                                        // line-height: 1.75;
                                                        lineHeight: 1.75,
                                                    }}
                                                >
                                                    <b>
                                                        {"2. "}
                                                        <i>
                                                            {/* <u> */}
                                                            Submit Application
                                                            {/* </u> */}
                                                        </i>
                                                    </b>
                                                </Typography>
                                                <Typography gutterBottom style={{ marginLeft: 9 }}>
                                                    {`\u2022`} Once you have compiled the required information, complete the permit application and
                                                    submit. Again, your progress will not be saved for submittal at a later time.
                                                </Typography>
                                                <br />
                                                <Typography
                                                    // variant="subtitle1"
                                                    variant="h2"
                                                    style={{
                                                        // font-size: 1rem;
                                                        fontSize: 17,
                                                        // font-weight: 400;
                                                        fontWeight: 400,
                                                        // line-height: 1.75;
                                                        lineHeight: 1.75,
                                                    }}
                                                >
                                                    <b>
                                                        {"3. "}
                                                        {/* <u> */}
                                                        <i>
                                                            Application Review
                                                        </i>
                                                        {/* </u> */}
                                                    </b>
                                                </Typography>
                                                <Typography gutterBottom style={{ marginLeft: 9 }}>
                                                    {`\u2022`} Once your application has been submitted, BRRWD staff will notify you within 15 days if more information is required.
                                                </Typography>
                                                <Typography gutterBottom style={{ marginLeft: 9 }}>
                                                    {`\u2022`} Once all required information has been received, application will be brought to BRRWD Board for approval.
                                                </Typography>
                                            </Grid>
                                        )}
                                        {activeStep === 1 && (
                                            <Grid item direction="row" justifyContent="center" alignItems="center" classes={{ root: classes.root }}>
                                                <Typography>
                                                    Please add contacts associated with the application.
                                                </Typography>
                                                <Accordion defaultExpanded>
                                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: "#ddd" }}>
                                                        <Typography
                                                            // variant="subtitle1" 
                                                            gutterBottom
                                                            variant="h2"
                                                            style={{
                                                                // font-size: 1rem;
                                                                fontSize: 17,
                                                                // font-weight: 400;
                                                                fontWeight: 400,
                                                                // line-height: 1.75;
                                                                lineHeight: 1.75,
                                                            }}
                                                        >
                                                            Primary Property Owner (required)
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                {/* <InputLabel htmlFor="appl_first_name">First Name *</InputLabel> */}
                                                                <AccTextField
                                                                    // id='appl_first_name'
                                                                    disabled={is_read_only}
                                                                    field="appl_first_name"
                                                                    label="First Name *"
                                                                    fullWidth
                                                                />

                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                {/* <InputLabel htmlFor="appl_last_name">Last Name *</InputLabel> */}
                                                                <AccTextField
                                                                    // id='appl_last_name'
                                                                    disabled={is_read_only}
                                                                    field="appl_last_name"
                                                                    label="Last Name *"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="appl_affiliation"
                                                                    label={
                                                                        <AccHelpLabel
                                                                            inputLabel="Affiliation"
                                                                            helpText="Please list government unit or private entity that 
                                                                        is applying on behalf of the landowner, if applicable.
                                                                        "
                                                                        />
                                                                    }
                                                                    fullWidth
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="appl_email"
                                                                    label="Email"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="appl_phone"
                                                                    label="Phone *"
                                                                    fullWidth
                                                                    usePhoneNumberFormat
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="appl_mailing_address"
                                                                    label="Address"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="appl_mailing_address2"
                                                                    label="Address 2"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="appl_city"
                                                                    label="City"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccessabilitySelect
                                                                    disabled={is_read_only}
                                                                    field="appl_state"
                                                                    label="State"
                                                                    options={states}
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="appl_zip"
                                                                    label="Zip"
                                                                    fullWidth
                                                                />
                                                            </Grid>

                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                                <Accordion defaultExpanded>
                                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: "#ddd" }}>
                                                        <Typography
                                                            // variant="subtitle1" 
                                                            gutterBottom
                                                            variant="h2"
                                                            style={{
                                                                // font-size: 1rem;
                                                                fontSize: 17,
                                                                // font-weight: 400;
                                                                fontWeight: 400,
                                                                // line-height: 1.75;
                                                                lineHeight: 1.75,
                                                            }}
                                                        >
                                                            Landowner (if not same as Applicant)
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="landowner_first_name"
                                                                    label="First Name"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="landowner_last_name"
                                                                    label="Last Name"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="landowner_email"
                                                                    label="Email"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="landowner_phone"
                                                                    label="Phone"
                                                                    fullWidth
                                                                    usePhoneNumberFormat
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="landowner_mailing_address"
                                                                    label="Address"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="landowner_mailing_address2"
                                                                    label="Address 2"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="landowner_city"
                                                                    label="City"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccessabilitySelect
                                                                    disabled={is_read_only}
                                                                    field="landowner_state"
                                                                    label="State"
                                                                    options={states}
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="landowner_zip"
                                                                    label="Zip"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>{" "}
                                            </Grid>
                                        )}
                                        {activeStep === "PRINT" && (
                                            <>
                                                <div style={{ height: 50 }}></div>
                                                <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                    <Divider className={classes.printDivider} />
                                                </Grid>
                                            </>
                                        )}
                                        {activeStep === 2 && (
                                            <Grid item direction="row" justifyContent="center" alignItems="center" classes={{ root: classes.root }}>
                                                <AccFppCheckboxGroup
                                                    field="project_types"
                                                    label="Select Project Types: (Check all that apply)"
                                                    required
                                                    row={true}
                                                    disabled={is_read_only}
                                                    eventHandle={(e) => {
                                                        this.setState({ projectType: e })
                                                    }}
                                                    options={MAKE_OPTIONS([
                                                        "Tiling", "Surface Drainage (New Ditch or Improvement)", "Culvert Installation / Removal / Modification", "Bridge Installation / Removal / Modification",
                                                        "Wetland Restoration / Water Retention Related Structures / Water and Sediment Control Basins", "Dike / Levee",
                                                        "Channel Stabilization / Restoration / Erosion Control / Shoreland Projects", "Land Development", "Utility Installations"
                                                    ])}
                                                />
                                                <Grid item xs={12}>
                                                    <br />
                                                    <hr />
                                                    <br />
                                                </Grid>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <AccTextField
                                                            field="project_description"
                                                            label={
                                                                <AccHelpLabel
                                                                    inputLabel="Provide description of proposed project *:"
                                                                    helpText="Applicant must provide a detailed project description. Application will be considered <u>incomplete</u> until adequate information is provided."
                                                                />
                                                            }
                                                            multiline
                                                            rows={8}
                                                            disabled={is_read_only}
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Typography
                                                            // variant="subtitle1" 
                                                            gutterBottom
                                                            variant="h2"
                                                            style={{
                                                                // font-size: 1rem;
                                                                fontSize: 17,
                                                                // font-weight: 400;
                                                                fontWeight: 400,
                                                                // line-height: 1.75;
                                                                lineHeight: 1.75,
                                                            }}
                                                        >
                                                            <b>Project Location (County, Township and Section is required)</b>
                                                        </Typography>
                                                    </Grid>

                                                    <Grid item xs={12} md={6} xl={4}>
                                                        <AccessabilitySelect
                                                            // id='county'
                                                            disabled={is_read_only}
                                                            field="county"
                                                            label="County *"
                                                            options={MAKE_OPTIONS(["Becker", "Clay", "Otter Tail", "Wilkin"])}
                                                            fullWidth
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} md={6} xl={4}>
                                                        <AccessabilitySelect
                                                            disabled={is_read_only}
                                                            field="project_township"
                                                            label="Township/City Name *"
                                                            options={MAKE_OPTIONS(["Akron", "Alliance", "Andrea", "Atherton", "Atlanta", "Audubon", "Barnesville", "Bradford", "Breckenridge", "Callaway", "Carlisle",
                                                                "City of Audubon", "City of Barnesville", "City of Breckenridge", "City of Callaway", "City of Comstock", "City of Dilworth", "City of Fergus Falls",
                                                                "City of Foxhome", "City of Georgetown", "City of Glyndon", "City of Hawley", "City of Hitterdal", "City of Kent", "City of Lake Park", "City of Moorhead",
                                                                "City of Rothsay", "City of Sabin", "City of Wolverton", "Connelly", "Cormorant", "Cromwell", "Cuba", "Deerhorn", "Detroit", "Eglon", "Elizabeth", "Elkton", "Elmwood",
                                                                "Erie", "Fergus Falls", "Flowing", "Foxhome", "Georgetown", "Glyndon", "Goose Prairie", "Hamden", "Hawley", "Height of Land", "Highland Grove", "Holmesville", "Holy Cross",
                                                                "Humboldt", "Keene", "Kragnes", "Kurtz", "Lake Eunice", "Lake Park", "Lake View", "Manston", "Maple Grove", "McCauleyville", "Meadows", "Mitchell", "Moland", "Moorhead", "Morken", "Nilsen",
                                                                "Nordick", "Norwegian Grove", "Oakport", "Orwell", "Oscar", "Parke", "Pelican", "Prairie View", "Riceville", "Richwood", "Riverton", "Roberts", "Scambler", "Skree", "Spring Creek",
                                                                "Spring Prairie", "Sugar Bush", "Sunnyside", "Tanberg", "Tansem", "Trondhjem", "Viding", "Western", "White Earth", "Wolverton"])}
                                                            fullWidth
                                                        />
                                                    </Grid>

                                                    <Grid item xs={12} md={6} xl={4}>
                                                        <AccessabilitySelect
                                                            disabled={is_read_only}
                                                            field="section"
                                                            label="Section *"
                                                            options={MAKE_OPTIONS([
                                                                "1",
                                                                "2",
                                                                "3",
                                                                "4",
                                                                "5",
                                                                "6",
                                                                "7",
                                                                "8",
                                                                "9",
                                                                "10",
                                                                "11",
                                                                "12",
                                                                "13",
                                                                "14",
                                                                "15",
                                                                "16",
                                                                "17",
                                                                "18",
                                                                "19",
                                                                "20",
                                                                "21",
                                                                "22",
                                                                "23",
                                                                "24",
                                                                "25",
                                                                "26",
                                                                "27",
                                                                "28",
                                                                "29",
                                                                "30",
                                                                "31",
                                                                "32",
                                                                "33",
                                                                "34",
                                                                "35",
                                                                "36",
                                                            ])}
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={6} xl={4}>
                                                        <AccessabilitySelect
                                                            disabled={is_read_only}
                                                            field="quarter_section"
                                                            label="Primary Quarter Section"
                                                            options={MAKE_OPTIONS(["NW", "NE", "SW", "SE"])}
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        )}
                                        {activeStep === "PRINT" && (
                                            <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                <Divider className={classes.printDivider} />
                                            </Grid>
                                        )}
                                        {activeStep === 3 && projectType.length === 0 && (
                                            <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                <Typography variant="subtitle1" gutterBottom style={{ textAlign: "center", textDecoration: "underline", fontWeight: "bold" }}>
                                                    No Project Types have been selected. Refer to Step 3 and select a 'Project Type'
                                                </Typography>
                                            </Grid>
                                        )}
                                        {activeStep === 3 && projectType.length > 0 && projectType.find(t => t === "Tiling") && (
                                            <Grid item direction="row" justifyContent="center" alignItems="center" classes={{ root: classes.root }}>
                                                <Accordion defaultExpanded>
                                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: "#ddd" }}>
                                                        <Typography
                                                            // variant="subtitle1" 
                                                            gutterBottom
                                                            variant="h2"
                                                            style={{
                                                                // font-size: 1rem;
                                                                fontSize: 17,
                                                                // font-weight: 400;
                                                                fontWeight: 400,
                                                                // line-height: 1.75;
                                                                lineHeight: 1.75,
                                                            }}
                                                        >
                                                            Tiling
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="til_water_issu"
                                                                    label="Describe water related issues that make this work necessary"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="til_rec_water"
                                                                    label="Describe receiving waters"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <RadioGroup
                                                                    field="til_land_ass"
                                                                    disabled={is_read_only}
                                                                    fullWidth
                                                                    options={[
                                                                        { label: "Yes", value: "Yes" },
                                                                        { label: "No", value: "No" },
                                                                    ]}
                                                                    alignment={true}
                                                                    label="Land is assessed to legal ditch system"
                                                                    eventHandle={e => {
                                                                        this.setState({ selectLegal: e === "Yes" ? true : false })
                                                                    }}
                                                                />
                                                            </Grid>
                                                            {selectLegal && (
                                                                <Grid item xs={12} md={6} xl={4}>
                                                                    <AccessabilitySelect
                                                                        // disabled={selectLegal }
                                                                        field="til_legal_ditch"
                                                                        label="Select legal ditch system"
                                                                        options={MAKE_OPTIONS(["Becker County Ditch No. 10", "Becker County Ditch No. 15", "Becker County Ditch No. 19",
                                                                            "Becker County Ditch No. 21", "Becker County Ditch No. 5", "Becker County Ditch No. 6", "Becker County Ditch No. 7",
                                                                            "Becker County Ditch No. 9", "Clay County Ditch No. 10", "Clay County Ditch No. 11", "Clay County Ditch No. 12", "Clay County Ditch No. 16",
                                                                            "Clay County Ditch No. 17", "Clay County Ditch No. 2", "Clay County Ditch No. 20", "Clay County Ditch No. 21", "Clay County Ditch No. 22",
                                                                            "Clay County Ditch No. 23", "Clay County Ditch No. 28", "Clay County Ditch No. 3", "Clay County Ditch No. 30", "Clay County Ditch No. 31",
                                                                            "Clay County Ditch No. 32", "Clay County Ditch No. 33", "Clay County Ditch No. 34", "Clay County Ditch No. 35", "Clay County Ditch No. 36",
                                                                            "Clay County Ditch No. 39", "Clay County Ditch No. 40", "Clay County Ditch No. 41", "Clay County Ditch No. 41-Lateral No. 1",
                                                                            "Clay County Ditch No. 41-Lateral No. 2", "Clay County Ditch No. 47", "Clay County Ditch No. 49", "Clay County Ditch No. 5", "Clay County Ditch No. 50",
                                                                            "Clay County Ditch No. 51", "Clay County Ditch No. 53", "Clay County Ditch No. 54", "Clay County Ditch No. 55", "Clay County Ditch No. 57",
                                                                            "Clay County Ditch No. 58", "Clay County Ditch No. 59", "Clay County Ditch No. 60", "Clay County Ditch No. 63", "Clay County Ditch No. 65",
                                                                            "Clay County Ditch No. 67", "Clay County Ditch No. 68", "Clay County Ditch No. 69", "Clay County Ditch No. 9", "Clay-Wilkin Judicial Ditch No. 1",
                                                                            "Wilkin County Ditch No. 12", "Wilkin County Ditch No. 13", "Wilkin County Ditch No. 13-Lateral No. 1", "Wilkin County Ditch No. 15",
                                                                            "Wilkin County Ditch No. 1A", "Wilkin County Ditch No. 1B", "Wilkin County Ditch No. 1C", "Wilkin County Ditch No. 2/2A", "Wilkin County Ditch No. 22",
                                                                            "Wilkin County Ditch No. 23", "Wilkin County Ditch No. 26", "Wilkin County Ditch No. 27", "Wilkin County Ditch No. 28", "Wilkin County Ditch No. 29",
                                                                            "Wilkin County Ditch No. 3", "Wilkin County Ditch No. 31", "Wilkin County Ditch No. 34", "Wilkin County Ditch No. 37", "Wilkin County Ditch No. 4/4A",
                                                                            "Wilkin County Ditch No. 40", "Wilkin County Ditch No. 41", "Wilkin County Ditch No. 42", "Wilkin County Ditch No. 43", "Wilkin County Ditch No. 44",
                                                                            "Wilkin County Ditch No. 5A", "Wilkin County Ditch No. 6A", "Wilkin County Ditch No. 7", "Wilkin-Otter Tail Judicial Ditch No. 2"])}
                                                                        fullWidth
                                                                    />
                                                                </Grid>
                                                            )}
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                {/* <InputLabel htmlFor="til_olet">Tile outlets across property not owned by landowner or applicant</InputLabel> */}
                                                                <RadioGroup
                                                                    // id='til_olet'
                                                                    field="til_olet"
                                                                    disabled={is_read_only}
                                                                    fullWidth
                                                                    options={[
                                                                        { label: "Yes", value: "Yes" },
                                                                        { label: "No", value: "No" },
                                                                    ]}
                                                                    alignment={true}
                                                                    label="Tile outlets across property not owned by landowner or applicant"
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="project_dname"
                                                                    label="Project Designer Name"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="project_dphone"
                                                                    label="Project Designer Phone"
                                                                    fullWidth
                                                                    usePhoneNumberFormat
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="project_demail"
                                                                    label="Project Designer Email"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="project_iname"
                                                                    label="Project Installer Name"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                {/* <InputLabel htmlFor="project_iphone">Project Installer Phone</InputLabel> */}
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="project_iphone"
                                                                    label="Project Installer Phone"
                                                                    fullWidth
                                                                    usePhoneNumberFormat
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="project_iemail"
                                                                    label="Project Installer Email"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="addinfo"
                                                                    label="Additional Information about Tiling Project"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid>
                                        )}
                                        {activeStep === 3 && projectType.length > 0 && projectType.find(t => t === "Surface Drainage (New Ditch or Improvement)") && (
                                            <Grid item direction="row" justifyContent="center" alignItems="center" classes={{ root: classes.root }}>
                                                <Accordion defaultExpanded>
                                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: "#ddd" }}>
                                                        <Typography
                                                            // variant="subtitle1" 
                                                            gutterBottom
                                                            variant="h2"
                                                            style={{
                                                                // font-size: 1rem;
                                                                fontSize: 17,
                                                                // font-weight: 400;
                                                                fontWeight: 400,
                                                                // line-height: 1.75;
                                                                lineHeight: 1.75,
                                                            }}
                                                        >
                                                            Surface Drainage (New Ditch or Improvement)
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccessabilitySelect
                                                                    disabled={is_read_only}
                                                                    field="sur_drainage"
                                                                    label="Surface Drainage Project involves:"
                                                                    options={MAKE_OPTIONS(["Construction of new ditch", "Improvement of existing ditch"])}
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="sur_depth"
                                                                    label="Existing ditch depth (max 50)"
                                                                    fullWidth
                                                                    units="feet"
                                                                    useNumberFormat3
                                                                    maxValue={50}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="sur_width"
                                                                    label="Existing ditch width (max 1000)"
                                                                    fullWidth
                                                                    units="feet"
                                                                    useNumberFormat3
                                                                    maxValue={1000}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccessabilitySelect
                                                                    disabled={is_read_only}
                                                                    field="sur_slopes"
                                                                    label="Existing ditch side slopes"
                                                                    options={MAKE_OPTIONS(["3H:1V", "4H:1V", "5H:1V", "6H:1V"])}
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="sur_pdepth"
                                                                    label="Proposed ditch depth (max 50)"
                                                                    fullWidth
                                                                    units="feet"
                                                                    useNumberFormat3
                                                                    maxValue={50}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="sur_pwidth"
                                                                    label="Proposed ditch width (max 1000)"
                                                                    fullWidth
                                                                    units="feet"
                                                                    useNumberFormat3
                                                                    maxValue={1000}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccessabilitySelect
                                                                    disabled={is_read_only}
                                                                    field="sur_pslopes"
                                                                    label="Proposed ditch side slopes"
                                                                    options={MAKE_OPTIONS(["3H:1V", "4H:1V", "5H:1V", "6H:1V"])}
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="sur_how_grade"
                                                                    label="How will grade-line of ditch be established?"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="sur_spoil"
                                                                    label="Where will spoil be placed?"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccessabilitySelect
                                                                    disabled={is_read_only}
                                                                    field="sur_outlet"
                                                                    label="Outlet is:"
                                                                    options={MAKE_OPTIONS(["Natural Stream / River", "Roadside Ditch", "Legal Ditch", "Applicants Field", "Other"])}
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="sur_outlet_other"
                                                                    label="If is Outlet Other, Explain"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <RadioGroup
                                                                    field="sur_ditch_outlet"
                                                                    disabled={is_read_only}
                                                                    fullWidth
                                                                    options={[
                                                                        { label: "Yes", value: "Yes" },
                                                                        { label: "No", value: "No" },
                                                                    ]}
                                                                    alignment={true}
                                                                    label="Ditch outlets across property not owned by landowner or applicant"
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <RadioGroup
                                                                    field="sur_land_ass"
                                                                    disabled={is_read_only}
                                                                    fullWidth
                                                                    options={[
                                                                        { label: "Yes", value: "Yes" },
                                                                        { label: "No", value: "No" },
                                                                    ]}
                                                                    alignment={true}
                                                                    label="Land is assessed to legal ditch system"
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccessabilitySelect
                                                                    disabled={is_read_only}
                                                                    field="sur_legal_ditch"
                                                                    label="Legal ditch system"
                                                                    options={MAKE_OPTIONS(["Becker County Ditch No. 10", "Becker County Ditch No. 15", "Becker County Ditch No. 19",
                                                                        "Becker County Ditch No. 21", "Becker County Ditch No. 5", "Becker County Ditch No. 6", "Becker County Ditch No. 7",
                                                                        "Becker County Ditch No. 9", "Clay County Ditch No. 10", "Clay County Ditch No. 11", "Clay County Ditch No. 12", "Clay County Ditch No. 16",
                                                                        "Clay County Ditch No. 17", "Clay County Ditch No. 2", "Clay County Ditch No. 20", "Clay County Ditch No. 21", "Clay County Ditch No. 22",
                                                                        "Clay County Ditch No. 23", "Clay County Ditch No. 28", "Clay County Ditch No. 3", "Clay County Ditch No. 30", "Clay County Ditch No. 31",
                                                                        "Clay County Ditch No. 32", "Clay County Ditch No. 33", "Clay County Ditch No. 34", "Clay County Ditch No. 35", "Clay County Ditch No. 36",
                                                                        "Clay County Ditch No. 39", "Clay County Ditch No. 40", "Clay County Ditch No. 41", "Clay County Ditch No. 41-Lateral No. 1",
                                                                        "Clay County Ditch No. 41-Lateral No. 2", "Clay County Ditch No. 47", "Clay County Ditch No. 49", "Clay County Ditch No. 5", "Clay County Ditch No. 50",
                                                                        "Clay County Ditch No. 51", "Clay County Ditch No. 53", "Clay County Ditch No. 54", "Clay County Ditch No. 55", "Clay County Ditch No. 57",
                                                                        "Clay County Ditch No. 58", "Clay County Ditch No. 59", "Clay County Ditch No. 60", "Clay County Ditch No. 63", "Clay County Ditch No. 65",
                                                                        "Clay County Ditch No. 67", "Clay County Ditch No. 68", "Clay County Ditch No. 69", "Clay County Ditch No. 9", "Clay-Wilkin Judicial Ditch No. 1",
                                                                        "Wilkin County Ditch No. 12", "Wilkin County Ditch No. 13", "Wilkin County Ditch No. 13-Lateral No. 1", "Wilkin County Ditch No. 15",
                                                                        "Wilkin County Ditch No. 1A", "Wilkin County Ditch No. 1B", "Wilkin County Ditch No. 1C", "Wilkin County Ditch No. 2/2A", "Wilkin County Ditch No. 22",
                                                                        "Wilkin County Ditch No. 23", "Wilkin County Ditch No. 26", "Wilkin County Ditch No. 27", "Wilkin County Ditch No. 28", "Wilkin County Ditch No. 29",
                                                                        "Wilkin County Ditch No. 3", "Wilkin County Ditch No. 31", "Wilkin County Ditch No. 34", "Wilkin County Ditch No. 37", "Wilkin County Ditch No. 4/4A",
                                                                        "Wilkin County Ditch No. 40", "Wilkin County Ditch No. 41", "Wilkin County Ditch No. 42", "Wilkin County Ditch No. 43", "Wilkin County Ditch No. 44",
                                                                        "Wilkin County Ditch No. 5A", "Wilkin County Ditch No. 6A", "Wilkin County Ditch No. 7", "Wilkin-Otter Tail Judicial Ditch No. 2"])}
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="sur_addinfo"
                                                                    label="Additional Information about Surface Drainage Project"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid>
                                        )}

                                        {activeStep === 3 && projectType.length > 0 && projectType.find(t => t === "Culvert Installation / Removal / Modification") && (
                                            <Grid item direction="row" justifyContent="center" alignItems="center" classes={{ root: classes.root }}>
                                                <Accordion defaultExpanded>
                                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: "#ddd" }}>
                                                        <Typography
                                                            // variant="subtitle1" 
                                                            gutterBottom
                                                            variant="h2"
                                                            style={{
                                                                // font-size: 1rem;
                                                                fontSize: 17,
                                                                // font-weight: 400;
                                                                fontWeight: 400,
                                                                // line-height: 1.75;
                                                                lineHeight: 1.75,
                                                            }}
                                                        >
                                                            Culvert Installation
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails style={{ paddingBottom: 27, backgroundColor: "f6f0f0" }}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccessabilitySelect
                                                                    disabled={is_read_only}
                                                                    field="cul_involves"
                                                                    label="Culvert Project involves:"
                                                                    options={MAKE_OPTIONS(["removal of existing culverts", "installation of new culverts", "modification of existing culverts"])}
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="cul_num"
                                                                    label="Number of culverts installed, removed or modified: (minimum 0, maximum 100)"
                                                                    fullWidth
                                                                    units="count"
                                                                    useNumberFormat3
                                                                    maxValue={100}
                                                                    minValue={0}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="cul_info"
                                                                    label="Additional Information for Culvert Project"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <RadioGroup
                                                                    disabled={is_read_only}
                                                                    field="culroad_involves"
                                                                    label="Does Project Involve Road Grading that will modify elevations?"
                                                                    fullWidth
                                                                    options={[
                                                                        { label: "Yes", value: "Yes" },
                                                                        { label: "No", value: "No" },
                                                                    ]}
                                                                    alignment={true}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="culroad_elev"
                                                                    label="If Project modifies road elevations, please describe proposed elevations?"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </AccordionDetails>
                                                    <AccordionDetails style={{ paddingBottom: 27, backgroundColor: "f6f0f0" }}>
                                                        <Grid container spacing={2}>
                                                            <Paper className={classes.root}>
                                                                <Button
                                                                    fullWidth
                                                                    disabled={is_read_only}
                                                                    className={classes.gutterBottom + " " + classes.buttonClass}
                                                                    gutterBottom={true}
                                                                    variant="contained"
                                                                    // color="primary"
                                                                    onClick={() => {
                                                                        this.setState({
                                                                            culvertDialogOpen: true,
                                                                            culvertEditing: null,
                                                                            culvertFormKey: window.performance.now(),
                                                                        })
                                                                    }}>
                                                                    <AddIcon className={classes.iconAdd} />
                                                                    &nbsp;&nbsp;&nbsp;Create New
                                                                </Button>
                                                                <Paper style={{ overflowX: "auto" }}>


                                                                    <Table className={classes.table}>
                                                                        <caption className={classes.visuallyHidden}>
                                                                            Culvert records table
                                                                        </caption>
                                                                        <AccessabilityEnhancedTableHead
                                                                            order={order}
                                                                            orderBy={orderBy}
                                                                            onRequestSort={this.handleRequestSort}
                                                                            columnData={culvertHeader}
                                                                        />
                                                                        <TableBody>
                                                                            {(() => {
                                                                                if (tempCulverts.length < 1) {
                                                                                    return (
                                                                                        <TableRow>
                                                                                            <CustomTableCell
                                                                                                colSpan={culvertHeader.length}
                                                                                                className={classes.centerAlign}
                                                                                            >
                                                                                                No Records Available
                                                                                            </CustomTableCell>
                                                                                        </TableRow>
                                                                                    );
                                                                                }
                                                                                return tempCulverts.map((n) => (
                                                                                    <TableRow hover key={n.id}>
                                                                                        <CustomTableCell className={classes.nowrap}>
                                                                                            <Tooltip title="Edit">
                                                                                                {/* EDIT RECORD will trigger createRepeatableField class*/}
                                                                                                <Button
                                                                                                    onClick={() => {
                                                                                                        this.setState({
                                                                                                            culvertEditing: n,
                                                                                                            culvertDialogOpen: true,
                                                                                                            culvertFormKey: window.performance.now()
                                                                                                        });
                                                                                                    }}

                                                                                                    className={classes.deleteWidth}>
                                                                                                    <EditIcon color="primary" />
                                                                                                </Button>
                                                                                            </Tooltip>
                                                                                            <Tooltip title="Delete">
                                                                                                <Button
                                                                                                    disabled={is_read_only}
                                                                                                    onClick={() =>
                                                                                                        this.setState({ tempCulverts: tempCulverts.filter((tc) => tc !== n) })
                                                                                                    }
                                                                                                    className={classes.deleteWidth}>
                                                                                                    <DeleteIcon color="inherit" />

                                                                                                </Button>
                                                                                            </Tooltip>
                                                                                        </CustomTableCell>
                                                                                        {/* PRINTING OF THE DATA IN THE TABLE */}
                                                                                        <CustomTableCell>{n.name}</CustomTableCell>
                                                                                        <CustomTableCell>{n.e_size}</CustomTableCell>
                                                                                        <CustomTableCell>{n.e_length}</CustomTableCell>
                                                                                        <CustomTableCell>{n.e_elevation}</CustomTableCell>
                                                                                        <CustomTableCell>{n.p_size}</CustomTableCell>
                                                                                        <CustomTableCell>{n.p_length}</CustomTableCell>
                                                                                        <CustomTableCell>{n.p_elevation}</CustomTableCell>
                                                                                        <CustomTableCell>{n.additional}</CustomTableCell>
                                                                                    </TableRow>
                                                                                ));
                                                                            })()}
                                                                        </TableBody>
                                                                    </Table>

                                                                </Paper>
                                                            </Paper>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid>
                                        )}
                                        {activeStep === 3 && projectType.length > 0 && projectType.find(t => t === "Bridge Installation / Removal / Modification") && (
                                            <Grid item direction="row" justifyContent="center" alignItems="center" classes={{ root: classes.root }}>
                                                <Accordion defaultExpanded>
                                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: "#ddd" }}>
                                                        <Typography
                                                            // variant="subtitle1" 
                                                            gutterBottom
                                                            variant="h2"
                                                            style={{
                                                                // font-size: 1rem;
                                                                fontSize: 17,
                                                                // font-weight: 400;
                                                                fontWeight: 400,
                                                                // line-height: 1.75;
                                                                lineHeight: 1.75,
                                                            }}
                                                        >
                                                            Bridge Installation / Removal / Modification
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <RadioGroup
                                                                    disabled={is_read_only}
                                                                    field="brroad_involves"
                                                                    label="Does Project Involve Road Grading that will modify elevations?"
                                                                    fullWidth
                                                                    options={[
                                                                        { label: "Yes", value: "Yes" },
                                                                        { label: "No", value: "No" },
                                                                    ]}
                                                                    alignment={true}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="brroad_elev"
                                                                    label="If Project modifies road elevations, please describe proposed elevations?"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccessabilitySelect
                                                                    disabled={is_read_only}
                                                                    field="br_involves"
                                                                    label="Bridge Project involves:"
                                                                    options={MAKE_OPTIONS(["removal of existing bridge", "installation of new bridge", "modification of existing bridge"])}
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="br_ex1width"
                                                                    label="Existing bridge 1 width (max 200)"
                                                                    fullWidth
                                                                    units="feet"
                                                                    useNumberFormat3
                                                                    maxValue={200}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="br_ex1len"
                                                                    label="Existing bridge 1 length (max 5000)"
                                                                    fullWidth
                                                                    units="feet"
                                                                    useNumberFormat3
                                                                    maxValue={5000}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="br_ex1elev"
                                                                    label="Existing bridge 1 elevation (max 1500)"
                                                                    fullWidth
                                                                    units="feet"
                                                                    useNumberFormat3
                                                                    maxValue={1500}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="br_p1width"
                                                                    label="Proposed bridge 1 width (max 200)"
                                                                    fullWidth
                                                                    units="feet"
                                                                    useNumberFormat3
                                                                    maxValue={200}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="br_p1len"
                                                                    label="Proposed bridge 1 length (max 5000)"
                                                                    fullWidth
                                                                    units="feet"
                                                                    useNumberFormat3
                                                                    maxValue={5000}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="br_p1elev"
                                                                    label="Proposed bridge 1 elevation (max 1500)"
                                                                    fullWidth
                                                                    units="feet"
                                                                    useNumberFormat3
                                                                    maxValue={1500}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="br_ex2width"
                                                                    label="Existing bridge 2 width (max 200)"
                                                                    fullWidth
                                                                    units="feet"
                                                                    useNumberFormat3
                                                                    maxValue={200}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="br_ex2len"
                                                                    label="Existing bridge 2 length (max 5000)"
                                                                    fullWidth
                                                                    units="feet"
                                                                    useNumberFormat3
                                                                    maxValue={5000}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="br_ex2elev"
                                                                    label="Existing bridge 2 elevation (max 1500)"
                                                                    fullWidth
                                                                    units="feet"
                                                                    useNumberFormat3
                                                                    maxValue={1500}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="br_p2width"
                                                                    label="Proposed bridge 2 width (max 200)"
                                                                    fullWidth
                                                                    units="feet"
                                                                    useNumberFormat3
                                                                    maxValue={200}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="br_p2len"
                                                                    label="Proposed bridge 2 length (max 5000)"
                                                                    fullWidth
                                                                    units="feet"
                                                                    useNumberFormat3
                                                                    maxValue={5000}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="br_p2elev"
                                                                    label="Proposed bridge 2 elevation (max 1500)"
                                                                    fullWidth
                                                                    units="feet"
                                                                    useNumberFormat3
                                                                    maxValue={1500}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="br_info"
                                                                    label="Additional Information for Bridge Proposed Project"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid>
                                        )}

                                        {activeStep === 3 && projectType.length > 0 && projectType.find(t => t === "Wetland Restoration / Water Retention Related Structures / Water and Sediment Control Basins") && (
                                            <Grid item direction="row" justifyContent="center" alignItems="center" classes={{ root: classes.root }}>
                                                <Accordion defaultExpanded>
                                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: "#ddd" }}>
                                                        <Typography
                                                            // variant="subtitle1" 
                                                            gutterBottom
                                                            variant="h2"
                                                            style={{
                                                                // font-size: 1rem;
                                                                fontSize: 17,
                                                                // font-weight: 400;
                                                                fontWeight: 400,
                                                                // line-height: 1.75;
                                                                lineHeight: 1.75,
                                                            }}
                                                        >
                                                            Wetland Restoration / Water Retention Related Structures / Water and Sediment Control Basins
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <RadioGroup
                                                                    field="wet_proj"
                                                                    disabled={is_read_only}
                                                                    fullWidth
                                                                    options={[
                                                                        { label: "Yes", value: "Yes" },
                                                                        { label: "No", value: "No" },
                                                                    ]}
                                                                    alignment={true}
                                                                    label="Project is mitigation for another project"
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="wet_desc"
                                                                    label="If yes, describe project"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <RadioGroup
                                                                    disabled={is_read_only}
                                                                    field="wroad_involves"
                                                                    label="Does Project Involve Road Grading that will modify elevations?"
                                                                    fullWidth
                                                                    options={[
                                                                        { label: "Yes", value: "Yes" },
                                                                        { label: "No", value: "No" },
                                                                    ]}
                                                                    alignment={true}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="wroad_elev"
                                                                    label="If Project modifies road elevations, please describe proposed elevations?"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccessabilitySelect
                                                                    disabled={is_read_only}
                                                                    field="wet_dat"
                                                                    label="Datum used for plan development"
                                                                    options={MAKE_OPTIONS(["Local", "NGVD29", "NAVD88"])}
                                                                    fullWidth
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="wet_op_plan"
                                                                    label="Describe operation plan"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="wet_dname"
                                                                    label="Project Designer Name"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="wet_dphone"
                                                                    label="Project Designer Phone"
                                                                    fullWidth
                                                                    usePhoneNumberFormat
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="wet_demail"
                                                                    label="Project Designer Email"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="wet_info"
                                                                    label="Additional Information for Wetland or Water Project"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid>
                                        )}
                                        {activeStep === 3 && projectType.length > 0 && projectType.find(t => t === "Road Grading") && (
                                            <Grid item direction="row" justifyContent="center" alignItems="center" classes={{ root: classes.root }}>
                                                <Accordion defaultExpanded>
                                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: "#ddd" }}>
                                                        <Typography variant="subtitle1" gutterBottom>
                                                            Road Grading
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccReactSelect
                                                                    label="Road Grading project involves:"
                                                                    field="road_involves"
                                                                    options={MAKE_OPTIONS([
                                                                        "Roadway elevations will be modified", "Project involves removal / installation or modification of culverts",
                                                                        "Project involves removal / installation or modification of bridge",
                                                                        "Project involves wetland restoration / water retention structures or water and sediment control basins"
                                                                    ])}
                                                                    disabled={is_read_only}
                                                                    isMulti={true}
                                                                    height="auto"
                                                                    fullWidth
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="road_info"
                                                                    label="Additional Information for Road Grading project"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid>
                                        )}
                                        {activeStep === 3 && projectType.length > 0 && projectType.find(t => t === "Dike / Levee") && (
                                            <Grid item direction="row" justifyContent="center" alignItems="center" classes={{ root: classes.root }}>
                                                <Accordion defaultExpanded>
                                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: "#ddd" }}>
                                                        <Typography
                                                            // variant="subtitle1" 
                                                            gutterBottom
                                                            variant="h2"
                                                            style={{
                                                                // font-size: 1rem;
                                                                fontSize: 17,
                                                                // font-weight: 400;
                                                                fontWeight: 400,
                                                                // line-height: 1.75;
                                                                lineHeight: 1.75,
                                                            }}
                                                        >
                                                            Dike / Levee
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccessabilitySelect
                                                                    disabled={is_read_only}
                                                                    field="dike_involves"
                                                                    label="Dike / Levee Project Involves:"
                                                                    options={MAKE_OPTIONS(["New Dike", "Modification of Existing Dike"])}
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <RadioGroup
                                                                    field="dike_includes"
                                                                    disabled={is_read_only}
                                                                    fullWidth
                                                                    options={[
                                                                        { label: "Yes", value: "Yes" },
                                                                        { label: "No", value: "No" },
                                                                    ]}
                                                                    alignment={true}
                                                                    label="Project includes construction of ring dike"
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccessabilitySelect
                                                                    disabled={is_read_only}
                                                                    field="dike_ring"
                                                                    label="Ring dike will tie into:"
                                                                    options={MAKE_OPTIONS(["Dike", "Roadway", "High Ground", "Other"])}
                                                                    fullWidth
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="dike_other"
                                                                    label="If Other, please describe:"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="dike_purpose"
                                                                    label="Describe purpose of proposed dike/levee"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="dike_elevation"
                                                                    label="Describe how elevation of dike was determined"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccessabilitySelect
                                                                    disabled={is_read_only}
                                                                    field="dike_datum"
                                                                    label="Datum used for plan development"
                                                                    options={MAKE_OPTIONS(["Local", "NGVD29", "NAVD88"])}
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="dike_len"
                                                                    label="Dike Length (max 20000)"
                                                                    fullWidth
                                                                    units="feet"
                                                                    useNumberFormat3
                                                                    maxValue={20000}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="dike_twidth"
                                                                    label="Top Width (max 50)"
                                                                    fullWidth
                                                                    units="feet"
                                                                    useNumberFormat3
                                                                    maxValue={50}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="dike_slopeint"
                                                                    label="Side Slopes Interior"
                                                                    fullWidth
                                                                    units="H:1V"
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="dike_slopeext"
                                                                    label="Side Slopes Exterior"
                                                                    fullWidth
                                                                    units="H:1V"
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="dike_maxheight"
                                                                    label="Maximum height"
                                                                    fullWidth
                                                                    units="feet tall"
                                                                    useNumberFormat3
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="dike_maxelev"
                                                                    label="Maximum Elevation"
                                                                    fullWidth
                                                                    units="feet msl"
                                                                    useNumberFormat3
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="dike_minheight"
                                                                    label="Minimum height"
                                                                    fullWidth
                                                                    units="feet tall"
                                                                    useNumberFormat3
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="dike_minelev"
                                                                    label="Minimum elevation"
                                                                    fullWidth
                                                                    units="feet msl"
                                                                    useNumberFormat3
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <RadioGroup
                                                                    field="dike_affect"
                                                                    disabled={is_read_only}
                                                                    fullWidth
                                                                    options={[
                                                                        { label: "Yes", value: "Yes" },
                                                                        { label: "No", value: "No" },
                                                                    ]}
                                                                    alignment={true}
                                                                    label="Dike will flood or adversely affect adjacent, upstream, or downstream landowners"
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="dike_impact"
                                                                    label="If yes, describe how impacts will be addressed"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="dike_info"
                                                                    label="Additional Information for Dike / Levee project"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid>
                                        )}
                                        {activeStep === 3 && projectType.length > 0 && projectType.find(t => t === "Channel Stabilization / Restoration / Erosion Control / Shoreland Projects") && (
                                            <Grid item direction="row" justifyContent="center" alignItems="center" classes={{ root: classes.root }}>
                                                <Accordion defaultExpanded>
                                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: "#ddd" }}>
                                                        <Typography
                                                            // variant="subtitle1" 
                                                            gutterBottom
                                                            variant="h2"
                                                            style={{
                                                                // font-size: 1rem;
                                                                fontSize: 17,
                                                                // font-weight: 400;
                                                                fontWeight: 400,
                                                                // line-height: 1.75;
                                                                lineHeight: 1.75,
                                                            }}
                                                        >
                                                            Channel Stabilization / Restoration / Erosion Control / Shoreland Projects
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccReactSelect
                                                                    label="Channel Stabilization / Restoration / Erosion Control / Shoreland Project Involves:"
                                                                    field="ch_involves"
                                                                    options={MAKE_OPTIONS([
                                                                        "Project includes channel or streambank stabilization",
                                                                        "Project includes river or stream restoration",
                                                                        "Project lake shore stabilization"
                                                                    ])}
                                                                    disabled={is_read_only}
                                                                    isMulti={true}
                                                                    height="auto"
                                                                    fullWidth
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="ch_info"
                                                                    label="Additional Information for Channel Stabilization / Restoration / Erosion Control / Shoreland Project"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid>
                                        )}

                                        {activeStep === 3 && projectType.length > 0 && projectType.find(t => t === "Land Development") && (
                                            <Grid item direction="row" justifyContent="center" alignItems="center" classes={{ root: classes.root }}>
                                                <Accordion defaultExpanded>
                                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: "#ddd" }}>
                                                        <Typography
                                                            // variant="subtitle1" 
                                                            gutterBottom
                                                            variant="h2"
                                                            style={{
                                                                // font-size: 1rem;
                                                                fontSize: 17,
                                                                // font-weight: 400;
                                                                fontWeight: 400,
                                                                // line-height: 1.75;
                                                                lineHeight: 1.75,
                                                            }}
                                                        >
                                                            Land Development
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="l_prjacres"
                                                                    label="Acres of project site:"
                                                                    fullWidth
                                                                    units="acres"
                                                                    useNumberFormat3
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="l_distacres"
                                                                    label="Acres of land disturbance"
                                                                    fullWidth
                                                                    units="acres"
                                                                    useNumberFormat3
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <RadioGroup
                                                                    field="l_stormsewer"
                                                                    disabled={is_read_only}
                                                                    fullWidth
                                                                    options={[
                                                                        { label: "Yes", value: "Yes" },
                                                                        { label: "No", value: "No" },
                                                                    ]}
                                                                    alignment={true}
                                                                    label="Project is a municipal storm sewer project"
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <RadioGroup
                                                                    field="l_sansewer"
                                                                    disabled={is_read_only}
                                                                    fullWidth
                                                                    options={[
                                                                        { label: "Yes", value: "Yes" },
                                                                        { label: "No", value: "No" },
                                                                    ]}
                                                                    alignment={true}
                                                                    label="Project is a municipal sanitary sewer or lagoon project"
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <RadioGroup
                                                                    field="l_runoff"
                                                                    disabled={is_read_only}
                                                                    fullWidth
                                                                    options={[
                                                                        { label: "Yes", value: "Yes" },
                                                                        { label: "No", value: "No" },
                                                                    ]}
                                                                    alignment={true}
                                                                    label="Project design incorporates stormwater ponding or other runoff reduction methods"
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="l_explain"
                                                                    label="If not yes, explain why:"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="l_info"
                                                                    label="Additional Information for Land Development Project"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid>
                                        )}
                                        {activeStep === 3 && projectType.length > 0 && projectType.find(t => t === "Utility Installations") && (
                                            <Grid item direction="row" justifyContent="center" alignItems="center" classes={{ root: classes.root }}>
                                                <Accordion defaultExpanded>
                                                    <AccordionSummary expandIcon={<ExpandMoreIcon />} style={{ backgroundColor: "#ddd" }}>
                                                        <Typography
                                                            // variant="subtitle1" 
                                                            gutterBottom
                                                            variant="h2"
                                                            style={{
                                                                // font-size: 1rem;
                                                                fontSize: 17,
                                                                // font-weight: 400;
                                                                fontWeight: 400,
                                                                // line-height: 1.75;
                                                                lineHeight: 1.75,
                                                            }}
                                                        >
                                                            Utility Installation
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <RadioGroup
                                                                    field="u_buried"
                                                                    disabled={is_read_only}
                                                                    fullWidth
                                                                    options={[
                                                                        { label: "Yes", value: "Yes" },
                                                                        { label: "No", value: "No" },
                                                                    ]}
                                                                    alignment={true}
                                                                    label="Utility is buried"
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="u_selected"
                                                                    label="If yes, what is depth of cover over top of utility? (minimum depth is 48 inches below waterways and ditches)"
                                                                    fullWidth
                                                                    units="inches"
                                                                    useNumberFormat3
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6} xl={4}>
                                                                <AccTextField
                                                                    disabled={is_read_only}
                                                                    field="u_info"
                                                                    label="Additional Information for Utility Installation Project"
                                                                    fullWidth
                                                                />
                                                            </Grid>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid>
                                        )}

                                        {activeStep === "PRINT" && (
                                            <Grid item xs={12} xl={10} classes={{ root: classes.root }}>
                                                <Divider className={classes.printDivider} />
                                            </Grid>
                                        )}
                                        {activeStep === 4 && (
                                            <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                <Typography
                                                    // variant="subtitle1"
                                                    variant="h2"
                                                    style={{
                                                        // font-size: 1rem;
                                                        fontSize: 17,
                                                        // font-weight: 400;
                                                        fontWeight: 400,
                                                        // line-height: 1.75;
                                                        lineHeight: 1.75,
                                                    }}
                                                >
                                                    Attachments
                                                </Typography>
                                                <Typography gutterBottom>

                                                    Please attached all electronic files associated with your applications. If document is not available for upload,
                                                    it shall be emailed to the BRRWD at <a
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        href='mailto:permits@brrwd.org'>
                                                        permits@brrwd.org
                                                    </a>{" "}. Application will not be reviewed or considered complete until appropriate documents have been submitted.
                                                    Below is the list of expected documents and the information those documents should contain
                                                </Typography>
                                                <Button
                                                    onClick={() =>
                                                        this.setState({
                                                            attachmentDialogOpen: true,
                                                            attachmentEditing: null,
                                                            attachmentFormKey: window.performance.now(),
                                                        })
                                                    }
                                                    disabled={is_read_only}
                                                    variant="contained"
                                                    // color="primary"
                                                    className={classes.buttonClass}
                                                >
                                                    Add Attachment
                                                </Button>
                                                <Table style={{ marginTop: 8 }}>
                                                    <caption
                                                        className={classes.visuallyHidden}
                                                        style={{ color: "black" }}
                                                    >
                                                        Attachments table
                                                    </caption>
                                                    <AccessabilityEnhancedTableHead
                                                        columnData={columnDataAttachments}
                                                        order={attachmentOrder}
                                                        orderBy={attachmentOrderBy}
                                                        onRequestSort={this.handleRequestSort2}
                                                    />
                                                    <TableBody>
                                                        {temp_attachments.map((n, idx) => {
                                                            return (
                                                                <TableRow key={idx} hover>
                                                                    <CustomTableCell className={classes.nowrap}>
                                                                        {n.file.includes("https") && (
                                                                            <Tooltip title="Open Link">
                                                                                <Button
                                                                                    color="primary"
                                                                                    onClick={() => {
                                                                                        window.open(n.file);
                                                                                    }}
                                                                                    className={classes.deleteWidth}>
                                                                                    <ViewIcon color="primary" />
                                                                                </Button>
                                                                            </Tooltip>
                                                                        )}
                                                                        <Tooltip title="Delete">
                                                                            <Button
                                                                                color="primary"
                                                                                onClick={() =>
                                                                                    this.setState({
                                                                                        temp_attachments: temp_attachments.filter((tc) => tc !== n),
                                                                                    })
                                                                                }
                                                                                disabled={is_read_only}
                                                                                className={classes.deleteWidth}>
                                                                                <DeleteIcon color="primary" />
                                                                            </Button>
                                                                        </Tooltip>
                                                                    </CustomTableCell>
                                                                    <CustomTableCell>{n.name}</CustomTableCell>
                                                                    <CustomTableCell>{n._type}</CustomTableCell>
                                                                    <CustomTableCell>{n.notes}</CustomTableCell>
                                                                </TableRow>
                                                            );
                                                        })}
                                                        {temp_attachments.length < 1 && (
                                                            <TableRow>
                                                                <CustomTableCell colSpan={columnDataAttachments.length} className={classes.centerAlign}>
                                                                    No Attachments Added
                                                                </CustomTableCell>
                                                            </TableRow>
                                                        )}
                                                    </TableBody>
                                                </Table>
                                            </Grid>

                                        )}
                                        {activeStep === 4 && attachmentTypes.length > 0 && attachmentTypes.find(a => a.includes("Tiling")) && (
                                            <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                <Accordion expanded>
                                                    <AccordionSummary
                                                        style={{ backgroundColor: "#ddd" }}
                                                    >
                                                        <Typography variant="subtitle1" gutterBottom component="div">
                                                            <b>Tiling Documents to Upload:</b>
                                                        </Typography>
                                                    </AccordionSummary>

                                                    <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
                                                        <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                            <Typography component="ol" style={{ margin: 0, paddingLeft: 20 }}>
                                                                <li>
                                                                    <Typography variant="subtitle1" component="div" gutterBottom>
                                                                        Site Map must include: <br />
                                                                    </Typography>
                                                                    <Typography component="ol" style={{ margin: 0, paddingLeft: 24 }} type="a">
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Location of tile lines.
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Size of tile.
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Location of outlets(s).
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Location of lift station(s).
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Location of surface inlet(s).
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Location of other special features
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Receiving waters.
                                                                                <br />
                                                                            </Typography>
                                                                        </li>
                                                                    </Typography>
                                                                </li>
                                                                <li>
                                                                    <Typography
                                                                        component="div"
                                                                        // variant="subtitle1"
                                                                        gutterBottom
                                                                        variant="h2"
                                                                        style={{
                                                                            // font-size: 1rem;
                                                                            fontSize: 17,
                                                                            // font-weight: 400;
                                                                            fontWeight: 400,
                                                                            // line-height: 1.75;
                                                                            lineHeight: 1.75,
                                                                        }}
                                                                    >
                                                                        Downstream Landowner Notification, if applicable.
                                                                    </Typography>
                                                                </li>
                                                            </Typography>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid>
                                        )}
                                        {activeStep === 4 && attachmentTypes.length > 0 && attachmentTypes.find(a => a.includes("Surface")) && (
                                            <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                <Accordion expanded>
                                                    <AccordionSummary style={{ backgroundColor: "#ddd" }}>
                                                        <Typography variant="subtitle1" gutterBottom component="div">
                                                            <b>Surface Drainage (New Ditch or Improvement) Documents to Upload:</b>
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
                                                        <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                            <Typography component="ol" style={{ margin: 0, paddingLeft: 20 }}>
                                                                <li>
                                                                    <Typography variant="subtitle1" component="div" gutterBottom>
                                                                        Site Map must include:<br />
                                                                    </Typography>
                                                                    <Typography component="ol" style={{ margin: 0, paddingLeft: 24 }} type="a">
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Location of existing and proposed ditch.
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Location of spoil pile.
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Location of outlet.
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Location of other special features.
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Receiving waters.
                                                                                <br />
                                                                            </Typography>
                                                                        </li>
                                                                    </Typography>
                                                                </li>
                                                                <li>
                                                                    <Typography
                                                                        // variant="subtitle1"
                                                                        component="div"
                                                                        gutterBottom
                                                                        variant="h2"
                                                                        style={{
                                                                            // font-size: 1rem;
                                                                            fontSize: 17,
                                                                            // font-weight: 400;
                                                                            fontWeight: 400,
                                                                            // line-height: 1.75;
                                                                            lineHeight: 1.75,
                                                                        }}
                                                                    >
                                                                        Downstream Landowner Notification, if applicable.
                                                                    </Typography>
                                                                </li>
                                                            </Typography>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid>
                                        )}
                                        {activeStep === 4 && attachmentTypes.length > 0 && attachmentTypes.find(a => a.includes("Culvert")) && (
                                            <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                <Accordion expanded>
                                                    <AccordionSummary style={{ backgroundColor: "#ddd" }}>
                                                        <Typography variant="subtitle1" gutterBottom component="div">
                                                            <b>Culvert Installation Documents to Upload:</b>
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
                                                        <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                            <Typography
                                                                component="ol"
                                                                style={{ margin: 0, paddingLeft: 20 }}
                                                            >
                                                                <li>
                                                                    <Typography
                                                                        variant="subtitle1"
                                                                        component="div"
                                                                        gutterBottom
                                                                    >Site Map must include:<br />
                                                                    </Typography>
                                                                    <Typography
                                                                        component="ol"
                                                                        style={{ margin: 0, paddingLeft: 24 }}
                                                                        type="a"
                                                                    >
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Location of existing and proposed culverts .
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Size of existing and proposed culverts.
                                                                                <br />
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Location of upstream and downstream culverts and bridges.
                                                                                <br />
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Size of upstream and downstream culverts and bridges.
                                                                                <br />
                                                                            </Typography>
                                                                        </li>
                                                                    </Typography>
                                                                </li>
                                                                <li>
                                                                    <Typography
                                                                        // variant="subtitle1"
                                                                        gutterBottom
                                                                        variant="h2"
                                                                        style={{
                                                                            // font-size: 1rem;
                                                                            fontSize: 17,
                                                                            // font-weight: 400;
                                                                            fontWeight: 400,
                                                                            // line-height: 1.75;
                                                                            lineHeight: 1.75,
                                                                        }}
                                                                    >
                                                                        Downstream Landowner Notification, if applicable.
                                                                    </Typography>
                                                                </li>
                                                            </Typography>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid>
                                        )}
                                        {activeStep === 4 && attachmentTypes.length > 0 && attachmentTypes.find(a => a.includes("Bridge")) && (
                                            <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                <Accordion expanded>
                                                    <AccordionSummary style={{ backgroundColor: "#ddd" }}>
                                                        <Typography variant="subtitle1" gutterBottom component="div">
                                                            <b>Bridge Installation Documents to Upload:</b>
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
                                                        <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                            <Typography
                                                                component="ol"
                                                                style={{ margin: 0, paddingLeft: 20 }}
                                                            >
                                                                <li>
                                                                    <Typography
                                                                        component="div"
                                                                        variant="subtitle1"
                                                                        gutterBottom
                                                                    >Site Map must include:
                                                                        <br />
                                                                    </Typography>
                                                                    <Typography
                                                                        component="ol"
                                                                        style={{ margin: 0, paddingLeft: 24 }}
                                                                        type="a"
                                                                    >
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Location of existing and proposed culverts.
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Size of existing and proposed culverts.
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Location of upstream and downstream culverts and bridges.
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Size of upstream and downstream culverts and bridges.
                                                                            </Typography>
                                                                        </li>
                                                                    </Typography>
                                                                    <li>
                                                                        <Typography
                                                                            component="div"
                                                                            variant="subtitle1"
                                                                            gutterBottom
                                                                        >
                                                                            Hydraulic analysis showing existing and proposed hydraulic conditions.
                                                                        </Typography>
                                                                    </li>
                                                                    <li>
                                                                        <Typography
                                                                            component="div"
                                                                            variant="subtitle1"
                                                                            gutterBottom
                                                                        >
                                                                            Size, type, location of adjacent upstream and downstream structures.
                                                                        </Typography>
                                                                    </li>
                                                                    <li>
                                                                        <Typography
                                                                            component="div"
                                                                            variant="subtitle1"
                                                                            gutterBottom
                                                                        >
                                                                            Maximum previously observed highwater elevation at site and time frame
                                                                        </Typography>
                                                                    </li>
                                                                    <li>
                                                                        <Typography
                                                                            component="div"
                                                                            variant="subtitle1"
                                                                            gutterBottom
                                                                        >
                                                                            Detailed project construction plans with profile, cross sections, plan views, details.
                                                                        </Typography>
                                                                    </li>
                                                                </li>
                                                            </Typography>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid>
                                        )}
                                        {activeStep === 4 && attachmentTypes.length > 0 && attachmentTypes.find(a => a.includes("Wetland")) && (
                                            <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                <Accordion expanded>
                                                    <AccordionSummary style={{ backgroundColor: "#ddd" }}>
                                                        <Typography
                                                            // variant="subtitle1" 
                                                            gutterBottom
                                                            variant="h2"
                                                            style={{
                                                                // font-size: 1rem;
                                                                fontSize: 17,
                                                                // font-weight: 400;
                                                                fontWeight: 400,
                                                                // line-height: 1.75;
                                                                lineHeight: 1.75,
                                                            }}
                                                        >
                                                            <b>Wetland Restoration Documents to Upload:</b>
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
                                                        <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                            <Typography component="ol" style={{ margin: 0, paddingLeft: 20 }}>
                                                                <li>
                                                                    <Typography
                                                                        component="div"
                                                                        variant="subtitle1"
                                                                        gutterBottom
                                                                    >
                                                                        Detailed project construction plans.<br />
                                                                    </Typography>
                                                                    <li>
                                                                        <Typography
                                                                            component="div"
                                                                            variant="subtitle1"
                                                                            gutterBottom
                                                                        >
                                                                            Site Map must include:<br />
                                                                        </Typography>
                                                                    </li>
                                                                    <Typography
                                                                        component="ol"
                                                                        style={{ margin: 0, paddingLeft: 24 }}
                                                                        type="a"
                                                                    >
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Location of proposed wetland basins, water retention areas.
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Locations of ditch plugs, scrapes, embankments, other related features.
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Property lines.
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Maximum pool elevation boundaries.
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Top of structure elevation.
                                                                                <br />
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Location of proposed tile lines.
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Location of outlet structure(s).
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Location of other special features.
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                component="div"
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Receiving waters.   <br />
                                                                            </Typography>
                                                                        </li>
                                                                    </Typography>
                                                                </li>
                                                            </Typography>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid>
                                        )}
                                        {activeStep === 4 && attachmentTypes.length > 0 && attachmentTypes.find(a => a.includes("Road")) && (
                                            <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                <Accordion expanded>
                                                    <AccordionSummary style={{ backgroundColor: "#ddd" }}>
                                                        <Typography variant="subtitle1" gutterBottom component="div">
                                                            <b>Road Grading Documents to Upload:</b>
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
                                                        <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                            <Typography component="ol" style={{ margin: 0, paddingLeft: 20 }}>
                                                                <li>
                                                                    <Typography
                                                                        component="div"
                                                                        variant="subtitle1"
                                                                        gutterBottom
                                                                    >
                                                                        Site Map must include:<br />
                                                                    </Typography>
                                                                    <Typography
                                                                        component="ol"
                                                                        style={{ margin: 0, paddingLeft: 24 }}
                                                                        type="a"
                                                                    >
                                                                        <li>
                                                                            <Typography
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Location of existing and proposed ditch.
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Location of spoil pile.
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Location of outlet(s).
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Location of existing and proposed culverts and bridges.
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Size of existing and proposed culverts and brides.
                                                                                <br />
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Location of upstream and downstream culverts and bridges.
                                                                                <br />
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Size of upstream and downstream culverts and bridges.
                                                                                <br />
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Location of proposed wetland basins, water retention areas.
                                                                                <br />
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Locations of ditch plugs, scrapes, embankments, other related features.
                                                                                <br />
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Property lines.
                                                                                <br />
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Maximum pool elevation boundaries.
                                                                                <br />
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >Location of proposed tile lines.
                                                                                <br />
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Location of other special features.
                                                                                <br />
                                                                            </Typography>
                                                                        </li>
                                                                        <li>
                                                                            <Typography
                                                                                gutterBottom
                                                                                style={{ marginLeft: 9 }}
                                                                            >
                                                                                Receiving waters.
                                                                                <br />
                                                                            </Typography>
                                                                        </li>
                                                                    </Typography>
                                                                </li>
                                                                <li>
                                                                    <Typography variant="subtitle1" component="div" gutterBottom>
                                                                        <Typography
                                                                            // variant="subtitle1" 
                                                                            gutterBottom
                                                                            variant="h2"
                                                                            style={{
                                                                                // font-size: 1rem;
                                                                                fontSize: 17,
                                                                                // font-weight: 400;
                                                                                fontWeight: 400,
                                                                                // line-height: 1.75;
                                                                                lineHeight: 1.75,
                                                                            }}
                                                                        >
                                                                            Downstream Landowner Notification, if applicable.
                                                                        </Typography>
                                                                    </Typography>
                                                                </li>
                                                            </Typography>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid>
                                        )}
                                        {activeStep === 4 && attachmentTypes.length > 0 && attachmentTypes.find(a => a.includes("Dike")) && (
                                            <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                <Accordion expanded>
                                                    <AccordionSummary style={{ backgroundColor: "#ddd" }}>
                                                        <Typography variant="subtitle1" gutterBottom component="div">
                                                            <b>Dike Documents to Upload:</b>
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
                                                        <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                            <Typography component="ol" style={{ margin: 0, paddingLeft: 20 }}>
                                                                <li>
                                                                    <Typography component="div" variant="subtitle1" gutterBottom>Detailed construction plans.<br /></Typography>
                                                                    <li>
                                                                        <Typography variant="subtitle1" component="div" gutterBottom>
                                                                            <Typography component="div" variant="subtitle1" gutterBottom>Site Map must include:<br /></Typography>
                                                                        </Typography>
                                                                    </li>
                                                                    <Typography component="ol" style={{ margin: 0, paddingLeft: 24 }} type="a">
                                                                        <li><Typography component="div" gutterBottom style={{ marginLeft: 9 }}>Location of proposed dike.</Typography></li>
                                                                        <li><Typography component="div" gutterBottom style={{ marginLeft: 9 }}>Elevation of proposed dike.</Typography></li>
                                                                        <li><Typography component="div" gutterBottom style={{ marginLeft: 9 }}>Location of other special features.</Typography></li>
                                                                    </Typography>
                                                                </li>
                                                            </Typography>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid>
                                        )}
                                        {activeStep === 4 && attachmentTypes.length > 0 && attachmentTypes.find(a => a.includes("Channel")) && (
                                            <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                <Accordion expanded>
                                                    <AccordionSummary style={{ backgroundColor: "#ddd" }} component="div">
                                                        <Typography variant="subtitle1" gutterBottom component="div">
                                                            <b>Channel Stabilization Documents to Upload:</b>
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
                                                        <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                            <Typography component="ol" style={{ margin: 0, paddingLeft: 20 }}>
                                                                <li>
                                                                    <Typography component="div" variant="subtitle1" gutterBottom>Detailed project plans.<br /></Typography>
                                                                    <li><Typography component="div" variant="subtitle1" gutterBottom>Site Map, must include:<br /></Typography></li>
                                                                    <Typography component="ol" style={{ margin: 0, paddingLeft: 20 }}>
                                                                        <li><Typography component="div" gutterBottom style={{ marginLeft: 9 }}>Location of proposed work.</Typography></li>
                                                                        <li><Typography component="div" gutterBottom style={{ marginLeft: 9 }}>Location of other special features.</Typography></li>
                                                                    </Typography>
                                                                </li>
                                                            </Typography>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid>
                                        )}
                                        {activeStep === 4 && attachmentTypes.length > 0 && attachmentTypes.find(a => a.includes("Land Dev")) && (
                                            <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }} >
                                                <Accordion expanded>
                                                    <AccordionSummary style={{ backgroundColor: "#ddd" }}>
                                                        <Typography variant="subtitle1" gutterBottom component="div">
                                                            <b>Land Documents to Upload:</b>
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
                                                        <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                            <Typography component="ol" style={{ margin: 0, paddingLeft: 20 }}>
                                                                <li>
                                                                    <Typography component="div" variant="subtitle1" gutterBottom>Detailed construction plans.<br /></Typography>
                                                                    <li><Typography component="div" variant="subtitle1" gutterBottom>Site Map, must include:<br /></Typography></li>
                                                                    <Typography component="ol" style={{ margin: 0, paddingLeft: 24 }} type="a">
                                                                        <li><Typography component="div" gutterBottom style={{ marginLeft: 9 }}>Location of proposed work.</Typography></li>
                                                                        <li><Typography component="div" gutterBottom style={{ marginLeft: 9 }}>Location of other special features.</Typography></li>
                                                                        <li><Typography component="div" gutterBottom style={{ marginLeft: 9 }}>Receiving waters.</Typography></li>
                                                                    </Typography>
                                                                    <li><Typography component="div" variant="subtitle1" gutterBottom>Stormwater Report showing modeling results of pond design.<br /></Typography></li>
                                                                    <li><Typography component="div" variant="subtitle1" gutterBottom>Stormwater Pollution Prevention Plan (SWPPP).<br /></Typography></li>
                                                                </li>
                                                            </Typography>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid>
                                        )}
                                        {activeStep === 4 && attachmentTypes.length > 0 && attachmentTypes.find(a => a.includes("Stormwater")) && (
                                            <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                <Accordion expanded>
                                                    <AccordionSummary style={{ backgroundColor: "#ddd" }}>
                                                        <Typography variant="subtitle1" gutterBottom component="div">
                                                            <b>Stormwater Documents to Upload:</b>
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
                                                        <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                            <Typography component="ol" style={{ margin: 0, paddingLeft: 20 }}>
                                                                <li>
                                                                    <Typography component="div" variant="subtitle1" gutterBottom>Site Map must include:<br /></Typography>
                                                                    <Typography component="ol" style={{ margin: 0, paddingLeft: 24 }} type="a">
                                                                        <li><Typography component="div" gutterBottom style={{ marginLeft: 9 }}>Location of existing and proposed ditch.</Typography></li>
                                                                        <li><Typography component="div" gutterBottom style={{ marginLeft: 9 }}>Location of spoil pile.</Typography></li>
                                                                        <li><Typography component="div" gutterBottom style={{ marginLeft: 9 }}>Location of outlet.</Typography></li>
                                                                        <li><Typography component="div" gutterBottom style={{ marginLeft: 9 }}>Location of other special features.</Typography></li>
                                                                        <li><Typography component="div" gutterBottom style={{ marginLeft: 9 }}>Receiving waters.     <br /></Typography></li>
                                                                    </Typography>
                                                                    <li>
                                                                        <Typography
                                                                            component="div"
                                                                            // variant="subtitle1" 
                                                                            gutterBottom
                                                                            variant="h2"
                                                                            style={{
                                                                                // font-size: 1rem;
                                                                                fontSize: 17,
                                                                                // font-weight: 400;
                                                                                fontWeight: 400,
                                                                                // line-height: 1.75;
                                                                                lineHeight: 1.75,
                                                                            }}
                                                                        >
                                                                            Downstream Landowner Notification, if applicable.
                                                                        </Typography>
                                                                    </li>
                                                                </li>
                                                            </Typography>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid>
                                        )}
                                        {activeStep === 4 && attachmentTypes.length > 0 && attachmentTypes.find(a => a.includes("Utility")) && (
                                            <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                <Accordion expanded>
                                                    <AccordionSummary style={{ backgroundColor: "#ddd" }}>
                                                        <Typography variant="subtitle1" gutterBottom component="div">
                                                            <b>Utility Documents to Upload:</b>
                                                        </Typography>
                                                    </AccordionSummary>
                                                    <AccordionDetails style={{ paddingBottom: 8, backgroundColor: "f6f0f0" }}>
                                                        <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                            <Typography component="ol" style={{ margin: 0, paddingLeft: 20 }}>
                                                                <li>
                                                                    <Typography component="div" variant="subtitle1" gutterBottom>Detailed project plans.<br /></Typography>
                                                                    <li><Typography component="div" variant="subtitle1" gutterBottom>Site Map, must include:<br /></Typography></li>
                                                                    <Typography component="ol" style={{ margin: 0, paddingLeft: 24 }} type="a">
                                                                        <li><Typography component="div" gutterBottom style={{ marginLeft: 9 }}>Location of proposed work.</Typography></li>
                                                                        <li><Typography component="div" gutterBottom style={{ marginLeft: 9 }}>Location of other special features.</Typography></li>
                                                                    </Typography>
                                                                </li>
                                                            </Typography>
                                                        </Grid>
                                                    </AccordionDetails>
                                                </Accordion>
                                            </Grid>
                                        )}
                                        {activeStep === "PRINT" && (
                                            <Grid item xs={12} xl={10} classes={{ root: classes.root }}>
                                                <Divider className={classes.printDivider} />
                                            </Grid>
                                        )}
                                        {activeStep === 5 && (
                                            <Grid item xs={12} xl={10} style={{ marginLeft: 15 }} classes={{ root: classes.root }}>
                                                <Typography
                                                    // variant="subtitle1" 
                                                    gutterBottom
                                                    variant="h2"
                                                    style={{
                                                        // font-size: 1rem;
                                                        fontSize: 17,
                                                        // font-weight: 400;
                                                        fontWeight: 400,
                                                        // line-height: 1.75;
                                                        lineHeight: 1.75,
                                                    }}
                                                >
                                                    <b>I understand:</b>
                                                </Typography>
                                                <ol style={{ paddingLeft: 20, marginTop: 0 }}>
                                                    {" "}
                                                    <li>
                                                        <Typography gutterBottom style={{ marginBottom: 3, marginLeft: 3 }}>
                                                            Submitting this application in no way relieves the applicant or landowner from any
                                                            responsibility or liability resulting from the construction, operation, or failure of the project.
                                                        </Typography>
                                                    </li>
                                                    <li>
                                                        <Typography gutterBottom style={{ marginBottom: 3, marginLeft: 3 }}>
                                                            The project may be field reviewed prior to the Board Meeting.
                                                            The applicant grants permission to the BRRWD and their representatives to review the work area within the permit application.
                                                        </Typography>
                                                    </li>
                                                    <li>
                                                        <Typography gutterBottom style={{ marginBottom: 3, marginLeft: 3 }}>
                                                            The application must be considered complete a minimum of 10 days prior to the Regular Board
                                                            Meeting to be considered. BRRWD staff will contact you within 15 days if additional information is required.
                                                        </Typography>
                                                    </li>
                                                    <li>
                                                        <Typography gutterBottom style={{ marginBottom: 3, marginLeft: 3 }}>
                                                            The requirements of the Permit Rules of the BRRWD. (A copy of the rules can be found at brrwd.org).
                                                        </Typography>
                                                    </li>
                                                    <li>
                                                        <Typography gutterBottom style={{ marginBottom: 3, marginLeft: 3 }}>
                                                            This permit does not relieve the applicant of any requirements of other permits which may be necessary
                                                            from any other permitting agency.
                                                        </Typography>
                                                    </li>
                                                    <li>
                                                        <Typography gutterBottom style={{ marginBottom: 3, marginLeft: 3 }}>
                                                            I acknowledge by submitting this permit application is equivalent to my manual/handwritten signature.
                                                        </Typography>
                                                    </li>
                                                </ol>


                                                <div
                                                    style={{
                                                        whiteSpace: "nowrap",
                                                        paddingRight: 16
                                                    }}
                                                >
                                                    <AccCheckbox
                                                        disabled={is_read_only}
                                                        label="I AGREE *"
                                                        field="understand1"
                                                    />

                                                    <Typography gutterBottom style={{ marginBottom: 0 }}>
                                                        In checking this box, I acknowledge the above statements.
                                                    </Typography>
                                                </div>


                                            </Grid>
                                        )}
                                        {activeStep !== "PRINT" && (
                                            <Grid
                                                item
                                                xs={12}
                                                xl={10}
                                                className={classes.rightAlign}
                                                classes={{ root: classes.root }}
                                            >

                                                <Button
                                                    disabled={activeStep === 0}
                                                    onClick={() => this.setState({ activeStep: activeStep - 1 })}
                                                    className={classes.backbuttonClass}
                                                >
                                                    Back
                                                </Button>


                                                <Button
                                                    onClick={() => this.handleNext()}
                                                    disabled={is_read_only && activeStep === 5}
                                                    variant="contained"
                                                    // color="primary"
                                                    className={classes.buttonClass}
                                                    style={{
                                                        marginLeft: 16,
                                                    }}
                                                >
                                                    {activeStep === 5 ? "Submit Permit Application" : "Next"}
                                                </Button>

                                                {/* <Button
                                                style={{ marginLeft: 16 }}
                                                onClick={() => {
                                                    return (
                                                        // this.setState({ activeStep: "PRINT" }),
                                                        window.open("/reports/application/" + application.hash)
                                                    );
                                                }}
                                                variant="contained"
                                                color="primary">
                                                Print
                                            </Button> */}
                                            </Grid>
                                        )}
                                    </Grid>
                                </>
                            </form>
                        )}
                    </Form>
                    <Dialog open={attachmentDialogOpen} classes={{ paper: classes.minWidth, overflowX: "none" }}>
                        <Toolbar>
                            <Typography
                                // variant="h6" 
                                className={classes.flex}
                                variant="h1"
                                style={{
                                    // font-size: 1rem;
                                    fontSize: 24,
                                    // font-weight: 400;
                                    fontWeight: 400,
                                    // line-height: 1.75;
                                    lineHeight: 1.75,
                                }}
                            >
                                Attachment
                            </Typography>
                            <IconButton aria-label="Close Dialog" onClick={() => this.setState({ attachmentDialogOpen: false })}>
                                <Close />
                            </IconButton>
                        </Toolbar>
                        <DialogContent
                            className={classes.dialogMin + " " + classes.modalStyle}
                        >
                            <DialogContentText>
                                <Form
                                    dontValidateOnMount={true}
                                    validateOnSubmit={true}
                                    key={attachmentFormKey}
                                    defaultValues={attachmentEditing}
                                    validateError={this.errorValidatorAttachment}
                                    onSubmit={(values) => this.addAttachment(values)}
                                >
                                    {(formApi) => (
                                        <form onSubmit={formApi.submitForm}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} md={12} xl={12}>
                                                    <Typography gutterBottom>
                                                        Only these file types can be directly uploaded as an attachment. All other file types should be
                                                        put into a .zip file and then uploaded. Direct supported file types are: PDF (.pdf), Microsoft
                                                        Word (.doc, .docx), Microsoft Excel (.xls, .xlsx), Images (.png, .jpg, .jpeg, .tiff, .bmp),
                                                        Microsoft Powerpoint (.ppt, .pptx), Zip files (.zip).
                                                    </Typography>

                                                </Grid>
                                                <Grid item xs={12} md={12} xl={12}>
                                                    <AccFileInput
                                                        field="file"
                                                        id="file_upl"
                                                        fullWidth
                                                        label="File *"
                                                        sx={{
                                                            width: '100%',
                                                        }}
                                                    />
                                                </Grid>


                                                <Grid item xs={12} md={12} xl={12}>
                                                    <AccTextField
                                                        field="name"
                                                        label="Name *"
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={12} xl={12}>
                                                    <AccessabilitySelect
                                                        field="_type"
                                                        label="Type"
                                                        options={MAKE_OPTIONS(["Site Map", "Downstream Landownder Notification", "Engineer's Report", "Detailed Construction Plans",
                                                            "Stormwater Report Showing MOdeling Results of Pond Design", "Stormwater Pollution Prevention Plan (SWPPP)", "Detailed Project Plans",
                                                            "Photo", "Other"])}
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={12} xl={12}>
                                                    <AccTextField
                                                        field="notes"
                                                        label="Notes"
                                                        fullWidth
                                                    />
                                                </Grid>
                                            </Grid>



                                            <br />
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} md={6} xl={6}>
                                                    <Button fullWidth onClick={() => this.setState({ attachmentDialogOpen: false })}>
                                                        Cancel
                                                    </Button>
                                                </Grid>
                                                <Grid item xs={12} md={6} xl={6}>
                                                    <Button
                                                        fullWidth
                                                        type="submit"
                                                        variant="contained"
                                                        // color="primary"
                                                        className={classes.buttonClass}
                                                    >
                                                        Save
                                                    </Button>
                                                </Grid>
                                            </Grid>

                                        </form>
                                    )}
                                </Form>
                            </DialogContentText>
                        </DialogContent>
                    </Dialog>
                    <Dialog open={culvertDialogOpen} classes={{ paper: classes.minWidth }}>
                        <Toolbar>
                            <Typography
                                // variant="h6"
                                className={classes.flex}
                                variant="h1"
                                style={{
                                    // font-size: 1rem;
                                    fontSize: 24,
                                    // font-weight: 400;
                                    fontWeight: 400,
                                    // line-height: 1.75;
                                    lineHeight: 1.75,
                                }}
                            >
                                Add Culvert
                            </Typography>


                            <IconButton aria-label="Close Dialog" onClick={() => this.setState({ culvertDialogOpen: false })}>
                                <Close />
                            </IconButton>
                        </Toolbar>
                        <Toolbar>
                            <Typography
                                variant="h7"
                                className={classes.flex}
                                style={{ marginTop: -10 }}
                            >
                                Note: If existing culvert is arch pipe or box culvert please include dimensions in Additional Information.
                            </Typography>
                        </Toolbar>
                        <DialogContent
                            className={classes.dialogMin + " " + classes.modalStyle}
                        >
                            <DialogContentText>
                                <Form
                                    dontValidateOnMount={true}
                                    validateOnSubmit={true}
                                    key={formKey}
                                    defaultValues={culvertEditing}
                                    validateError={this.errorValidatorCulvert}
                                    onSubmit={(values) => this.addCulvert(values)}
                                >
                                    {(formApi) => (
                                        <form onSubmit={formApi.submitForm}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} md={6} xl={6}>
                                                    <AccTextField
                                                        disabled={is_read_only}
                                                        field="name"
                                                        label="Culvert Name or ID"
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6} xl={6}>
                                                    <AccTextField
                                                        disabled={is_read_only}
                                                        field="e_size"
                                                        label="Existing culvert size"
                                                        fullWidth
                                                        units="inches"
                                                        useNumberFormat3
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6} xl={6}>
                                                    <AccTextField
                                                        disabled={is_read_only}
                                                        field="e_length"
                                                        label="Existing culvert length"
                                                        fullWidth
                                                        units="feet"
                                                        useNumberFormat3
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6} xl={6}>
                                                    <AccTextField
                                                        disabled={is_read_only}
                                                        field="e_elevation"
                                                        label="Existing culvert elevation"
                                                        fullWidth
                                                        units="feet"
                                                        useNumberFormat3
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6} xl={6}>
                                                    <AccTextField
                                                        disabled={is_read_only}
                                                        field="p_size"
                                                        label="Proposed culvert size"
                                                        fullWidth
                                                        units="inches"
                                                        useNumberFormat3
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6} xl={6}>
                                                    <AccTextField
                                                        disabled={is_read_only}
                                                        field="p_length"
                                                        label="Proposed culvert length"
                                                        fullWidth
                                                        units="feet"
                                                        useNumberFormat3
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6} xl={6}>
                                                    <AccTextField
                                                        disabled={is_read_only}
                                                        field="p_elevation"
                                                        label="Proposed culvert elevation"
                                                        fullWidth
                                                        units="feet"
                                                        useNumberFormat3
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6} xl={6}>
                                                    <AccTextField
                                                        disabled={is_read_only}
                                                        field="additional"
                                                        label="Additional information about culvert"
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6} xl={6}>
                                                    <RadioGroup
                                                        disabled={is_read_only}
                                                        field="cul_road_involves"
                                                        label="Does Project Involve Road Grading that will modify elevations?"
                                                        fullWidth
                                                        options={[
                                                            { label: "Yes", value: "Yes" },
                                                            { label: "No", value: "No" },
                                                        ]}
                                                        alignment={true}
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6} xl={6}>
                                                    <AccTextField
                                                        disabled={is_read_only}
                                                        field="cul_road_elev"
                                                        label="If Project modifies road elevations, please describe proposed elevations?"
                                                        fullWidth
                                                    />
                                                </Grid>
                                            </Grid>

                                            {/* <Grid item xs={6} /> */}
                                            {/* <Grid item xs={6} /> */}
                                            <br />
                                            <Grid
                                                container
                                                spacing={2}
                                                className={classes.modalStyle}
                                                sx={{
                                                    marginTop: 10
                                                }}
                                            >
                                                <Grid item xs={12} md={6} xl={4}>
                                                    <Button
                                                        fullWidth
                                                        onClick={() => this.setState({ culvertDialogOpen: false })}
                                                    >
                                                        Cancel
                                                    </Button>
                                                </Grid>
                                                <Grid item xs={12} md={6} xl={4}>
                                                    <Button
                                                        disabled={is_read_only}
                                                        fullWidth
                                                        type="submit"
                                                        variant="contained"
                                                        // color="primary"
                                                        className={classes.buttonClass}
                                                    >
                                                        Save
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </form>
                                    )}
                                </Form>
                            </DialogContentText>
                        </DialogContent>
                    </Dialog>
                </main>
            </AppContainerApplication >
        );
    }
}

BRRWD = connect(
    (state, ownProps) => ({
        authState: state.auth, // Admins will have an authstate
    }),
    {
        ...ApplicationRecord.actions,
        ...ApplicationRecordStatus.actions,
        ...BRRWDPermit.actions,
        ...BRRWDCulvert.actions,
        ...BRRWDAttachment.actions
    }
)(BRRWD);

const withMediaQuery = (...args) => Component => props => {
    const mediaQuery = useMediaQuery(...args);
    return <Component mediaQuery={mediaQuery} {...props} />;
};

export default withStyles(styles)(withMediaQuery('(min-width:960px)')(withRouter(BRRWD)));
